import { useState, useEffect } from "react";

const SUPABASE_URL = "https://umkhcbfbhdakzlmsdgyo.supabase.co";
const SUPABASE_ANON_KEY = "sb_publishable_qjnOyNbjNzx7xkFhr7cUeg_TpUfmuDd";
const SHARED_PASSWORD = "GVM2024!";

const TEAM = [
  { name: "Alex Giampietro",  key: "alex",     color: "#f9a8d4", textColor: "#831843" },
  { name: "Jordin Gutierrez", key: "jordin",   color: "#d8b4fe", textColor: "#4c1d95" },
  { name: "Madison Rhodes",   key: "madison",  color: "#99f6e4", textColor: "#134e4a" },
  { name: "Patricia Diaz",    key: "patricia", color: "#fed7aa", textColor: "#7c2d12" },
];

const STATUS_OPTS = ["Trailing", "Received", "N/A"];
const COND_STATUS_OPTS = ["Requested", "Received"];
const STATUS_COLORS = {
  Trailing:  { bg: "#fef3c7", text: "#92400e", border: "#fcd34d" },
  Received:  { bg: "#d1fae5", text: "#065f46", border: "#6ee7b7" },
  "N/A":     { bg: "#f1f5f9", text: "#475569", border: "#cbd5e1" },
  Requested: { bg: "#dbeafe", text: "#1e40af", border: "#93c5fd" },
  Yes:       { bg: "#d1fae5", text: "#065f46", border: "#6ee7b7" },
  No:        { bg: "#fee2e2", text: "#991b1b", border: "#fca5a5" },
};

const INITIAL_NEEDS = [
  { header: "INCOME", items: ["Last 30 days paystubs","Last 2 years W2s / 1099s / K1s","Last 2 years Federal Tax Returns","YTD Profit and Loss Statement","Employment Contract","Award Letters"] },
  { header: "ASSETS", items: ["Last 2 months bank statements (all pages)","Last 2 months (or quarterly) retirement account statement","Gift Letter"] },
  { header: "REAL ESTATE OWNED", items: ["Latest Mortgage Statement for all properties","Property Tax Statement for all properties","Homeowner Insurance for all properties","HOA Statement on all properties","Lease Agreements for all properties","CD or Settlement Statement for all property sales in the last 90 days"] },
  { header: "CREDIT", items: ["Inquiry LOE","Credit LOE","Address LOE"] },
  { header: "MISC", items: ["Contract with all addendums","Floor Plans","USDA Household Income Disclosure","DD-214","Payoff / VOM","Government-Issued Photo ID"] },
];

function buildDefaultNeedsStatus() {
  const out = {};
  INITIAL_NEEDS.forEach((s) => s.items.forEach((item) => { out[item] = { status: "", checked: false, note: "" }; }));
  return out;
}

function todayStr() {
  // Force local date in Arizona timezone (MST/no DST)
  const d = new Date();
  const offset = d.getTimezoneOffset();
  const local = new Date(d.getTime() - offset * 60000);
  const s = local.toISOString().split("T")[0];
  return s;
}
function addDays(dateStr, n) {
  const d = new Date(dateStr + "T12:00:00");
  d.setDate(d.getDate() + n);
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
}
function getFederalHolidays(year) {
  // Fixed holidays
  const fixed = [
    `${year}-01-01`, // New Year's Day
    `${year}-06-19`, // Juneteenth
    `${year}-07-04`, // Independence Day
    `${year}-11-11`, // Veterans Day
    `${year}-12-24`, // Christmas Eve
    `${year}-12-25`, // Christmas Day
  ];
  // Calculated holidays
  const nthWeekday = (y, m, n, wd) => {
    const d = new Date(y, m - 1, 1);
    let count = 0;
    while (count < n) { if (d.getDay() === wd) count++; if (count < n) d.setDate(d.getDate() + 1); }
    return d;
  };
  const lastWeekday = (y, m, wd) => {
    const d = new Date(y, m, 0);
    while (d.getDay() !== wd) d.setDate(d.getDate() - 1);
    return d;
  };
  const fmt = d => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
  const mlk = nthWeekday(year, 1, 3, 1);
  const presidents = nthWeekday(year, 2, 3, 1);
  const memorial = lastWeekday(year, 5, 1);
  const labor = nthWeekday(year, 9, 1, 1);
  const columbus = nthWeekday(year, 10, 2, 1);
  const thanksgiving = nthWeekday(year, 11, 4, 4);
  const dayAfterThanksgiving = new Date(thanksgiving); dayAfterThanksgiving.setDate(thanksgiving.getDate() + 1);
  return new Set([...fixed, fmt(mlk), fmt(presidents), fmt(memorial), fmt(labor), fmt(columbus), fmt(thanksgiving), fmt(dayAfterThanksgiving)]);
}

function isBusinessDay(dateStr) {
  const d = new Date(dateStr + "T12:00:00");
  const day = d.getDay();
  if (day === 0 || day === 6) return false;
  const holidays = getFederalHolidays(d.getFullYear());
  return !holidays.has(dateStr);
}

function prevBusinessDay(dateStr) {
  let d = new Date(dateStr + "T12:00:00");
  d.setDate(d.getDate() - 1);
  let s = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
  while (!isBusinessDay(s)) {
    d.setDate(d.getDate() - 1);
    s = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
  }
  return s;
}

function nextBusinessDay(dateStr) {
  let d = new Date(dateStr + "T12:00:00");
  d.setDate(d.getDate() + 1);
  let s = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
  while (!isBusinessDay(s)) {
    d.setDate(d.getDate() + 1);
    s = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
  }
  return s;
}

function safeTaskDate(dateStr) {
  // Move task to Friday before if it falls on weekend or holiday
  if (isBusinessDay(dateStr)) return dateStr;
  let d = new Date(dateStr + "T12:00:00");
  d.setDate(d.getDate() - 1);
  let s = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
  while (!isBusinessDay(s)) {
    d.setDate(d.getDate() - 1);
    s = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
  }
  return s;
}
function daysDiff(dateStr) {
  const today = todayStr();
  const todayMs = new Date(today + "T12:00:00").getTime();
  const targetMs = new Date(dateStr + "T12:00:00").getTime();
  return Math.round((targetMs - todayMs) / 86400000);
}

async function sbFetch(path, options = {}) {
  const res = await fetch(`${SUPABASE_URL}/rest/v1${path}`, {
    headers: { apikey: SUPABASE_ANON_KEY, Authorization: `Bearer ${SUPABASE_ANON_KEY}`, "Content-Type": "application/json", Prefer: options.prefer || "return=representation", ...options.headers },
    ...options,
  });
  if (!res.ok) { const err = await res.text(); throw new Error(err); }
  const text = await res.text();
  return text ? JSON.parse(text) : null;
}

function parse(val, fallback) {
  if (!val) return fallback;
  if (typeof val === "string") { try { return JSON.parse(val); } catch { return fallback; } }
  return val;
}

// ── UI ATOMS ──────────────────────────────────────────────────────────────
function StatusButton({ options, value, onChange }) {
  return (
    <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
      {options.map((opt) => {
        const active = value === opt; const c = STATUS_COLORS[opt] || {};
        return <button key={opt} onClick={() => onChange(active ? "" : opt)} style={{ padding: "3px 10px", borderRadius: 6, border: `1.5px solid ${active ? c.border : "#d1d5db"}`, background: active ? c.bg : "#fff", color: active ? c.text : "#6b7280", fontWeight: active ? 700 : 400, fontSize: 12, cursor: "pointer" }}>{opt}</button>;
      })}
    </div>
  );
}

function DateField({ label, value, onChange, accent = "#1e3a5f" }) {
  const [editing, setEditing] = useState(false);
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
      {label && <span style={{ fontSize: 13, color: "#374151", fontWeight: 600, minWidth: 180 }}>{label}</span>}
      {editing || !value ? (
        <input type="date" value={value || ""} autoFocus onChange={(e) => { onChange(e.target.value); setEditing(false); }} onBlur={() => setEditing(false)}
          style={{ padding: "3px 10px", borderRadius: 6, border: `1.5px solid ${accent}`, fontSize: 13, outline: "none" }} />
      ) : (
        <span onClick={() => setEditing(true)} title="Click to change" style={{ background: accent, color: "#fff", borderRadius: 6, padding: "3px 12px", fontSize: 13, fontWeight: 700, cursor: "pointer" }}>{value} ✎</span>
      )}
      {value && !editing && <button onClick={() => onChange("")} style={{ background: "none", border: "none", color: "#9ca3af", cursor: "pointer", fontSize: 13 }}>×</button>}
    </div>
  );
}

function Section({ title, accent = "#1e3a5f", children, defaultOpen = true }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div style={{ marginBottom: 20, borderRadius: 12, border: "1.5px solid #e5e7eb", overflow: "hidden", background: "#fff", boxShadow: "0 1px 4px rgba(0,0,0,0.05)" }}>
      <div onClick={() => setOpen(o => !o)} style={{ background: accent, padding: "12px 20px", display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer" }}>
        <span style={{ color: "#fff", fontWeight: 800, fontSize: 14, letterSpacing: "0.03em" }}>{title}</span>
        <span style={{ color: "rgba(255,255,255,0.7)", fontSize: 16 }}>{open ? "▲" : "▼"}</span>
      </div>
      {open && <div style={{ padding: "16px 20px" }}>{children}</div>}
    </div>
  );
}

function FreeformList({ items, onChange, statusOptions, withNotes = false, withClientToggle = false, withCheckbox = false, defaultChecked = false, placeholder = "Add item..." }) {
  const [pasteMode, setPasteMode] = useState(false);
  const [pasteText, setPasteText] = useState("");
  const defaultStatus = statusOptions.includes("Trailing") ? "Trailing" : statusOptions[0];
  const addItem = () => onChange([...items, { id: Date.now() + Math.random(), text: "", status: defaultStatus, notes: "", sendToClient: true, checked: defaultChecked }]);
  const handlePaste = () => {
    const lines = pasteText.split("\n").map(l => l.trim()).filter(Boolean);
    onChange([...items, ...lines.map(line => ({ id: Date.now() + Math.random(), text: line, status: defaultStatus, notes: "", sendToClient: true, checked: defaultChecked }))]);
    setPasteText(""); setPasteMode(false);
  };
  const upd = (id, f, v) => onChange(items.map(i => i.id === id ? { ...i, [f]: v } : i));
  const del = (id) => onChange(items.filter(i => i.id !== id));
  return (
    <div>
      {items.map(item => (
        <div key={item.id} style={{ marginBottom: 8, background: "#f8fafc", borderRadius: 8, border: "1px solid #e5e7eb", padding: "8px 10px" }}>
          <div style={{ display: "grid", gridTemplateColumns: withCheckbox ? (withNotes ? "auto 1fr auto 1fr auto" : "auto 1fr auto auto") : (withNotes ? "1fr auto 1fr auto" : "1fr auto auto"), gap: 8, alignItems: "center" }}>
            {withCheckbox && (
              <input type="checkbox" checked={item.checked || false} onChange={e => {
                const newChecked = e.target.checked;
                const curStatus = item.status;
                const newStatus = newChecked && (!curStatus || curStatus === "N/A" || curStatus === "") ? "Trailing" : curStatus;
                onChange(items.map(i => i.id === item.id ? { ...i, checked: newChecked, status: newStatus } : i));
              }} style={{ width: 15, height: 15, cursor: "pointer", accentColor: "#1e3a5f", flexShrink: 0 }} title="Mark as requested" />
            )}
            <input value={item.text} onChange={e => upd(item.id, "text", e.target.value)} placeholder={placeholder} style={{ padding: "6px 10px", borderRadius: 6, border: "1px solid #d1d5db", fontSize: 13, outline: "none", width: "100%", boxSizing: "border-box" }} />
            <StatusButton options={statusOptions} value={item.status} onChange={v => upd(item.id, "status", v)} />
            {withNotes && <input value={item.notes} onChange={e => upd(item.id, "notes", e.target.value)} placeholder="Notes..." style={{ padding: "6px 10px", borderRadius: 6, border: "1px solid #d1d5db", fontSize: 13, outline: "none", width: "100%", boxSizing: "border-box" }} />}
            <button onClick={() => del(item.id)} style={{ background: "none", border: "none", color: "#dc2626", cursor: "pointer", fontSize: 20, padding: "0 4px" }}>×</button>
          </div>
          {withClientToggle && (
            <div style={{ marginTop: 6, display: "flex", alignItems: "center", gap: 6 }}>
              <input type="checkbox" id={`stc_${item.id}`} checked={item.sendToClient !== false} onChange={e => upd(item.id, "sendToClient", e.target.checked)} style={{ width: 13, height: 13, cursor: "pointer", accentColor: "#1e3a5f" }} />
              <label htmlFor={`stc_${item.id}`} style={{ fontSize: 11, color: "#6b7280", cursor: "pointer" }}>Include in client email</label>
            </div>
          )}
        </div>
      ))}
      {pasteMode ? (
        <div style={{ marginTop: 8 }}>
          <textarea value={pasteText} onChange={e => setPasteText(e.target.value)} placeholder="Paste your list here. Each line becomes its own row." style={{ width: "100%", height: 120, padding: "8px 12px", borderRadius: 8, border: "1.5px solid #93c5fd", fontSize: 13, outline: "none", boxSizing: "border-box", resize: "vertical" }} />
          <div style={{ display: "flex", gap: 8, marginTop: 6 }}>
            <button onClick={handlePaste} style={{ background: "#1e3a5f", color: "#fff", border: "none", borderRadius: 7, padding: "6px 16px", fontSize: 13, cursor: "pointer", fontWeight: 700 }}>Add All Items</button>
            <button onClick={() => { setPasteMode(false); setPasteText(""); }} style={{ background: "#fff", border: "1.5px solid #d1d5db", borderRadius: 7, padding: "6px 14px", fontSize: 13, cursor: "pointer" }}>Cancel</button>
          </div>
        </div>
      ) : (
        <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
          <button onClick={addItem} style={{ background: "#f0f9ff", color: "#1e40af", border: "1.5px solid #93c5fd", borderRadius: 7, padding: "6px 14px", fontSize: 13, cursor: "pointer", fontWeight: 600 }}>+ Add Item</button>
          <button onClick={() => setPasteMode(true)} style={{ background: "#f0f9ff", color: "#1e40af", border: "1.5px solid #93c5fd", borderRadius: 7, padding: "6px 14px", fontSize: 13, cursor: "pointer", fontWeight: 600 }}>Paste List</button>
        </div>
      )}
    </div>
  );
}

function NeedsItemRow({ item, statusObj, onUpdate }) {
  const status = statusObj?.status || "N/A";
  const checked = statusObj?.checked || false;
  const note = statusObj?.note || "";
  return (
    <div style={{ marginBottom: 6 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "7px 10px", borderRadius: status === "Trailing" ? "7px 7px 0 0" : 7, background: "#f8fafc", border: "1px solid #e5e7eb" }}>
        <input type="checkbox" checked={checked} onChange={e => {
          const newChecked = e.target.checked;
          const newStatus = newChecked && (!status || status === "N/A" || status === "") ? "Trailing" : status;
          onUpdate({ status: newStatus, checked: newChecked, note });
        }} style={{ width: 16, height: 16, cursor: "pointer", accentColor: "#1e3a5f", flexShrink: 0 }} />
        <span style={{ fontSize: 13, color: "#374151", flex: 1 }}>{item}</span>
        <StatusButton options={STATUS_OPTS} value={status} onChange={v => onUpdate({ status: v, checked, note })} />
      </div>
      {status === "Trailing" && (
        <div style={{ borderRadius: "0 0 7px 7px", border: "1px solid #fcd34d", borderTop: "none", background: "#fffbeb", padding: "6px 10px" }}>
          <input value={note} onChange={e => onUpdate({ status, checked, note: e.target.value, includeNoteInEmail: statusObj?.includeNoteInEmail || false })} placeholder="Trailing note..." style={{ width: "100%", padding: "5px 10px", borderRadius: 5, border: "1px solid #fcd34d", fontSize: 12, outline: "none", background: "#fff", boxSizing: "border-box", marginBottom: 4 }} />
          {note && (
            <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer", marginTop: 4 }}>
              <input type="checkbox" checked={statusObj?.includeNoteInEmail || false} onChange={e => onUpdate({ status, checked, note, includeNoteInEmail: e.target.checked })} style={{ width: 12, height: 12, accentColor: "#92400e", cursor: "pointer" }} />
              <span style={{ fontSize: 11, color: "#92400e" }}>Include this note in client email</span>
            </label>
          )}
        </div>
      )}
    </div>
  );
}

// ── TASK HELPERS ──────────────────────────────────────────────────────────
function getTeamMember(key) { return TEAM.find(t => t.key === key) || TEAM[0]; }

function TaskBadge({ task, onComplete, onNavigate }) {
  const member = getTeamMember(task.assigned_to);
  const diff = task.due_date ? daysDiff(task.due_date) : null;
  const overdue = diff !== null && diff < 0;
  const dueToday = diff === 0;
  const hasLink = (task.loan_id || task.lead_id) && onNavigate;
  const linkLabel = task.loan_name ? `📁 ${task.loan_name}` : task.lead_name ? `🎯 ${task.lead_name}` : task.relationship_name ? `🤝 ${task.relationship_name}` : null;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 12px", borderRadius: 8, border: `1.5px solid ${overdue ? "#fca5a5" : dueToday ? "#fcd34d" : "#e5e7eb"}`, background: overdue ? "#fef2f2" : dueToday ? "#fffbeb" : "#f8fafc", marginBottom: 6 }}>
      <input type="checkbox" checked={task.completed} onChange={() => onComplete(task.id)} style={{ width: 16, height: 16, cursor: "pointer", accentColor: "#1e3a5f", flexShrink: 0 }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: task.completed ? "#9ca3af" : "#0f2644", textDecoration: task.completed ? "line-through" : "none" }}>{task.title}</div>
        {linkLabel && (
          <div
            onClick={hasLink ? (e) => { e.stopPropagation(); onNavigate(task); } : undefined}
            style={{ fontSize: 11, color: hasLink ? "#1e40af" : "#6b7280", cursor: hasLink ? "pointer" : "default", textDecoration: hasLink ? "underline" : "none", marginTop: 2 }}
          >
            {linkLabel}
          </div>
        )}
      </div>
      <span style={{ background: member.color, color: member.textColor, borderRadius: 5, padding: "2px 8px", fontSize: 11, fontWeight: 700, flexShrink: 0 }}>{member.name.split(" ")[0]}</span>
      {task.due_date && (
        <span style={{ fontSize: 11, fontWeight: 700, color: overdue ? "#dc2626" : dueToday ? "#92400e" : "#6b7280", flexShrink: 0 }}>
          {overdue ? `${Math.abs(diff)}d overdue` : dueToday ? "Today" : `${diff}d`}
        </span>
      )}
    </div>
  );
}

// ── LOGIN ─────────────────────────────────────────────────────────────────
function LoginScreen({ onLogin }) {
  const [pw, setPw] = useState(""); const [err, setErr] = useState("");
  return (
    <div style={{ minHeight: "100vh", background: "linear-gradient(135deg, #0f2644 0%, #1e3a5f 60%, #c9a84c 100%)", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ background: "#fff", borderRadius: 16, padding: "48px 40px", width: 340, boxShadow: "0 20px 60px rgba(0,0,0,0.25)", textAlign: "center" }}>
        <div style={{ fontSize: 36, marginBottom: 6 }}>🏠</div>
        <h1 style={{ fontSize: 22, fontWeight: 800, color: "#0f2644", margin: "0 0 4px" }}>Gila Valley Mortgage</h1>
        <p style={{ fontSize: 13, color: "#6b7280", marginBottom: 28 }}>Loan Tracker — Team Access</p>
        <input type="password" placeholder="Team password" value={pw} onChange={e => setPw(e.target.value)} onKeyDown={e => e.key === "Enter" && (pw === SHARED_PASSWORD ? onLogin() : setErr("Incorrect password."))}
          style={{ width: "100%", padding: "10px 14px", borderRadius: 8, border: "1.5px solid #d1d5db", fontSize: 15, outline: "none", boxSizing: "border-box", marginBottom: 10 }} />
        {err && <p style={{ color: "#dc2626", fontSize: 13, margin: "0 0 8px" }}>{err}</p>}
        <button onClick={() => pw === SHARED_PASSWORD ? onLogin() : setErr("Incorrect password.")} style={{ width: "100%", background: "#1e3a5f", color: "#fff", border: "none", borderRadius: 8, padding: 11, fontSize: 15, fontWeight: 700, cursor: "pointer" }}>Sign In</button>
      </div>
    </div>
  );
}

// ── DASHBOARD ─────────────────────────────────────────────────────────────
function Dashboard({ loans, tasks, onOpen, onNew, onDeleteLoan, onCompleteTask, onAddTask }) {
  const [sortByClosing, setSortByClosing] = useState(false);
  const [sortByStage, setSortByStage] = useState(false);
  const [search, setSearch] = useState("");
  const [showClosed, setShowClosed] = useState("active");
  const [deadFilter, setDeadFilter] = useState("all");
  const [stageFilter, setStageFilter] = useState("all");
  const [rateFilter, setRateFilter] = useState("");

  const filtered = loans.filter(l => {
    const name = `${l.borrower_last} ${l.borrower_first} ${l.coborrower_last || ""}`.toLowerCase();
    const matchSearch = name.includes(search.toLowerCase());
    const matchRate = !rateFilter || (l.interest_rate && parseFloat(l.interest_rate) >= parseFloat(rateFilter));
    let matchTab = false;
    if (showClosed === "active") matchTab = (!l.funding_date && l.loan_stage !== "Funded") && l.loan_status !== "Withdrawn" && l.loan_status !== "Denied";
    else if (showClosed === "closed") matchTab = !!l.funding_date || l.loan_stage === "Funded";
    else if (showClosed === "dead") {
      matchTab = l.loan_status === "Withdrawn" || l.loan_status === "Denied";
      if (deadFilter !== "all") matchTab = matchTab && l.loan_status === deadFilter;
    }
    return matchSearch && matchTab && matchRate;
  }).sort((a, b) => {
    if (sortByClosing) { const da = a.closing_date || "9999"; const db = b.closing_date || "9999"; return da < db ? -1 : 1; }
    if (sortByStage) {
      const stageOrder = LOAN_STAGES.map(s => s.label);
      const ai = stageOrder.indexOf(a.loan_stage || "Loan Open");
      const bi = stageOrder.indexOf(b.loan_stage || "Loan Open");
      return ai - bi;
    }
    return (a.borrower_last || "").toLowerCase() < (b.borrower_last || "").toLowerCase() ? -1 : 1;
  });

  const openTasks = tasks.filter(t => !t.completed);
  const overdueCount = openTasks.filter(t => t.due_date && daysDiff(t.due_date) < 0).length;

  return (
    <div style={{ minHeight: "100vh", background: "#f8fafc" }}>
      <div style={{ background: "linear-gradient(90deg, #0f2644 0%, #1e3a5f 100%)", padding: "20px 32px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div>
          <h1 style={{ color: "#fff", margin: 0, fontSize: 22, fontWeight: 800 }}>🏠 Gila Valley Mortgage</h1>
          <p style={{ color: "#c9a84c", margin: 0, fontSize: 13, fontWeight: 600 }}>Loan Tracker Dashboard</p>
        </div>
        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          <button onClick={onNew} style={{ background: "#c9a84c", color: "#0f2644", border: "none", borderRadius: 8, padding: "10px 22px", fontWeight: 800, fontSize: 14, cursor: "pointer" }}>+ New Loan File</button>
        </div>
      </div>
      <div style={{ padding: "28px 32px" }}>
        <div style={{ display: "flex", gap: 0, marginBottom: 20, borderRadius: 8, overflow: "hidden", border: "1.5px solid #d1d5db", width: "fit-content" }}>
          {[
            ["Active Pipeline", "active"],
            ["Closed / Funded", "closed"],
            ["Withdrawn / Denied", "dead"],
          ].map(([label, val]) => (
            <button key={val} onClick={() => setShowClosed(val)} style={{ padding: "8px 24px", border: "none", cursor: "pointer", fontSize: 13, fontWeight: 700, background: showClosed === val ? "#1e3a5f" : "#fff", color: showClosed === val ? "#fff" : "#6b7280", borderLeft: val !== "active" ? "1.5px solid #d1d5db" : "none" }}>
              {label} ({val === "active" ? loans.filter(l => !l.funding_date && l.loan_status !== "Withdrawn" && l.loan_status !== "Denied").length : val === "closed" ? loans.filter(l => !!l.funding_date).length : loans.filter(l => l.loan_status === "Withdrawn" || l.loan_status === "Denied").length})
            </button>
          ))}
        </div>
        <div style={{ display: "flex", gap: 12, marginBottom: 20, alignItems: "center", flexWrap: "wrap" }}>
          <input placeholder="Search by borrower name..." value={search} onChange={e => setSearch(e.target.value)} style={{ padding: "8px 14px", borderRadius: 8, border: "1.5px solid #d1d5db", fontSize: 14, width: 260, outline: "none" }} />
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <label style={{ fontSize: 13, color: "#374151", fontWeight: 600 }}>Rate ≥</label>
            <select value={rateFilter} onChange={e => setRateFilter(e.target.value)} style={{ padding: "8px 12px", borderRadius: 8, border: `1.5px solid ${rateFilter ? "#1e3a5f" : "#d1d5db"}`, fontSize: 13, outline: "none", background: rateFilter ? "#eff6ff" : "#fff", cursor: "pointer" }}>
              <option value="">All Rates</option>
              {[5.0,5.5,6.0,6.25,6.5,6.75,7.0,7.25,7.5,7.75,8.0].map(r => <option key={r} value={r}>{r}%</option>)}
            </select>
          </div>
          <button onClick={() => { setSortByClosing(s => !s); setSortByStage(false); }} style={{ padding: "8px 16px", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer", border: `1.5px solid ${sortByClosing ? "#1e3a5f" : "#d1d5db"}`, background: sortByClosing ? "#1e3a5f" : "#fff", color: sortByClosing ? "#fff" : "#374151" }}>
            {sortByClosing ? "✓ Sorted by Closing Date" : "Sort by Closing Date"}
          </button>
          <button onClick={() => { setSortByStage(s => !s); setSortByClosing(false); }} style={{ padding: "8px 16px", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer", border: `1.5px solid ${sortByStage ? "#1e3a5f" : "#d1d5db"}`, background: sortByStage ? "#1e3a5f" : "#fff", color: sortByStage ? "#fff" : "#374151" }}>
            {sortByStage ? "✓ Sorted by Stage" : "Sort by Stage"}
          </button>
        </div>
        {filtered.length === 0 ? (
          <div style={{ textAlign: "center", padding: "60px 20px", color: "#9ca3af", fontSize: 15 }}>{showClosed ? "No closed loans yet." : "No active loans. Click \"+ New Loan File\" to get started."}</div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {filtered.map(loan => {
              const loanTasks = openTasks.filter(t => t.loan_id === loan.id);
              const loanOverdue = loanTasks.filter(t => t.due_date && daysDiff(t.due_date) < 0).length;
              return (
                <div key={loan.id} onClick={() => onOpen(loan.id)} style={{ background: "#fff", borderRadius: 10, border: "1.5px solid #e5e7eb", padding: "16px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", cursor: "pointer" }}>
                  <div>
                    <div style={{ fontWeight: 800, fontSize: 16, color: "#0f2644" }}>
                      {loan.borrower_last}, {loan.borrower_first}{loan.coborrower_last ? ` & ${loan.coborrower_last}, ${loan.coborrower_first || ""}` : ""}
                    </div>
                    <div style={{ fontSize: 13, color: "#6b7280", marginTop: 2 }}>{loan.property_address || "No address"} | Loan #{loan.loan_number || "TBD"}{loan.loan_type ? ` | ${loan.loan_type}` : ""}{loan.purchase_or_refi ? ` · ${loan.purchase_or_refi}` : ""}{loan.loan_amount ? ` · $${Number(loan.loan_amount).toLocaleString()}` : ""}{loan.interest_rate ? ` · ${loan.interest_rate}%` : ""}{loan.is_new_construction === "Yes" ? " · 🏗 New Construction" : ""}</div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", justifyContent: "flex-end" }}>
                    {loan.loan_stage && (() => { const s = LOAN_STAGES.find(x => x.label === loan.loan_stage); return s ? <span style={{ background: s.bg, color: s.text, border: "1.5px solid " + s.border, borderRadius: 6, padding: "4px 12px", fontSize: 12, fontWeight: 800 }}>{s.label}</span> : null; })()}
                    {loan.loan_status === "Withdrawn" && <span style={{ background: "#fef3c7", color: "#92400e", borderRadius: 6, padding: "3px 10px", fontSize: 12, fontWeight: 700 }}>Withdrawn</span>}
                    {loan.loan_status === "Denied" && <span style={{ background: "#fee2e2", color: "#991b1b", borderRadius: 6, padding: "3px 10px", fontSize: 12, fontWeight: 700 }}>Denied</span>}
                    {loanOverdue > 0 && <span style={{ background: "#fee2e2", color: "#991b1b", borderRadius: 6, padding: "3px 8px", fontSize: 11, fontWeight: 700 }}>overdue: {loanOverdue}</span>}
                    {loanTasks.length > 0 && loanOverdue === 0 && <span style={{ background: "#fef3c7", color: "#92400e", borderRadius: 6, padding: "3px 8px", fontSize: 11, fontWeight: 700 }}>{loanTasks.length} tasks</span>}
                    {(loan.funding_date || loan.loan_stage === "Funded") && <span style={{ background: "#d1fae5", color: "#065f46", borderRadius: 6, padding: "3px 10px", fontSize: 12, fontWeight: 700 }}>{loan.funding_date ? "Funded: " + loan.funding_date : "Funded"}</span>}
                    {loan.closing_date && !loan.funding_date && loan.loan_stage !== "Funded" && <span style={{ background: "#fef3c7", color: "#92400e", borderRadius: 6, padding: "3px 10px", fontSize: 12, fontWeight: 700 }}>Closing: {loan.closing_date}</span>}
                    <button onClick={e => { e.stopPropagation(); if (window.confirm("Delete this loan file?")) onDeleteLoan(loan.id); }} style={{ background: "none", border: "none", color: "#dc2626", cursor: "pointer", fontSize: 22, padding: "0 4px" }}>x</button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

// ── TASK DASHBOARD ────────────────────────────────────────────────────────
function TaskDashboard({ tasks, loans, leads, onComplete, onAddTask, onDeleteTask, onNavigate, onPushTask, onReassignTask }) {
  const [view, setView] = useState("alex");
  const [calMonth, setCalMonth] = useState(() => { const d = new Date(); return { year: d.getFullYear(), month: d.getMonth() }; });
  const [showAddModal, setShowAddModal] = useState(false);
  const [calView, setCalView] = useState(false);
  const [dateFilter, setDateFilter] = useState("today");
  const [calPersonFilter, setCalPersonFilter] = useState("all");
  const [expandedDay, setExpandedDay] = useState(null);
  const [calTaskPopup, setCalTaskPopup] = useState(null);
  const [pushFromCal, setPushFromCal] = useState(null);
  const [calActionTask, setCalActionTask] = useState(null);

  const openTasks = tasks.filter(t => !t.completed);

  function applyDateFilter(taskList) {
    const today = todayStr();
    const startOfWeek = (() => { const d = new Date(); d.setDate(d.getDate() - d.getDay()); return d.toISOString().split("T")[0]; })();
    const endOfWeek = (() => { const d = new Date(); d.setDate(d.getDate() + (6 - d.getDay())); return d.toISOString().split("T")[0]; })();
    const startOfMonth = `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, "0")}-01`;
    const endOfMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().split("T")[0];
    switch (dateFilter) {
      case "overdue": return taskList.filter(t => t.due_date && t.due_date < today);
      case "today": return taskList.filter(t => t.due_date === today);
      case "week": return taskList.filter(t => t.due_date && t.due_date >= startOfWeek && t.due_date <= endOfWeek);
      case "month": return taskList.filter(t => t.due_date && t.due_date >= startOfMonth && t.due_date <= endOfMonth);
      default: return taskList;
    }
  }

  const viewTasks = view === "all" ? openTasks : openTasks.filter(t => t.assigned_to === view);
  const filteredTasks = applyDateFilter(viewTasks);
  const sortedTasks = [...filteredTasks].sort((a, b) => (a.due_date || "9999") < (b.due_date || "9999") ? -1 : 1);

  const overdueCount = viewTasks.filter(t => t.due_date && t.due_date < todayStr()).length;
  const todayCount = viewTasks.filter(t => t.due_date === todayStr()).length;

  // Calendar
  const { year, month } = calMonth;
  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const monthNames = ["January","February","March","April","May","June","July","August","September","October","November","December"];

  function getCalEvents(day) {
    const dateStr = `${year}-${String(month+1).padStart(2,"0")}-${String(day).padStart(2,"0")}`;
    const events = [];
    tasks.filter(t => !t.completed && t.due_date === dateStr && (calPersonFilter === "all" || t.assigned_to === calPersonFilter)).forEach(t => {
      const m = getTeamMember(t.assigned_to);
      events.push({ label: t.title, color: m.color, textColor: m.textColor, type: "task", taskId: t.id, loanId: t.loan_id, leadId: t.lead_id, relId: t.relationship_id });
    });
    loans.forEach(l => {
      if (l.lock_expiration_date === dateStr) events.push({ label: `🔒 Lock Exp: ${l.borrower_last}`, color: "#ef4444", textColor: "#fff", type: "lock", loanId: l.id });
      if (l.funding_date === dateStr) events.push({ label: `💰 Funding: ${l.borrower_last}`, color: "#bbf7d0", textColor: "#065f46", type: "funding", loanId: l.id });
    });
    return events;
  }

  return (
    <div style={{ minHeight: "100vh", background: "#f8fafc" }}>
      <div style={{ background: "linear-gradient(90deg, #0f2644 0%, #1e3a5f 100%)", padding: "20px 32px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div>
          <h1 style={{ color: "#fff", margin: 0, fontSize: 22, fontWeight: 800 }}>📋 Task Dashboard</h1>
          <p style={{ color: "#c9a84c", margin: 0, fontSize: 13, fontWeight: 600 }}>Gila Valley Mortgage</p>
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={() => setCalView(v => !v)} style={{ background: calView ? "#c9a84c" : "rgba(255,255,255,0.15)", color: calView ? "#0f2644" : "#fff", border: "none", borderRadius: 7, padding: "8px 16px", fontWeight: 700, fontSize: 13, cursor: "pointer" }}>
            {calView ? "📋 List View" : "📅 Calendar View"}
          </button>
          <button onClick={() => setShowAddModal(true)} style={{ background: "#c9a84c", color: "#0f2644", border: "none", borderRadius: 8, padding: "10px 20px", fontWeight: 800, fontSize: 14, cursor: "pointer" }}>+ Add Task</button>
        </div>
      </div>

      {/* Team filter tabs */}
      <div style={{ background: "#fff", borderBottom: "1.5px solid #e5e7eb", padding: "0 32px", display: "flex", gap: 0, overflowX: "auto" }}>
        {[{ key: "all", name: "All Tasks", color: "#1e3a5f", textColor: "#fff" }, ...TEAM].map(m => (
          <button key={m.key} onClick={() => setView(m.key)} style={{ padding: "12px 20px", border: "none", borderBottom: view === m.key ? `3px solid ${m.key === "all" ? "#1e3a5f" : m.color}` : "3px solid transparent", background: "none", cursor: "pointer", fontWeight: view === m.key ? 800 : 500, fontSize: 13, color: view === m.key ? "#0f2644" : "#6b7280", whiteSpace: "nowrap" }}>
            {m.name}
            {m.key !== "all" && <span style={{ marginLeft: 6, background: m.color, color: m.textColor, borderRadius: 10, padding: "1px 7px", fontSize: 11, fontWeight: 700 }}>{openTasks.filter(t => t.assigned_to === m.key).length}</span>}
          </button>
        ))}
      </div>

      {/* Date filter bar */}
      {!calView && (
        <div style={{ background: "#f8fafc", borderBottom: "1.5px solid #e5e7eb", padding: "10px 32px", display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
          <span style={{ fontSize: 12, fontWeight: 700, color: "#6b7280", marginRight: 4 }}>SHOW:</span>
          {[
            { key: "overdue", label: `Overdue${overdueCount > 0 ? ` (${overdueCount})` : ""}`, color: "#fee2e2", textActive: "#991b1b", borderActive: "#fca5a5" },
            { key: "today", label: `Due Today${todayCount > 0 ? ` (${todayCount})` : ""}`, color: "#fef3c7", textActive: "#92400e", borderActive: "#fcd34d" },
            { key: "week", label: "This Week", color: "#dbeafe", textActive: "#1e40af", borderActive: "#93c5fd" },
            { key: "month", label: "This Month", color: "#f3e8ff", textActive: "#5b21b6", borderActive: "#c4b5fd" },
            { key: "all", label: "All Tasks", color: "#f1f5f9", textActive: "#1e3a5f", borderActive: "#94a3b8" },
          ].map(f => (
            <button key={f.key} onClick={() => setDateFilter(f.key)} style={{
              padding: "5px 14px", borderRadius: 20, fontSize: 12, fontWeight: 700, cursor: "pointer",
              border: `1.5px solid ${dateFilter === f.key ? f.borderActive : "#d1d5db"}`,
              background: dateFilter === f.key ? f.color : "#fff",
              color: dateFilter === f.key ? f.textActive : "#6b7280",
            }}>{f.label}</button>
          ))}
        </div>
      )}

      <div style={{ padding: "24px 32px" }}>
        {!calView ? (
          <div>
            {sortedTasks.length === 0 ? (
              <div style={{ textAlign: "center", padding: "60px", color: "#9ca3af", fontSize: 15 }}>
                {dateFilter !== "all" ? `No tasks found for this date range.` : "No open tasks. Great work! 🎉"}
              </div>
            ) : (
              sortedTasks.map(task => (
                <div key={task.id} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <div style={{ flex: 1 }}><TaskBadge task={task} onComplete={onComplete} onNavigate={onNavigate} onPush={onPushTask} onReassign={onReassignTask} /></div>
                  <button onClick={() => { if (window.confirm("Delete this task?")) onDeleteTask(task.id); }} style={{ background: "none", border: "none", color: "#dc2626", cursor: "pointer", fontSize: 18, padding: "0 4px", marginBottom: 6 }}>×</button>
                </div>
              ))
            )}
            {/* Completed tasks */}
            {tasks.filter(t => t.completed).length > 0 && (
              <details style={{ marginTop: 20 }}>
                <summary style={{ cursor: "pointer", fontSize: 13, color: "#6b7280", fontWeight: 600, marginBottom: 8 }}>Show Completed ({tasks.filter(t => t.completed).length})</summary>
                {tasks.filter(t => t.completed && (view === "all" || t.assigned_to === view)).map(task => (
                  <div key={task.id} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <div style={{ flex: 1 }}><TaskBadge task={task} onComplete={onComplete} onNavigate={onNavigate} onPush={onPushTask} onReassign={onReassignTask} /></div>
                    <button onClick={() => onDeleteTask(task.id)} style={{ background: "none", border: "none", color: "#dc2626", cursor: "pointer", fontSize: 18 }}>×</button>
                  </div>
                ))}
              </details>
            )}
          </div>
        ) : (
          <div>
            {/* Calendar person filter */}
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 14 }}>
              <button onClick={() => setCalPersonFilter("all")} style={{ padding: "5px 14px", borderRadius: 20, fontSize: 12, fontWeight: 700, cursor: "pointer", border: `1.5px solid ${calPersonFilter === "all" ? "#1e3a5f" : "#d1d5db"}`, background: calPersonFilter === "all" ? "#1e3a5f" : "#fff", color: calPersonFilter === "all" ? "#fff" : "#6b7280" }}>All</button>
              {TEAM.map(m => (
                <button key={m.key} onClick={() => setCalPersonFilter(calPersonFilter === m.key ? "all" : m.key)} style={{ padding: "5px 14px", borderRadius: 20, fontSize: 12, fontWeight: 700, cursor: "pointer", border: `1.5px solid ${calPersonFilter === m.key ? m.color : "#d1d5db"}`, background: calPersonFilter === m.key ? m.color : "#fff", color: calPersonFilter === m.key ? m.textColor : "#6b7280" }}>
                  {m.name.split(" ")[0]}
                </button>
              ))}
              <span style={{ fontSize: 11, color: "#9ca3af", alignSelf: "center", marginLeft: 4 }}>🔒 Lock & 💰 Funding always visible</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 16 }}>
              <button onClick={() => setCalMonth(m => { const d = new Date(m.year, m.month - 1); return { year: d.getFullYear(), month: d.getMonth() }; })} style={{ background: "#1e3a5f", color: "#fff", border: "none", borderRadius: 7, padding: "6px 14px", cursor: "pointer", fontWeight: 700 }}>←</button>
              <span style={{ fontWeight: 800, fontSize: 18, color: "#0f2644" }}>{monthNames[month]} {year}</span>
              <button onClick={() => setCalMonth(m => { const d = new Date(m.year, m.month + 1); return { year: d.getFullYear(), month: d.getMonth() }; })} style={{ background: "#1e3a5f", color: "#fff", border: "none", borderRadius: 7, padding: "6px 14px", cursor: "pointer", fontWeight: 700 }}>→</button>
            </div>
            {/* Legend */}
            <div style={{ display: "flex", gap: 12, marginBottom: 16, flexWrap: "wrap" }}>
              {TEAM.map(m => <span key={m.key} style={{ background: m.color, color: m.textColor, borderRadius: 5, padding: "2px 10px", fontSize: 12, fontWeight: 700 }}>{m.name.split(" ")[0]}</span>)}
              <span style={{ background: "#ef4444", color: "#fff", borderRadius: 5, padding: "2px 10px", fontSize: 12, fontWeight: 700 }}>🔒 Lock Exp</span>
              <span style={{ background: "#bbf7d0", color: "#065f46", borderRadius: 5, padding: "2px 10px", fontSize: 12, fontWeight: 700 }}>💰 Funding</span>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 2, marginBottom: 4 }}>
              {["Sun","Mon","Tue","Wed","Thu","Fri","Sat"].map(d => <div key={d} style={{ textAlign: "center", fontWeight: 700, fontSize: 12, color: "#6b7280", padding: "4px 0" }}>{d}</div>)}
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 2 }}>
              {Array.from({ length: firstDay }).map((_, i) => <div key={`e${i}`} style={{ minHeight: 80, background: "#f1f5f9", borderRadius: 6 }} />)}
              {Array.from({ length: daysInMonth }).map((_, i) => {
                const day = i + 1;
                const events = getCalEvents(day);
                const CAP = 3;
                const isToday = new Date().getDate() === day && new Date().getMonth() === month && new Date().getFullYear() === year;
                const visible = events.slice(0, CAP);
                const hidden = events.length - CAP;
                const dayKey = `${year}-${month}-${day}`;
                const isExpanded = expandedDay === dayKey;
                const displayEvents = isExpanded ? events : visible;
                return (
                  <div key={day} style={{ minHeight: 80, background: "#fff", borderRadius: 6, border: isToday ? "2px solid #1e3a5f" : "1px solid #e5e7eb", padding: "4px" }}>
                    <div style={{ fontWeight: isToday ? 800 : 600, fontSize: 13, color: isToday ? "#1e3a5f" : "#374151", marginBottom: 2 }}>{day}</div>
                    {displayEvents.map((ev, idx) => (
                      <div key={idx}
                        onClick={() => setCalTaskPopup(ev)}
                        style={{ background: ev.color, color: ev.textColor, borderRadius: 4, padding: "1px 5px", fontSize: 10, fontWeight: 700, marginBottom: 2, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", cursor: "pointer" }}
                        title="Click for details"
                      >{ev.label}</div>
                    ))}
                    {!isExpanded && hidden > 0 && (
                      <div onClick={() => setExpandedDay(dayKey)} style={{ fontSize: 10, color: "#1e40af", cursor: "pointer", fontWeight: 700, marginTop: 2 }}>+{hidden} more</div>
                    )}
                    {isExpanded && events.length > CAP && (
                      <div onClick={() => setExpandedDay(null)} style={{ fontSize: 10, color: "#6b7280", cursor: "pointer", fontWeight: 700, marginTop: 2 }}>show less</div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
      {showAddModal && <AddTaskModal loans={loans} leads={leads} onSave={task => { onAddTask(task); setShowAddModal(false); }} onCancel={() => setShowAddModal(false)} />}
      {pushFromCal && <PushTaskModal task={pushFromCal} onPush={(newDate) => { onPushTask(pushFromCal.id, newDate); setPushFromCal(null); }} onCancel={() => setPushFromCal(null)} />
      }{calActionTask && <TaskActionModal task={calActionTask} tasks={tasks} onComplete={onComplete} onPush={onPushTask} onReassign={onReassignTask || (() => {})} onCancel={() => setCalActionTask(null)} />}
      {calTaskPopup && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }} onClick={() => setCalTaskPopup(null)}>
          <div style={{ background: "#fff", borderRadius: 14, padding: "28px 32px", width: 380, boxShadow: "0 20px 60px rgba(0,0,0,0.2)" }} onClick={e => e.stopPropagation()}>
            <div style={{ fontSize: 15, fontWeight: 800, color: "#0f2644", marginBottom: 8 }}>{calTaskPopup.label}</div>
            {calTaskPopup.taskId && (() => {
              const task = tasks.find(t => t.id === calTaskPopup.taskId);
              const member = task ? getTeamMember(task.assigned_to) : null;
              return task ? (
                <div style={{ marginBottom: 14 }}>
                  {member && <span style={{ background: member.color, color: member.textColor, borderRadius: 5, padding: "2px 10px", fontSize: 12, fontWeight: 700, marginBottom: 8, display: "inline-block" }}>{member.name}</span>}
                  {task.due_date && <div style={{ fontSize: 13, color: "#6b7280", marginTop: 6 }}>Due: {task.due_date}</div>}
                  {task.notes && <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 4, fontStyle: "italic" }}>{task.notes}</div>}
                </div>
              ) : null;
            })()}
            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
              <button onClick={() => setCalTaskPopup(null)} style={{ padding: "8px 18px", borderRadius: 8, border: "1.5px solid #d1d5db", background: "#fff", cursor: "pointer", fontSize: 13 }}>Close</button>
              {(calTaskPopup.loanId || calTaskPopup.leadId || calTaskPopup.relId) && onNavigate && (
                <button onClick={() => { setCalTaskPopup(null); onNavigate({ loan_id: calTaskPopup.loanId, lead_id: calTaskPopup.leadId, relationship_id: calTaskPopup.relId }); }} style={{ padding: "8px 18px", borderRadius: 8, border: "none", background: "#1e3a5f", color: "#fff", fontWeight: 700, cursor: "pointer", fontSize: 13 }}>Open File →</button>
              )}
              {calTaskPopup.taskId && (
                <button onClick={() => { const t = tasks.find(x => x.id === calTaskPopup.taskId); if (t) { setCalTaskPopup(null); setCalActionTask(t); } }} style={{ padding: "8px 18px", borderRadius: 8, border: "1.5px solid #93c5fd", background: "#f0f9ff", color: "#1e40af", fontWeight: 700, cursor: "pointer", fontSize: 13 }}>⋯ Actions</button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── ADD TASK MODAL ────────────────────────────────────────────────────────
function AddTaskModal({ loans, leads = [], onSave, onCancel, defaultLoanId = null, defaultLeadId = null }) {
  const [form, setForm] = useState({ title: "", assigned_to: "alex", due_date: "", loan_id: defaultLoanId || "", lead_id: defaultLeadId || "", notes: "" });
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const inp = { width: "100%", padding: "8px 12px", borderRadius: 7, border: "1.5px solid #d1d5db", fontSize: 14, outline: "none", boxSizing: "border-box" };
  const lbl = { fontSize: 12, fontWeight: 700, color: "#374151", marginBottom: 4, display: "block" };
  const activeLoans = loans.filter(l => !l.funding_date);
  const activeLeads = leads.filter(l => !CLOSED_LEAD_STATUSES.includes(l.status));
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }}>
      <div style={{ background: "#fff", borderRadius: 14, padding: "32px", width: 480, boxShadow: "0 20px 60px rgba(0,0,0,0.2)" }}>
        <h2 style={{ margin: "0 0 20px", color: "#0f2644", fontSize: 18, fontWeight: 800 }}>New Task</h2>
        <div style={{ marginBottom: 14 }}><label style={lbl}>Task Title *</label><input style={inp} value={form.title} onChange={e => set("title", e.target.value)} placeholder="Describe the task..." /></div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 14 }}>
          <div>
            <label style={lbl}>Assign To</label>
            <select value={form.assigned_to} onChange={e => set("assigned_to", e.target.value)} style={{ ...inp }}>
              {TEAM.map(m => <option key={m.key} value={m.key}>{m.name}</option>)}
            </select>
          </div>
          <div><label style={lbl}>Due Date</label><input type="date" style={inp} value={form.due_date} onChange={e => set("due_date", e.target.value)} /></div>
        </div>
        {activeLoans.length > 0 && !defaultLeadId && (
          <div style={{ marginBottom: 14 }}>
            <label style={lbl}>Link to Loan File (optional)</label>
            <select value={form.loan_id} onChange={e => set("loan_id", e.target.value)} style={{ ...inp }}>
              <option value="">No loan file</option>
              {activeLoans.map(l => <option key={l.id} value={l.id}>{l.borrower_last}, {l.borrower_first} — {l.property_address || "No address"}</option>)}
            </select>
          </div>
        )}
        {activeLeads.length > 0 && !defaultLoanId && (
          <div style={{ marginBottom: 14 }}>
            <label style={lbl}>Link to Lead (optional)</label>
            <select value={form.lead_id} onChange={e => set("lead_id", e.target.value)} style={{ ...inp }}>
              <option value="">No lead</option>
              {activeLeads.map(l => <option key={l.id} value={l.id}>{l.last_name}, {l.first_name}</option>)}
            </select>
          </div>
        )}
        <div style={{ marginBottom: 20 }}><label style={lbl}>Notes</label><textarea value={form.notes} onChange={e => set("notes", e.target.value)} placeholder="Optional notes..." style={{ ...inp, height: 70, resize: "vertical" }} /></div>
        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          <button onClick={onCancel} style={{ padding: "9px 20px", borderRadius: 8, border: "1.5px solid #d1d5db", background: "#fff", cursor: "pointer", fontSize: 14 }}>Cancel</button>
          <button onClick={() => { if (!form.title.trim()) return alert("Task title is required."); onSave(form); }} style={{ padding: "9px 20px", borderRadius: 8, border: "none", background: "#1e3a5f", color: "#fff", fontWeight: 700, cursor: "pointer", fontSize: 14 }}>Add Task</button>
        </div>
      </div>
    </div>
  );
}

// ── NEW LOAN MODAL ────────────────────────────────────────────────────────
function NewLoanModal({ onSave, onCancel }) {
  const [form, setForm] = useState({ borrower_first: "", borrower_last: "", coborrower_first: "", coborrower_last: "", property_address: "", loan_number: "", closing_date: "", lock_expiration_date: "", loan_type: "", purchase_or_refi: "", loan_amount: "", lead_source: "" });
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const inp = { width: "100%", padding: "8px 12px", borderRadius: 7, border: "1.5px solid #d1d5db", fontSize: 14, outline: "none", boxSizing: "border-box" };
  const lbl = { fontSize: 12, fontWeight: 700, color: "#374151", marginBottom: 4, display: "block" };
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }}>
      <div style={{ background: "#fff", borderRadius: 14, padding: "36px 32px", width: 500, boxShadow: "0 20px 60px rgba(0,0,0,0.2)" }}>
        <h2 style={{ margin: "0 0 20px", color: "#0f2644", fontSize: 18, fontWeight: 800 }}>New Loan File</h2>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 14 }}>
          <div><label style={lbl}>Borrower First Name</label><input style={inp} value={form.borrower_first} onChange={e => set("borrower_first", e.target.value)} /></div>
          <div><label style={lbl}>Borrower Last Name *</label><input style={inp} value={form.borrower_last} onChange={e => set("borrower_last", e.target.value)} /></div>
          <div><label style={lbl}>Co-Borrower First Name</label><input style={inp} value={form.coborrower_first} onChange={e => set("coborrower_first", e.target.value)} /></div>
          <div><label style={lbl}>Co-Borrower Last Name</label><input style={inp} value={form.coborrower_last} onChange={e => set("coborrower_last", e.target.value)} /></div>
        </div>
        <div style={{ marginBottom: 14 }}><label style={lbl}>Property Address</label><input style={inp} value={form.property_address} onChange={e => set("property_address", e.target.value)} /></div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 24 }}>
          <div><label style={lbl}>Loan Number</label><input style={inp} value={form.loan_number} onChange={e => set("loan_number", e.target.value)} /></div>
          <div><label style={lbl}>Closing Date</label><input type="date" style={inp} value={form.closing_date} onChange={e => set("closing_date", e.target.value)} /></div>
          <div><label style={lbl}>Lock Expiration Date</label><input type="date" style={inp} value={form.lock_expiration_date} onChange={e => set("lock_expiration_date", e.target.value)} /></div>
          <div>
            <label style={lbl}>Loan Type</label>
            <select style={inp} value={form.loan_type || ""} onChange={e => set("loan_type", e.target.value)}>
              <option value="">Select...</option>
              {LOAN_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
            </select>
          </div>
          <div>
            <label style={lbl}>Purchase or Refinance</label>
            <select style={inp} value={form.purchase_or_refi || ""} onChange={e => set("purchase_or_refi", e.target.value)}>
              <option value="">Select...</option>
              <option value="Purchase">Purchase</option>
              <option value="Refinance">Refinance</option>
            </select>
          </div>
          <div><label style={lbl}>Loan Amount</label><input type="number" style={inp} value={form.loan_amount || ""} onChange={e => set("loan_amount", e.target.value)} placeholder="$" /></div>
          <div>
            <label style={lbl}>Lead Source</label>
            <select style={inp} value={form.lead_source || ""} onChange={e => set("lead_source", e.target.value)}>
              <option value="">Select...</option>
              {LEAD_SOURCES.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
        </div>
        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          <button onClick={onCancel} style={{ padding: "9px 20px", borderRadius: 8, border: "1.5px solid #d1d5db", background: "#fff", cursor: "pointer" }}>Cancel</button>
          <button onClick={() => { if (!form.borrower_last.trim()) return alert("Borrower last name is required."); const cleanForm = { ...form, closing_date: form.closing_date || null, lock_expiration_date: form.lock_expiration_date || null, loan_amount: form.loan_amount || null }; onSave(cleanForm); }} style={{ padding: "9px 20px", borderRadius: 8, border: "none", background: "#1e3a5f", color: "#fff", fontWeight: 700, cursor: "pointer" }}>Create File</button>
        </div>
      </div>
    </div>
  );
}

// ── CONVERSATION LOG ─────────────────────────────────────────────────────
function ConversationLog({ entries, onChange }) {
  const [text, setText] = useState("");
  const [author, setAuthor] = useState("Alex Giampietro");
  const [showForm, setShowForm] = useState(false);

  function addEntry() {
    if (!text.trim()) return;
    const now = new Date();
    const timestamp = `${now.toLocaleDateString()} ${now.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}`;
    const newEntry = { id: Date.now(), author, text, timestamp };
    onChange([newEntry, ...entries]);
    setText("");
    setShowForm(false);
  }

  return (
    <div>
      {!showForm ? (
        <button onClick={() => setShowForm(true)} style={{ background: "#f0f9ff", color: "#1e40af", border: "1.5px solid #93c5fd", borderRadius: 7, padding: "6px 14px", fontSize: 13, cursor: "pointer", fontWeight: 600, marginBottom: 12 }}>+ Add Note</button>
      ) : (
        <div style={{ background: "#f8fafc", borderRadius: 8, padding: "12px", border: "1.5px solid #93c5fd", marginBottom: 12 }}>
          <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
            <select value={author} onChange={e => setAuthor(e.target.value)} style={{ padding: "6px 10px", borderRadius: 6, border: "1px solid #d1d5db", fontSize: 13, outline: "none" }}>
              {["Alex Giampietro","Jordin Gutierrez","Madison Rhodes","Patricia Diaz"].map(n => <option key={n} value={n}>{n}</option>)}
            </select>
          </div>
          <textarea value={text} onChange={e => setText(e.target.value)} placeholder="Add a note..." style={{ width: "100%", padding: "8px 10px", borderRadius: 6, border: "1px solid #d1d5db", fontSize: 13, outline: "none", resize: "vertical", height: 80, boxSizing: "border-box", marginBottom: 8 }} />
          <div style={{ display: "flex", gap: 8 }}>
            <button onClick={addEntry} style={{ background: "#1e3a5f", color: "#fff", border: "none", borderRadius: 7, padding: "6px 16px", fontSize: 13, cursor: "pointer", fontWeight: 700 }}>Save Note</button>
            <button onClick={() => { setShowForm(false); setText(""); }} style={{ background: "#fff", border: "1.5px solid #d1d5db", borderRadius: 7, padding: "6px 14px", fontSize: 13, cursor: "pointer" }}>Cancel</button>
          </div>
        </div>
      )}
      {entries.length === 0 ? (
        <p style={{ fontSize: 13, color: "#9ca3af", margin: 0 }}>No notes yet.</p>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {entries.map(entry => (
            <div key={entry.id} style={{ background: "#fff", borderRadius: 8, padding: "10px 14px", border: "1px solid #e5e7eb" }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                <span style={{ fontSize: 12, fontWeight: 700, color: "#1e3a5f" }}>{entry.author}</span>
                <span style={{ fontSize: 11, color: "#9ca3af" }}>{entry.timestamp}</span>
              </div>
              <div style={{ fontSize: 13, color: "#374151", lineHeight: 1.5 }}>{entry.text}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── TASK ACTION MODAL ────────────────────────────────────────────────────
function TaskActionModal({ task, tasks, onComplete, onPush, onReassign, onCancel }) {
  const [view, setView] = useState("main"); // main | push | followup | reassign
  const [pushDate, setPushDate] = useState("");
  const [showCustomPush, setShowCustomPush] = useState(false);
  const [followupDays, setFollowupDays] = useState(null);
  const [followupCustomDate, setFollowupCustomDate] = useState("");
  const [showCustomFollowup, setShowCustomFollowup] = useState(false);
  const [selectedAssignees, setSelectedAssignees] = useState(
    task.assigned_to ? [task.assigned_to] : []
  );
  const [reassignMode, setReassignMode] = useState("add"); // add | replace

  const member = getTeamMember(task.assigned_to);
  const today = task.due_date || todayStr();

  async function handleComplete() {
    await onComplete(task.id);
    setView("followup");
  }

  async function handleFollowupChoice(days, customDate) {
    onCancel();
    if (days !== null || customDate) {
      const dueDate = customDate || safeTaskDate(addDays(todayStr(), days));
      // Create follow up for each current assignee
      const assignees = selectedAssignees.length > 0 ? selectedAssignees : [task.assigned_to];
      for (const assignee of assignees) {
        await window._createFollowupTask({ title: task.title, assigned_to: assignee, due_date: dueDate, loan_id: task.loan_id, loan_name: task.loan_name, lead_id: task.lead_id, lead_name: task.lead_name, notes: task.notes });
      }
    }
  }

  function handlePushDays(n) {
    const newDate = safeTaskDate(addDays(today, n));
    onPush(task.id, newDate);
    onCancel();
  }

  async function handleReassign() {
    await onReassign(task.id, selectedAssignees, reassignMode);
    onCancel();
  }

  const pushLog = (() => { try { return JSON.parse(task.push_log || "[]"); } catch { return []; } })();

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 2000 }} onClick={onCancel}>
      <div style={{ background: "#fff", borderRadius: 14, padding: "28px 32px", width: 420, boxShadow: "0 20px 60px rgba(0,0,0,0.2)", maxHeight: "90vh", overflowY: "auto" }} onClick={e => e.stopPropagation()}>

        {view === "main" && (
          <>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
              <div>
                <div style={{ fontSize: 15, fontWeight: 800, color: "#0f2644", marginBottom: 4 }}>{task.title}</div>
                {task.due_date && <div style={{ fontSize: 12, color: "#6b7280" }}>Due: {task.due_date}</div>}
              </div>
              <span style={{ background: member.color, color: member.textColor, borderRadius: 5, padding: "2px 10px", fontSize: 11, fontWeight: 700 }}>{member.name.split(" ")[0]}</span>
            </div>
            {pushLog.length > 0 && (
              <div style={{ background: "#f8fafc", borderRadius: 8, padding: "8px 12px", marginBottom: 12, fontSize: 11, color: "#6b7280" }}>
                Pushed {pushLog.length}x — originally due {pushLog[0].from}
              </div>
            )}
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {!task.completed && <button onClick={handleComplete} style={{ padding: "10px", borderRadius: 8, border: "none", background: "#d1fae5", color: "#065f46", fontWeight: 800, fontSize: 14, cursor: "pointer" }}>✅ Mark Complete</button>}
              {!task.completed && <button onClick={() => setView("push")} style={{ padding: "10px", borderRadius: 8, border: "1.5px solid #93c5fd", background: "#f0f9ff", color: "#1e40af", fontWeight: 700, fontSize: 14, cursor: "pointer" }}>🕐 Push Out Date</button>}
              <button onClick={() => setView("reassign")} style={{ padding: "10px", borderRadius: 8, border: "1.5px solid #d1d5db", background: "#f8fafc", color: "#374151", fontWeight: 700, fontSize: 14, cursor: "pointer" }}>👤 Reassign / Add Assignee</button>
              <button onClick={onCancel} style={{ padding: "8px", borderRadius: 8, border: "1.5px solid #e5e7eb", background: "#fff", color: "#6b7280", fontSize: 13, cursor: "pointer" }}>Cancel</button>
            </div>
          </>
        )}

        {view === "push" && (
          <>
            <h3 style={{ margin: "0 0 14px", color: "#0f2644", fontSize: 16, fontWeight: 800 }}>🕐 Push Out Date</h3>
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
              {[[1,"+ 1 Day"],[2,"+ 2 Days"],[3,"+ 3 Days"]].map(([n, label]) => (
                <button key={n} onClick={() => handlePushDays(n)} style={{ padding: "8px 16px", borderRadius: 8, border: "1.5px solid #d1d5db", background: "#f8fafc", color: "#374151", fontWeight: 700, fontSize: 13, cursor: "pointer" }}>{label}</button>
              ))}
              <button onClick={() => setShowCustomPush(s => !s)} style={{ padding: "8px 16px", borderRadius: 8, border: "1.5px solid #93c5fd", background: "#f0f9ff", color: "#1e40af", fontWeight: 700, fontSize: 13, cursor: "pointer" }}>📅 Pick Date</button>
            </div>
            {showCustomPush && (
              <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
                <input type="date" value={pushDate} onChange={e => setPushDate(e.target.value)} style={{ flex: 1, padding: "7px 10px", borderRadius: 7, border: "1.5px solid #93c5fd", fontSize: 13, outline: "none" }} />
                <button onClick={() => { if (pushDate) { onPush(task.id, pushDate); onCancel(); } }} style={{ padding: "7px 14px", borderRadius: 7, border: "none", background: "#1e3a5f", color: "#fff", fontWeight: 700, cursor: "pointer" }}>Set</button>
              </div>
            )}
            <button onClick={() => setView("main")} style={{ fontSize: 13, color: "#6b7280", background: "none", border: "none", cursor: "pointer" }}>← Back</button>
          </>
        )}

        {view === "followup" && (
          <>
            <div style={{ textAlign: "center", marginBottom: 16 }}>
              <div style={{ fontSize: 28, marginBottom: 6 }}>✅</div>
              <h3 style={{ margin: "0 0 4px", color: "#0f2644", fontSize: 16, fontWeight: 800 }}>Task Complete!</h3>
              <p style={{ fontSize: 13, color: "#6b7280", margin: 0 }}>Would you like to set a follow up?</p>
            </div>
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap", justifyContent: "center", marginBottom: 12 }}>
              {[[1,"1 Day","#1e3a5f","#fff"],[2,"2 Days","#374151","#fff"],[3,"3 Days","#4b5563","#fff"]].map(([days,label,bg,color]) => (
                <button key={days} onClick={() => handleFollowupChoice(days, null)} style={{ padding: "8px 14px", borderRadius: 8, border: "none", background: bg, color, fontWeight: 700, fontSize: 13, cursor: "pointer" }}>{label}</button>
              ))}
              <button onClick={() => setShowCustomFollowup(s => !s)} style={{ padding: "8px 14px", borderRadius: 8, border: "1.5px solid #93c5fd", background: "#f0f9ff", color: "#1e40af", fontWeight: 700, fontSize: 13, cursor: "pointer" }}>📅 Set Date</button>
              <button onClick={() => handleFollowupChoice(null, null)} style={{ padding: "8px 14px", borderRadius: 8, border: "none", background: "#f1f5f9", color: "#374151", fontWeight: 700, fontSize: 13, cursor: "pointer" }}>No Follow Up</button>
            </div>
            {showCustomFollowup && (
              <div style={{ display: "flex", gap: 8, marginBottom: 12, justifyContent: "center" }}>
                <input type="date" value={followupCustomDate} onChange={e => setFollowupCustomDate(e.target.value)} style={{ padding: "7px 10px", borderRadius: 7, border: "1.5px solid #93c5fd", fontSize: 13, outline: "none" }} />
                <button onClick={() => { if (followupCustomDate) handleFollowupChoice(null, followupCustomDate); }} style={{ padding: "7px 14px", borderRadius: 7, border: "none", background: "#1e3a5f", color: "#fff", fontWeight: 700, cursor: "pointer" }}>Set</button>
              </div>
            )}
          </>
        )}

        {view === "reassign" && (
          <>
            <h3 style={{ margin: "0 0 14px", color: "#0f2644", fontSize: 16, fontWeight: 800 }}>👤 Reassign Task</h3>
            <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
              {["add","replace"].map(mode => (
                <button key={mode} onClick={() => setReassignMode(mode)} style={{ padding: "6px 14px", borderRadius: 7, border: `1.5px solid ${reassignMode === mode ? "#1e3a5f" : "#d1d5db"}`, background: reassignMode === mode ? "#1e3a5f" : "#fff", color: reassignMode === mode ? "#fff" : "#374151", fontWeight: 700, fontSize: 12, cursor: "pointer" }}>
                  {mode === "add" ? "Add Assignee" : "Replace Assignee"}
                </button>
              ))}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 16 }}>
              {TEAM.map(m => (
                <label key={m.key} style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer", padding: "8px 12px", borderRadius: 8, background: selectedAssignees.includes(m.key) ? m.color : "#f8fafc", border: `1.5px solid ${selectedAssignees.includes(m.key) ? m.border || m.color : "#e5e7eb"}` }}>
                  <input type="checkbox" checked={selectedAssignees.includes(m.key)} onChange={e => {
                    if (e.target.checked) setSelectedAssignees(prev => [...prev, m.key]);
                    else setSelectedAssignees(prev => prev.filter(k => k !== m.key));
                  }} style={{ width: 15, height: 15, accentColor: "#1e3a5f", cursor: "pointer" }} />
                  <span style={{ fontSize: 13, fontWeight: 700, color: selectedAssignees.includes(m.key) ? m.textColor : "#374151" }}>{m.name}</span>
                </label>
              ))}
            </div>
            <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
              <button onClick={() => setView("main")} style={{ padding: "8px 16px", borderRadius: 8, border: "1.5px solid #d1d5db", background: "#fff", cursor: "pointer", fontSize: 13 }}>← Back</button>
              <button onClick={handleReassign} style={{ padding: "8px 18px", borderRadius: 8, border: "none", background: "#1e3a5f", color: "#fff", fontWeight: 700, cursor: "pointer", fontSize: 13 }}>Save</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

// ── PUSH TASK MODAL ──────────────────────────────────────────────────────
function PushTaskModal({ task, onPush, onCancel }) {
  const [customDate, setCustomDate] = useState("");
  const [showCustom, setShowCustom] = useState(false);
  const today = task.due_date || todayStr();

  function pushDays(n) {
    const newDate = addDays(today, n);
    onPush(safeTaskDate(newDate));
  }

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 2000 }}>
      <div style={{ background: "#fff", borderRadius: 14, padding: "28px 32px", width: 380, boxShadow: "0 20px 60px rgba(0,0,0,0.2)" }}>
        <h3 style={{ margin: "0 0 6px", color: "#0f2644", fontSize: 16, fontWeight: 800 }}>🕐 Push Out Task</h3>
        <p style={{ fontSize: 13, color: "#6b7280", margin: "0 0 18px" }}>{task.title}</p>
        {task.due_date && <p style={{ fontSize: 12, color: "#9ca3af", margin: "0 0 14px" }}>Current due date: {task.due_date}</p>}
        {task.push_log && (() => {
          const log = JSON.parse(task.push_log || "[]");
          return log.length > 0 ? (
            <div style={{ background: "#f8fafc", borderRadius: 8, padding: "8px 12px", marginBottom: 14, fontSize: 11, color: "#6b7280" }}>
              <div style={{ fontWeight: 700, marginBottom: 4 }}>Push history:</div>
              {log.map((l, i) => <div key={i}>{l.on}: {l.from} → {l.to}</div>)}
            </div>
          ) : null;
        })()}
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
          {[[1,"+ 1 Day"],[2,"+ 2 Days"],[3,"+ 3 Days"]].map(([n, label]) => (
            <button key={n} onClick={() => pushDays(n)} style={{ padding: "8px 16px", borderRadius: 8, border: "1.5px solid #d1d5db", background: "#f8fafc", color: "#374151", fontWeight: 700, fontSize: 13, cursor: "pointer" }}>{label}</button>
          ))}
          <button onClick={() => setShowCustom(s => !s)} style={{ padding: "8px 16px", borderRadius: 8, border: "1.5px solid #93c5fd", background: "#f0f9ff", color: "#1e40af", fontWeight: 700, fontSize: 13, cursor: "pointer" }}>📅 Pick Date</button>
        </div>
        {showCustom && (
          <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
            <input type="date" value={customDate} onChange={e => setCustomDate(e.target.value)} style={{ flex: 1, padding: "7px 10px", borderRadius: 7, border: "1.5px solid #93c5fd", fontSize: 13, outline: "none" }} />
            <button onClick={() => { if (customDate) onPush(customDate); }} style={{ padding: "7px 14px", borderRadius: 7, border: "none", background: "#1e3a5f", color: "#fff", fontWeight: 700, cursor: "pointer", fontSize: 13 }}>Set</button>
          </div>
        )}
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <button onClick={onCancel} style={{ padding: "8px 18px", borderRadius: 8, border: "1.5px solid #d1d5db", background: "#fff", cursor: "pointer", fontSize: 13 }}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

// ── EMAIL DROPDOWN ───────────────────────────────────────────────────────
function EmailDropdown({ emails }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ position: "relative" }}>
      <button onClick={() => setOpen(o => !o)} style={{ background: "#c9a84c", color: "#0f2644", border: "none", borderRadius: 7, padding: "7px 14px", fontWeight: 700, fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", gap: 6 }}>
        📧 Emails {open ? "▲" : "▼"}
      </button>
      {open && (
        <div style={{ position: "absolute", top: "calc(100% + 4px)", right: 0, background: "#fff", borderRadius: 10, boxShadow: "0 8px 30px rgba(0,0,0,0.15)", border: "1.5px solid #e5e7eb", zIndex: 200, minWidth: 260, overflow: "hidden" }}>
          {emails.map((email, idx) => (
            <a key={idx} href={email.href} onClick={() => { email.onLog && email.onLog(); setOpen(false); }}
              style={{ display: "block", padding: "10px 16px", fontSize: 13, fontWeight: 600, color: "#0f2644", textDecoration: "none", borderBottom: idx < emails.length - 1 ? "1px solid #f1f5f9" : "none" }}
              onMouseEnter={e => e.target.style.background = "#f8fafc"}
              onMouseLeave={e => e.target.style.background = "#fff"}
            >
              {email.label}
            </a>
          ))}
        </div>
      )}
    </div>
  );
}

// ── LOAN FILE ─────────────────────────────────────────────────────────────
function LoanFile({ loan: initialLoan, allTasks, onBack, onSave, onAddTask, onCompleteTask, onDeleteTask, onPushTask }) {
  const [loan, setLoan] = useState(initialLoan);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [showAddTask, setShowAddTask] = useState(false);
  const [snoozePrompt, setSnoozePrompt] = useState(null);
  const [manualCompletePrompt, setManualCompletePrompt] = useState(null);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const needsStatus = parse(loan.needs_status, buildDefaultNeedsStatus());
  const processorItems = parse(loan.processor_items, []);
  const conditions = parse(loan.conditions, []);
  const miscCustomItems = parse(loan.misc_custom_items, []);
  const loanTasks = allTasks.filter(t => t.loan_id === loan.id);

  function upd(field, value) { setLoan(l => ({ ...l, [field]: value })); }

  function buildPayload(l) {
    const DATE_FIELDS = ["closing_date","lock_expiration_date","pre_audit_cd_requested","pre_audit_cd_received","initial_needs_requested","initial_needs_received","initial_disclosures_requested","initial_disclosures_received","sent_to_setup_date","proc_needs_requested","proc_needs_received","submitted_to_uw_date","cd_requested_date","conditions_sent_date","conditions_received_date","appraisal_ordered_date","appraisal_due_date","appraisal_received_date","final_inspection_ordered_date","final_inspection_due_date","final_inspection_received_date","homeowners_insurance_ordered_date","homeowners_insurance_received_date","credit_supplement_ordered_date","credit_supplement_received_date","additional_title_docs_ordered_date","additional_title_docs_received_date","ibts_ordered_date","ibts_received_date","engineer_cert_ordered_date","engineer_cert_received_date","signing_date","funding_date","completion_date","contract_coe_date","wvoe_requested_date","wvoe_received_date","pvoe_requested_date","pvoe_received_date","flood_insurance_ordered_date","flood_insurance_received_date"];
    const cleaned = { ...l };
    DATE_FIELDS.forEach(f => { if (cleaned[f] === "" || cleaned[f] === undefined) cleaned[f] = null; });
    if (cleaned.loan_amount === "" || cleaned.loan_amount === undefined) cleaned.loan_amount = null;
    if (cleaned.interest_rate === "" || cleaned.interest_rate === undefined) cleaned.interest_rate = null;
    return {
      ...cleaned,
      needs_status: typeof cleaned.needs_status === "string" ? cleaned.needs_status : JSON.stringify(cleaned.needs_status),
      processor_items: typeof cleaned.processor_items === "string" ? cleaned.processor_items : JSON.stringify(cleaned.processor_items),
      conditions: typeof cleaned.conditions === "string" ? cleaned.conditions : JSON.stringify(cleaned.conditions),
      misc_custom_items: typeof cleaned.misc_custom_items === "string" ? cleaned.misc_custom_items : JSON.stringify(cleaned.misc_custom_items || []),
      additional_borrowers: typeof cleaned.additional_borrowers === "string" ? cleaned.additional_borrowers : JSON.stringify(cleaned.additional_borrowers || []),
    };
  }

  async function handleSave() {
    setSaving(true);
    await onSave(buildPayload(loan));
    setSaving(false); setSaved(true);
    setTimeout(() => setSaved(false), 2500);
  }

  async function handleBack() {
    setSaving(true);
    await onSave(buildPayload(loan));
    setSaving(false);
    onBack();
  }

  async function handleCompleteTaskWithSnooze(taskId) {
    const task = allTasks.find(t => t.id === taskId);
    if (!task) return;
    if (task.completed) { await onCompleteTask(taskId); return; }
    if (task.snooze_options) {
      setSnoozePrompt({ taskId, title: task.title });
      return;
    }
    // For manually created tasks, show follow up prompt
    setManualCompletePrompt({ taskId, title: task.title });
  }

  async function handleSnoozeChoice(taskId, days) {
    setSnoozePrompt(null);
    await onCompleteTask(taskId);
    if (days) {
      const task = allTasks.find(t => t.id === taskId);
      if (task) {
        await onAddTask({ title: task.title, assigned_to: task.assigned_to, due_date: safeTaskDate(addDays(todayStr(), days)), loan_id: task.loan_id, loan_name: task.loan_name, notes: task.notes, is_recurring: true, snooze_options: true });
      }
    }
  }

  function updateNeedsItem(item, val) { upd("needs_status", JSON.stringify({ ...needsStatus, [item]: val })); }

  // Check for automation triggers on date changes
  function handleSetupDateChange(field, value, receivedField, assignedTo, taskTitle, hoursDelay) {
    upd(field, value);
    if (value && !loan[receivedField]) {
      const dueDate = addDays(value, Math.ceil(hoursDelay / 24));
      onAddTask({ title: `Follow up: ${taskTitle}`, assigned_to: assignedTo, due_date: dueDate, loan_id: loan.id, loan_name: `${loan.borrower_last}, ${loan.borrower_first}`, notes: `Auto-generated follow up. Check if ${taskTitle} has been received.`, auto: true });
    }
  }

  // Email builders
  const borrowerFirst = loan.borrower_first || "";
  const borrowerLast = loan.borrower_last || "";

  function buildInitialRequestMailto() {
    const checkedItems = [];
    INITIAL_NEEDS.forEach(s => {
      const si = s.items.filter(item => needsStatus[item]?.checked && needsStatus[item]?.status === "Trailing");
      si.forEach(i => {
        const note = needsStatus[i]?.note;
        const includeNote = needsStatus[i]?.includeNoteInEmail;
        checkedItems.push(`  - ${i}${includeNote && note ? ` — ${note}` : ""}`);
      });
    });
    const customChecked = miscCustomItems.filter(ci => ci.checked && ci.text && ci.status === "Trailing");
    customChecked.forEach(ci => checkedItems.push(`  - ${ci.text}${ci.includeNoteInEmail && ci.note ? ` — ${ci.note}` : ""}`));
    const greeting = buildBorrowerGreeting() || borrowerFirst;
    const body = `Hello ${greeting},\n\nWe are so excited to work with you and truly grateful for the opportunity to help you through this process! To get things moving right away, we are going to need a few documents from you to get your file started.\n\nHere is what we need:\n${checkedItems.join("\n")}\n\nPlease get these over to us at your earliest convenience and do not hesitate to reach out if you have any questions or need help with anything at all. We are here every step of the way!\n\nThank you,`;
    const emails = [loan.borrower_email, loan.coborrower_email, ...parse(loan.additional_borrowers, []).map(b => b.email)].filter(Boolean).join(";");
    return `mailto:${emails}?cc=teamg%40gilavalleymtg.com&subject=${encodeURIComponent(`Welcome to Gila Valley Mortgage — Documents Needed — ${borrowerLast}`)}&body=${encodeURIComponent(body)}`;
  }

  function buildOutstandingMailto() {
    const needed = [];
    INITIAL_NEEDS.forEach(s => {
      const si = s.items.filter(item => { const st = needsStatus[item]?.status || needsStatus[item]; return st === "Trailing"; });
      si.forEach(i => {
        const note = needsStatus[i]?.note;
        const incNote = needsStatus[i]?.includeNoteInEmail;
        needed.push(`  - ${i}${incNote && note ? ` — ${note}` : ""}`);
      });
    });
    const outstanding = miscCustomItems.filter(ci => ci.text && ci.status === "Trailing");
    outstanding.forEach(ci => needed.push(`  - ${ci.text}${ci.includeNoteInEmail && ci.note ? ` — ${ci.note}` : ""}`));
    const trailingProcItems = processorItems.filter(i => i.status === "Trailing" && i.sendToClient !== false && i.text);
    trailingProcItems.forEach(i => needed.push(`  - ${i.text}`));
    const greetingOut = buildBorrowerGreeting() || borrowerFirst;
    const body = `Hello ${greetingOut},\n\nWe just wanted to check in on your file and let you know we are still waiting on a few items. We want to keep things moving forward for you so please send these over as soon as you are able!\n\nHere is what we still need:\n${needed.join("\n")}\n\nAs always, please reach out if you have any questions or need any help getting these together. We are happy to assist!\n\nThank you,`;
    const emailsOut = [loan.borrower_email, loan.coborrower_email, ...parse(loan.additional_borrowers, []).map(b => b.email)].filter(Boolean).join(";");
    return `mailto:${emailsOut}?cc=teamg%40gilavalleymtg.com&subject=${encodeURIComponent(`Documents Still Needed — ${borrowerLast}`)}&body=${encodeURIComponent(body)}`;
  }

  // ── EMAIL LOG HELPER ──────────────────────────────────────────────────
  function logEmail(type) {
    const emailLog = parse(loan.email_log, []);
    const entry = { id: Date.now(), type, date: todayStr() };
    upd("email_log", JSON.stringify([...emailLog, entry]));
  }

  // ── BORROWER NAME HELPERS ─────────────────────────────────────────────
  function buildBorrowerGreeting() {
    const names = [];
    if (loan.borrower_first) names.push(loan.borrower_first);
    if (loan.coborrower_first) names.push(loan.coborrower_first);
    const addl = parse(loan.additional_borrowers, []);
    addl.forEach(b => { if (b.first) names.push(b.first); });
    if (names.length === 0) return "";
    if (names.length === 1) return names[0];
    if (names.length === 2) return `${names[0]} and ${names[1]}`;
    return `${names.slice(0, -1).join(", ")}, and ${names[names.length - 1]}`;
  }

  function buildClientInfo() {
    const addl = parse(loan.additional_borrowers, []);
    const buildLine = (first, last, phone, email) => {
      const name = `${first || ""} ${last || ""}`.trim();
      return [name, phone, email].filter(Boolean).join(" | ");
    };
    const lines = [];
    if (loan.borrower_first || loan.borrower_last) lines.push(buildLine(loan.borrower_first, loan.borrower_last, loan.borrower_phone, loan.borrower_email));
    if (loan.coborrower_first || loan.coborrower_last) lines.push(buildLine(loan.coborrower_first, loan.coborrower_last, loan.coborrower_phone, loan.coborrower_email));
    addl.forEach(b => { if (b.first || b.last) lines.push(buildLine(b.first, b.last, b.phone, b.email)); });
    return lines.join("\n");
  }

  function buildTeamUpdateMailto() {
    const greeting = buildBorrowerGreeting() || borrowerFirst;
    const allBorrowerContact = buildClientInfo();
    // Collect ALL trailing items from all sections (with notes)
    const trailingItems = [];
    INITIAL_NEEDS.forEach(s => {
      s.items.filter(item => { const st = needsStatus[item]?.status || needsStatus[item]; return st === "Trailing"; }).forEach(item => {
        const note = needsStatus[item]?.note;
        trailingItems.push(`  - ${item}${note ? ` — ${note}` : ""}`);
      });
    });
    miscCustomItems.filter(ci => ci.text && ci.status === "Trailing").forEach(ci => trailingItems.push(`  - ${ci.text}${ci.note ? ` — ${ci.note}` : ""}`));
    processorItems.filter(i => i.status === "Trailing" && i.text).forEach(i => trailingItems.push(`  - ${i.text}${i.notes ? ` — ${i.notes}` : ""}`));
    conditions.filter(i => i.status === "Requested" && i.text).forEach(i => trailingItems.push(`  - ${i.text}${i.notes ? ` — ${i.notes}` : ""}`));
    const body = `Hi Team,\n\nHere is a status update on the ${borrowerLast} file for your review.\n\nBORROWER: ${greeting}\nLOAN STAGE: ${loan.loan_stage || "Not set"}\nLOAN TYPE: ${loan.loan_type || "Not set"} · ${loan.purchase_or_refi || ""}\nCONTRACT COE DATE: ${loan.contract_coe_date || "N/A"}\n\nCLIENT CONTACT:\n${allBorrowerContact}\n\nOUTSTANDING / TRAILING ITEMS:\n${trailingItems.length > 0 ? trailingItems.join("\n") : "  - None currently outstanding"}\n\nPlease review and let me know if you would like to add or remove anything before I send items to the client.\n\nThank you,\nPatricia Diaz\nLoan Processor — Gila Valley Mortgage`;
    return `mailto:teamg@gilavalleymtg.com?cc=teamg%40gilavalleymtg.com&subject=${encodeURIComponent(`File Update: ${borrowerLast} — ${loan.loan_stage || "Active"}`)}&body=${encodeURIComponent(body)}`;
  }

  function buildHomeownersInsuranceMailto() {
    const clientInfo = buildClientInfo();
    const body = `Hi,\n\nHope you are doing well! We are working on a mortgage loan for the client listed below and wanted to reach out to get their homeowners insurance in order.\n\nWe will need the following from you:\n\n  - Evidence of insurance reflecting the mortgagee clause and loan number (please note we are unable to accept a binder)\n  - Most recent replacement cost estimator for the policy\n  - Paid invoice or an invoice confirming the amount to be collected to pay the premium in full at closing\n\nWhen responding, please be sure to reply all so our entire team receives your response!\n\nClient Information:\n${clientInfo}\nProperty Address: ${loan.property_address || "TBD"}\nLoan #${loan.loan_number || "TBD"}\n\nThank you,`;
    return `mailto:?cc=teamg%40gilavalleymtg.com&subject=${encodeURIComponent(`Homeowners Insurance Request — ${borrowerLast} | ${loan.property_address || ""}`)}&body=${encodeURIComponent(body)}`;
  }

  function buildOutstandingTitleMailto() {
    const body = `Hi,\n\nHope you are having a great day! We are following up on our previous request for the ${borrowerLast} file and wanted to check in on the status of the outstanding title documents.\n\nWe are still waiting on the following:\n\n  - Title commitment dated within 60 days of closing (including 8.1 & 9.0 endorsement language and any applicable condo or PUD endorsement language)\n  - Property tax certification confirming the annual amount (if not included in the title commitment)\n  - 24-month chain of title (if providing copies of deeds please include any transfers outside this timeframe to ensure full 24-month coverage)\n  - Closing Protection Letter dated within 60 days of closing\n  - Wiring instructions\n  - Current E&O policy reflecting limited liability coverage of the greater of $1,000,000 or the loan amount\n  - Preliminary CD with your fees only along with a contact name, license number, and email address\n\nPlease reply all when responding so our whole team stays in the loop! And as always, do not hesitate to reach out if you need anything from us.\n\nThank you,`;
    return `mailto:?cc=teamg%40gilavalleymtg.com&subject=${encodeURIComponent(`Following Up — Title Documents Needed — ${borrowerLast}`)}&body=${encodeURIComponent(body)}`;
  }

  function buildPatriciaIntroMailto() {
    const greeting = buildBorrowerGreeting() || borrowerFirst;
    const needed = [];
    INITIAL_NEEDS.forEach(s => {
      s.items.filter(item => { const st = needsStatus[item]?.status || needsStatus[item]; return st === "Trailing"; }).forEach(i => needed.push(`  - ${i}`));
    });
    miscCustomItems.filter(ci => ci.text && ci.status === "Trailing").forEach(ci => needed.push(`  - ${ci.text}`));
    processorItems.filter(i => i.status === "Trailing" && i.text).forEach(i => needed.push(`  - ${i.text}`));
    const body = `Hello ${greeting},\n\nI hope you are doing well! My name is Patricia Diaz and I am the Loan Processor here at Gila Valley Mortgage working on your file. I just wanted to introduce myself and let you know I am here to help make this process as smooth as possible for you!\n\nAs I work through your file I am going to need a few items from you to keep things moving forward:\n${needed.join("\n") || "  - (No items currently marked as needed)"}\n\nWhen sending these over please be sure to reply all to this email as our entire team is copied and will be able to receive your documents right away. Do not hesitate to reach out with any questions — I am always happy to help!\n\nThank you,`;
    const emailsPatricia = [loan.borrower_email, loan.coborrower_email, ...parse(loan.additional_borrowers, []).map(b => b.email)].filter(Boolean).join(";");
    return `mailto:${emailsPatricia}?cc=teamg%40gilavalleymtg.com&subject=${encodeURIComponent(`Processing Items Needed — ${borrowerLast}`)}&body=${encodeURIComponent(body)}`;
  }

  function buildUWItemsMailto() {
    const greeting = buildBorrowerGreeting() || borrowerFirst;
    const needed = [];
    conditions.filter(i => i.status === "Requested" && i.checked !== false && i.text).forEach(i => needed.push(`  - ${i.text}${i.notes ? ` — ${i.notes}` : ""}`));
    const body = `Hello ${greeting},\n\nCongratulations! We are one step closer to closing! Our underwriter has had a chance to review your file and has come back with a few items they need from you. We know this can feel like a lot but we promise we are working hard to get you to the finish line as quickly as possible!\n\nHere is what they are asking for:\n${needed.join("\n") || "  - (No outstanding conditions)"}\n\nPlease reply all when sending these over so our whole team receives them right away. And as always, please do not hesitate to reach out with any questions — we are here every step of the way!\n\nThank you,`;
    const emailsUW = [loan.borrower_email, loan.coborrower_email, ...parse(loan.additional_borrowers, []).map(b => b.email)].filter(Boolean).join(";");
    return `mailto:${emailsUW}?cc=teamg%40gilavalleymtg.com&subject=${encodeURIComponent(`Items Needed from Underwriting Review — ${borrowerLast}`)}&body=${encodeURIComponent(body)}`;
  }

  function buildFollowUpMailto() {
    const needed = [];
    INITIAL_NEEDS.forEach(s => {
      const si = s.items.filter(item => { const st = needsStatus[item]?.status || needsStatus[item]; return st === "Trailing"; });
      si.forEach(i => {
        const note = needsStatus[i]?.note;
        const incNote = needsStatus[i]?.includeNoteInEmail;
        needed.push(`  - ${i}${incNote && note ? ` — ${note}` : ""}`);
      });
    });
    const outstanding = miscCustomItems.filter(ci => ci.text && ci.status === "Trailing");
    outstanding.forEach(ci => needed.push(`  - ${ci.text}${ci.includeNoteInEmail && ci.note ? ` — ${ci.note}` : ""}`));
    const trailingProcItems2 = processorItems.filter(i => i.status === "Trailing" && i.sendToClient !== false && i.text);
    trailingProcItems2.forEach(i => needed.push(`  - ${i.text}`));
    const greetingFu = buildBorrowerGreeting() || borrowerFirst;
    const body = `Hello ${greetingFu},\n\nWe wanted to follow up on our previous message regarding some outstanding documents on your file. We know life gets busy and we completely understand, but we want to make sure your loan stays on track and keeps moving forward!\n\nWe are still waiting on the following:\n${needed.join("\n")}\n\nPlease send these over as soon as you are able and do not hesitate to reach out with any questions. We are always happy to help and we are rooting for you every step of the way!\n\nThank you,`;
    const emailsFu = [loan.borrower_email, loan.coborrower_email, ...parse(loan.additional_borrowers, []).map(b => b.email)].filter(Boolean).join(";");
    return `mailto:${emailsFu}?cc=teamg%40gilavalleymtg.com&subject=${encodeURIComponent(`Following Up — Documents Still Needed — ${borrowerLast}`)}&body=${encodeURIComponent(body)}`;
  }

  function buildDisclosuresMailto() {
    const body = `Hello ${borrowerFirst},\n\nWe wanted to reach out and let you know that your initial disclosures are ready and waiting for your signature. These are time-sensitive documents and we kindly ask that you sign them as soon as possible to keep your loan moving forward on schedule.\n\nIf you have any questions about the disclosures or need assistance signing them, please do not hesitate to reach out to us.\n\nThank you so much for your prompt attention to this.\n\nWarm regards,\nGila Valley Mortgage Team`;
    return `mailto:?cc=teamg%40gilavalleymtg.com&subject=${encodeURIComponent(`Action Required: Please Sign Your Initial Disclosures - ${borrowerLast}`)}&body=${encodeURIComponent(body)}`;
  }

  function buildPreAuditMailto() {
    const addl = parse(loan.additional_borrowers, []);
    const buildContactLine = (first, last, phone, email) => {
      const name = `${first || ""} ${last || ""}`.trim();
      const parts = [name, phone, email].filter(Boolean);
      return parts.join(" | ");
    };
    const contactLines = [];
    if (loan.borrower_first || loan.borrower_last) contactLines.push(buildContactLine(loan.borrower_first, loan.borrower_last, loan.borrower_phone, loan.borrower_email));
    if (loan.coborrower_first || loan.coborrower_last) contactLines.push(buildContactLine(loan.coborrower_first, loan.coborrower_last, loan.coborrower_phone, loan.coborrower_email));
    addl.forEach(b => { if (b.first || b.last) contactLines.push(buildContactLine(b.first, b.last, b.phone, b.email)); });
    const clientInfo = contactLines.length > 0 ? `\n\nClient Contact Information:\n${contactLines.join("\n")}` : "";
    const body = `Hi,\n\nWe are excited to get started on the ${borrowerLast} file and hit the ground running! We are reaching out right away because we are on a tight timeline — our initial disclosures need to go out within 3 business days, so we need the Pre-Audit CD from you as soon as possible.\n\nCould you please send that over at your earliest convenience? We want to make sure we hit our deadline and keep everything moving smoothly for our mutual clients.${clientInfo ? `\n\nClient Contact Information:${clientInfo}` : ""}\n\nThank you so much and please do not hesitate to reach out if you need anything from us!\n\nThank you,`;
    return `mailto:?cc=teamg%40gilavalleymtg.com&subject=${encodeURIComponent(`Pre-Audit CD Needed — ${borrowerLast}`)}&body=${encodeURIComponent(body)}`;
  }

  function buildPreAuditFollowUpMailto() {
    const body = `Hi,\n\nWe just wanted to follow up on our previous message regarding the Pre-Audit CD for the ${borrowerLast} file. We are still waiting to receive it and our disclosure deadline is approaching quickly, so we want to make sure this does not slip through the cracks!\n\nIf there is anything you need from us to get that sent over, please let us know and we will take care of it right away. We really appreciate your help in keeping this one on track for our clients.\n\nThank you so much and we look forward to hearing from you soon!\n\nThank you,`;
    return `mailto:?cc=teamg%40gilavalleymtg.com&subject=${encodeURIComponent(`Following Up — Pre-Audit CD Needed — ${borrowerLast}`)}&body=${encodeURIComponent(body)}`;
  }

  const inp = { padding: "7px 12px", borderRadius: 7, border: "1.5px solid #d1d5db", fontSize: 14, outline: "none", width: "100%", boxSizing: "border-box" };
  const lbl = { fontSize: 12, fontWeight: 700, color: "#374151", display: "block", marginBottom: 4 };

  return (
    <div style={{ minHeight: "100vh", background: "#f8fafc" }}>
      {/* Top bar */}
      <div style={{ background: "linear-gradient(90deg, #0f2644 0%, #1e3a5f 100%)", padding: "14px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 100 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <button onClick={handleBack} style={{ background: "rgba(255,255,255,0.15)", border: "none", color: "#fff", borderRadius: 7, padding: "6px 14px", cursor: "pointer", fontSize: 13 }}>
            {saving ? "Saving..." : "← Dashboard"}
          </button>
          <div>
            <div style={{ color: "#fff", fontWeight: 800, fontSize: 16, display: "flex", alignItems: "center", gap: 10 }}>
              {loan.borrower_last}, {loan.borrower_first}{loan.coborrower_last ? ` & ${loan.coborrower_last}, ${loan.coborrower_first || ""}` : ""}
              {loan.loan_stage && (() => { const s = LOAN_STAGES.find(x => x.label === loan.loan_stage); return s ? <span style={{ background: s.bg, color: s.text, borderRadius: 5, padding: "2px 10px", fontSize: 11, fontWeight: 800 }}>{s.label}</span> : null; })()}
            </div>
            <div style={{ color: "#c9a84c", fontSize: 12 }}>{loan.property_address || "No address"} | Loan #{loan.loan_number || "TBD"}</div>
          </div>
        </div>
        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
          <EmailDropdown
            emails={[
              { label: "📋 Initial Needs List", href: buildInitialRequestMailto(), onLog: () => logEmail("Initial Needs List") },
              { label: "🏦 Pre-Audit CD", href: buildPreAuditMailto(), onLog: () => logEmail("Pre-Audit CD") },
              { label: "🏦 Pre-Audit CD Follow Up", href: buildPreAuditFollowUpMailto(), onLog: () => logEmail("Pre-Audit CD Follow Up") },
              { label: "✍️ Disclosures Reminder", href: buildDisclosuresMailto(), onLog: () => logEmail("Disclosures Reminder") },
              { label: "📧 Outstanding Items", href: buildOutstandingMailto(), onLog: () => logEmail("Outstanding Items") },
              { label: "📊 Team Update (Patricia)", href: buildTeamUpdateMailto(), onLog: () => logEmail("Team Update") },
              { label: "🔁 Follow Up", href: buildFollowUpMailto(), onLog: () => logEmail("Follow Up") },
              { label: "📦 Processing Items Request", href: buildPatriciaIntroMailto(), onLog: () => logEmail("Processing Items Request") },
              { label: "📝 Underwriting Items Request", href: buildUWItemsMailto(), onLog: () => logEmail("Underwriting Items Request") },
              { label: "🏠 Homeowners Insurance Request", href: buildHomeownersInsuranceMailto(), onLog: () => logEmail("Homeowners Insurance Request") },
              { label: "📄 Outstanding Title Docs", href: buildOutstandingTitleMailto(), onLog: () => logEmail("Outstanding Title Docs") },
            ]}
          />
          <button onClick={handleSave} style={{ background: saved ? "#d1fae5" : "#fff", color: saved ? "#065f46" : "#1e3a5f", border: `2px solid ${saved ? "#6ee7b7" : "#1e3a5f"}`, borderRadius: 7, padding: "7px 16px", fontWeight: 700, fontSize: 13, cursor: "pointer" }}>
            {saving ? "Saving..." : saved ? "✓ Saved" : "Save File"}
          </button>
        </div>
      </div>

      <div style={{ maxWidth: 920, margin: "0 auto", padding: "24px 20px" }}>

        {/* File Info */}
        <Section title="FILE INFORMATION" accent="#0f2644">
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
            <div><label style={lbl}>Borrower First Name</label><input style={inp} value={loan.borrower_first || ""} onChange={e => upd("borrower_first", e.target.value)} /></div>
            <div><label style={lbl}>Borrower Last Name</label><input style={inp} value={loan.borrower_last || ""} onChange={e => upd("borrower_last", e.target.value)} /></div>
            <div><label style={lbl}>Co-Borrower First Name</label><input style={inp} value={loan.coborrower_first || ""} onChange={e => upd("coborrower_first", e.target.value)} /></div>
            <div><label style={lbl}>Co-Borrower Last Name</label><input style={inp} value={loan.coborrower_last || ""} onChange={e => upd("coborrower_last", e.target.value)} /></div>
            <div style={{ gridColumn: "1 / -1" }}><label style={lbl}>Property Address</label><input style={inp} value={loan.property_address || ""} onChange={e => upd("property_address", e.target.value)} /></div>
            <div><label style={lbl}>Loan Number</label><input style={inp} value={loan.loan_number || ""} onChange={e => upd("loan_number", e.target.value)} /></div>
            <div>
              <label style={lbl}>Loan Stage</label>
              <select style={inp} value={loan.loan_stage || ""} onChange={e => {
                const newStage = e.target.value;
                upd("loan_stage", newStage);
                if (newStage === "Funded" && !loan.funding_date) {
                  upd("funding_date", todayStr());
                  onAddTask({ title: `Call ${loan.borrower_last} — closing document questions`, assigned_to: "alex", due_date: todayStr(), loan_id: loan.id, loan_name: `${loan.borrower_last}, ${loan.borrower_first}`, notes: "Auto: Call client on funding day." });
                  onAddTask({ title: `Call ${loan.borrower_last} — closing document questions`, assigned_to: "madison", due_date: todayStr(), loan_id: loan.id, loan_name: `${loan.borrower_last}, ${loan.borrower_first}`, notes: "Auto: Call client on funding day." });
                  onAddTask({ title: `40-day check in: ${loan.borrower_last}`, assigned_to: "alex", due_date: safeTaskDate(addDays(todayStr(), 40)), loan_id: loan.id, loan_name: `${loan.borrower_last}, ${loan.borrower_first}`, notes: "Auto: 40-day post-close check in." });
                  onAddTask({ title: `40-day check in: ${loan.borrower_last}`, assigned_to: "madison", due_date: safeTaskDate(addDays(todayStr(), 40)), loan_id: loan.id, loan_name: `${loan.borrower_last}, ${loan.borrower_first}`, notes: "Auto: 40-day post-close check in." });
                }
              }}>
                <option value="">Select Stage...</option>
                {LOAN_STAGES.map(s => <option key={s.label} value={s.label}>{s.label}</option>)}
              </select>
            </div>
            <div>
              <label style={lbl}>File Status</label>
              <select style={inp} value={loan.loan_status || "Active"} onChange={e => {
                const newStatus = e.target.value;
                upd("loan_status", newStatus);
                if (newStatus === "Withdrawn" || newStatus === "Denied") {
                  // Cancel lock expiration tasks
                  allTasks.filter(t => !t.completed && t.loan_id === loan.id && t.title && t.title.includes("Lock expiration")).forEach(t => onCompleteTask && onCompleteTask(t.id, true));
                  // Create 6 month touch base task for Alex and Madison
                  const dueDate = addDays(todayStr(), 180);
                  if (onAddTask) {
                    onAddTask({ title: `Touch base: ${loan.borrower_last} (${newStatus})`, assigned_to: "alex", due_date: dueDate, loan_id: loan.id, loan_name: `${loan.borrower_last}, ${loan.borrower_first}`, notes: `Auto: 6-month touch base after file marked ${newStatus}.` });
                    onAddTask({ title: `Touch base: ${loan.borrower_last} (${newStatus})`, assigned_to: "madison", due_date: dueDate, loan_id: loan.id, loan_name: `${loan.borrower_last}, ${loan.borrower_first}`, notes: `Auto: 6-month touch base after file marked ${newStatus}.` });
                  }
                }
              }}>
                <option value="Active">Active</option>
                <option value="Withdrawn">Withdrawn</option>
                <option value="Denied">Denied</option>
              </select>
            </div>
            <div><label style={lbl}>Closing Date</label><input type="date" style={inp} value={loan.closing_date || ""} onChange={e => upd("closing_date", e.target.value)} /></div>
            <div><label style={lbl}>Lock Expiration Date</label><input type="date" style={inp} value={loan.lock_expiration_date || ""} onChange={e => upd("lock_expiration_date", e.target.value)} /></div>
            {loan.purchase_or_refi !== "Refinance" && (
              <div><label style={lbl}>Purchase Contract COE Date</label><input type="date" style={inp} value={loan.contract_coe_date || ""} onChange={e => upd("contract_coe_date", e.target.value)} /></div>
            )}
            {loan.purchase_or_refi === "Refinance" && (
              <div><label style={lbl}>Payoff Lender</label><input style={inp} value={loan.payoff_lender || ""} onChange={e => upd("payoff_lender", e.target.value)} placeholder="Lender name for payoff order..." /></div>
            )}
            <div>
              <label style={lbl}>Loan Type</label>
              <select style={inp} value={loan.loan_type || ""} onChange={e => upd("loan_type", e.target.value)}>
                <option value="">Select...</option>
                {LOAN_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>
            <div>
              <label style={lbl}>Purchase or Refinance</label>
              <select style={inp} value={loan.purchase_or_refi || ""} onChange={e => upd("purchase_or_refi", e.target.value)}>
                <option value="">Select...</option>
                <option value="Purchase">Purchase</option>
                <option value="Refinance">Refinance</option>
              </select>
            </div>
            <div><label style={lbl}>Loan Amount</label><input type="number" style={inp} value={loan.loan_amount || ""} onChange={e => upd("loan_amount", e.target.value)} placeholder="$" /></div>
            <div>
              <label style={lbl}>Lead Source</label>
              <select style={inp} value={loan.lead_source || ""} onChange={e => upd("lead_source", e.target.value)}>
                <option value="">Select...</option>
                {LEAD_SOURCES.map(s => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
            <div><label style={lbl}>Interest Rate (%)</label><input type="number" step="0.001" style={inp} value={loan.interest_rate || ""} onChange={e => upd("interest_rate", e.target.value)} placeholder="e.g. 6.875" /></div>
            <div><label style={lbl}>Broker / Lender Name</label><input style={inp} value={loan.broker_lender_name || ""} onChange={e => upd("broker_lender_name", e.target.value)} placeholder="Lender or broker name..." /></div>
          </div>

          {/* Borrower contact info */}
          <div style={{ marginTop: 16, padding: "14px", background: "#f8fafc", borderRadius: 8, border: "1px solid #e5e7eb" }}>
            <div style={{ fontSize: 12, fontWeight: 800, color: "#c9a84c", letterSpacing: "0.06em", marginBottom: 10, textTransform: "uppercase" }}>Borrower Contact</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
              <div><label style={lbl}>Borrower Email</label><input style={inp} type="email" value={loan.borrower_email || ""} onChange={e => upd("borrower_email", e.target.value)} placeholder="email@example.com" /></div>
              <div><label style={lbl}>Borrower Phone</label><input style={inp} type="tel" value={loan.borrower_phone || ""} onChange={e => upd("borrower_phone", e.target.value)} placeholder="(555) 555-5555" /></div>
            </div>
          </div>

          {/* Co-Borrower 1 contact */}
          {(loan.coborrower_first || loan.coborrower_last) && (
            <div style={{ marginTop: 10, padding: "14px", background: "#f8fafc", borderRadius: 8, border: "1px solid #e5e7eb" }}>
              <div style={{ fontSize: 12, fontWeight: 800, color: "#c9a84c", letterSpacing: "0.06em", marginBottom: 10, textTransform: "uppercase" }}>Co-Borrower Contact</div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                <div><label style={lbl}>Co-Borrower Email</label><input style={inp} type="email" value={loan.coborrower_email || ""} onChange={e => upd("coborrower_email", e.target.value)} placeholder="email@example.com" /></div>
                <div><label style={lbl}>Co-Borrower Phone</label><input style={inp} type="tel" value={loan.coborrower_phone || ""} onChange={e => upd("coborrower_phone", e.target.value)} placeholder="(555) 555-5555" /></div>
              </div>
            </div>
          )}

          {/* Additional borrowers */}
          {(() => {
            const addl = parse(loan.additional_borrowers, []);
            return (
              <div style={{ marginTop: 10 }}>
                {addl.map((b, idx) => (
                  <div key={b.id} style={{ marginBottom: 10, padding: "14px", background: "#f8fafc", borderRadius: 8, border: "1px solid #e5e7eb" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                      <div style={{ fontSize: 12, fontWeight: 800, color: "#c9a84c", letterSpacing: "0.06em", textTransform: "uppercase" }}>Co-Borrower {idx + 2}</div>
                      <button onClick={() => upd("additional_borrowers", JSON.stringify(addl.filter(x => x.id !== b.id)))} style={{ background: "none", border: "none", color: "#dc2626", cursor: "pointer", fontSize: 18 }}>×</button>
                    </div>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                      <div><label style={lbl}>First Name</label><input style={inp} value={b.first || ""} onChange={e => { const u = addl.map(x => x.id === b.id ? { ...x, first: e.target.value } : x); upd("additional_borrowers", JSON.stringify(u)); }} /></div>
                      <div><label style={lbl}>Last Name</label><input style={inp} value={b.last || ""} onChange={e => { const u = addl.map(x => x.id === b.id ? { ...x, last: e.target.value } : x); upd("additional_borrowers", JSON.stringify(u)); }} /></div>
                      <div><label style={lbl}>Email</label><input style={inp} type="email" value={b.email || ""} onChange={e => { const u = addl.map(x => x.id === b.id ? { ...x, email: e.target.value } : x); upd("additional_borrowers", JSON.stringify(u)); }} placeholder="email@example.com" /></div>
                      <div><label style={lbl}>Phone</label><input style={inp} type="tel" value={b.phone || ""} onChange={e => { const u = addl.map(x => x.id === b.id ? { ...x, phone: e.target.value } : x); upd("additional_borrowers", JSON.stringify(u)); }} placeholder="(555) 555-5555" /></div>
                    </div>
                  </div>
                ))}
                {addl.length < 3 && (
                  <button onClick={() => upd("additional_borrowers", JSON.stringify([...addl, { id: Date.now() + Math.random(), first: "", last: "", email: "", phone: "" }]))} style={{ background: "#f0f9ff", color: "#1e40af", border: "1.5px solid #93c5fd", borderRadius: 7, padding: "6px 14px", fontSize: 13, cursor: "pointer", fontWeight: 600 }}>+ Add Co-Borrower</button>
                )}
              </div>
            );
          })()}

          <div style={{ marginTop: 14 }}><label style={lbl}>General Notes</label><textarea value={loan.general_notes || ""} onChange={e => upd("general_notes", e.target.value)} placeholder="General notes..." style={{ ...inp, height: 80, resize: "vertical" }} /></div>
        </Section>

        {/* Initial Needs List */}
        <Section title="INITIAL NEEDS LIST" accent="#1e3a5f">
          <p style={{ fontSize: 12, color: "#6b7280", marginBottom: 14, marginTop: 0 }}>Check items to include in the Initial Request email. Trailing items reveal a notes field. Items marked internal will not appear in client emails.</p>
          {INITIAL_NEEDS.map(section => (
            <div key={section.header} style={{ marginBottom: 18 }}>
              <div style={{ fontSize: 11, fontWeight: 800, color: "#c9a84c", letterSpacing: "0.08em", marginBottom: 8, textTransform: "uppercase" }}>{section.header}</div>
              {section.items.map(item => (
                <NeedsItemRow key={item} item={item} statusObj={needsStatus[item] || { status: "N/A", checked: false, note: "" }} onUpdate={val => updateNeedsItem(item, val)} />
              ))}
              {section.header === "MISC" && (
                <>
                  {miscCustomItems.map(ci => (
                    <div key={ci.id} style={{ marginBottom: 6 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "7px 10px", borderRadius: ci.status === "Trailing" ? "7px 7px 0 0" : 7, background: "#f8fafc", border: "1px solid #e5e7eb" }}>
                        <input type="checkbox" checked={ci.checked || false} onChange={e => { const u = miscCustomItems.map(x => x.id === ci.id ? { ...x, checked: e.target.checked } : x); upd("misc_custom_items", JSON.stringify(u)); }} style={{ width: 16, height: 16, cursor: "pointer", accentColor: "#1e3a5f" }} />
                        <input value={ci.text} onChange={e => { const u = miscCustomItems.map(x => x.id === ci.id ? { ...x, text: e.target.value } : x); upd("misc_custom_items", JSON.stringify(u)); }} placeholder="Custom item..." style={{ flex: 1, padding: "4px 8px", borderRadius: 5, border: "1px solid #d1d5db", fontSize: 13, outline: "none" }} />
                        <StatusButton options={STATUS_OPTS} value={ci.status || "N/A"} onChange={v => { const u = miscCustomItems.map(x => x.id === ci.id ? { ...x, status: v } : x); upd("misc_custom_items", JSON.stringify(u)); }} />
                        <button onClick={() => upd("misc_custom_items", JSON.stringify(miscCustomItems.filter(x => x.id !== ci.id)))} style={{ background: "none", border: "none", color: "#dc2626", cursor: "pointer", fontSize: 20, padding: "0 4px" }}>×</button>
                      </div>
                      {ci.status === "Trailing" && (
                        <div style={{ borderRadius: "0 0 7px 7px", border: "1px solid #fcd34d", borderTop: "none", background: "#fffbeb", padding: "6px 10px" }}>
                          <input value={ci.note || ""} onChange={e => { const u = miscCustomItems.map(x => x.id === ci.id ? { ...x, note: e.target.value } : x); upd("misc_custom_items", JSON.stringify(u)); }} placeholder="Trailing note..." style={{ width: "100%", padding: "5px 10px", borderRadius: 5, border: "1px solid #fcd34d", fontSize: 12, outline: "none", background: "#fff", boxSizing: "border-box" }} />
                        </div>
                      )}
                    </div>
                  ))}
                  <button onClick={() => upd("misc_custom_items", JSON.stringify([...miscCustomItems, { id: Date.now() + Math.random(), text: "", status: "N/A", checked: false, note: "" }]))} style={{ background: "#f0f9ff", color: "#1e40af", border: "1.5px solid #93c5fd", borderRadius: 7, padding: "6px 14px", fontSize: 13, cursor: "pointer", fontWeight: 600, marginTop: 6 }}>+ Add Item</button>
                </>
              )}
            </div>
          ))}
        </Section>

        {/* Initial Loan Set Up */}
        <Section title="INITIAL LOAN SET UP" accent="#1e3a5f">
          <p style={{ fontSize: 12, color: "#6b7280", marginBottom: 14, marginTop: 0 }}>Setting a requested date will auto-create a follow up task for Jordin every 24 hours until the received date is entered.</p>
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {[
              { req: "pre_audit_cd_requested", rec: "pre_audit_cd_received", label: "Pre-Audit CD" },
              { req: "initial_needs_requested", rec: "initial_needs_received", label: "Initial Needs List" },
              { req: "initial_disclosures_requested", rec: "initial_disclosures_received", label: "Initial Disclosures" },
            ].map(({ req, rec, label }) => (
              <div key={req} style={{ background: "#f8fafc", borderRadius: 8, padding: "12px 14px", border: "1px solid #e5e7eb" }}>
                <div style={{ fontWeight: 700, fontSize: 13, color: "#0f2644", marginBottom: 8 }}>{label}</div>
                <div style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
                  <DateField label="Requested:" value={loan[req] || ""} onChange={v => handleSetupDateChange(req, v, rec, "jordin", label, 24)} />
                  <DateField label="Received:" value={loan[rec] || ""} onChange={v => upd(rec, v)} accent="#065f46" />
                </div>
              </div>
            ))}
            {/* Appraisal */}
            <div style={{ background: "#f8fafc", borderRadius: 8, padding: "12px 14px", border: "1px solid #e5e7eb" }}>
              <div style={{ fontWeight: 700, fontSize: 13, color: "#0f2644", marginBottom: 8 }}>Appraisal</div>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
                <input type="checkbox" id="delay_appraisal" checked={loan.delay_appraisal || false} onChange={e => upd("delay_appraisal", e.target.checked)} style={{ width: 15, height: 15, cursor: "pointer", accentColor: "#1e3a5f" }} />
                <label htmlFor="delay_appraisal" style={{ fontSize: 13, fontWeight: 600, color: "#374151", cursor: "pointer" }}>Delay Appraisal</label>
              </div>
              {loan.delay_appraisal && (
                <div style={{ marginBottom: 10 }}>
                  <input value={loan.delay_appraisal_reason || ""} onChange={e => upd("delay_appraisal_reason", e.target.value)} placeholder="Reason for delaying appraisal..." style={{ width: "100%", padding: "6px 10px", borderRadius: 6, border: "1px solid #fcd34d", background: "#fffbeb", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
                </div>
              )}
              {!loan.delay_appraisal && (
                <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
                  <DateField label="Ordered:" value={loan.appraisal_ordered_date || ""} onChange={v => upd("appraisal_ordered_date", v)} />
                  <DateField label="Due:" value={loan.appraisal_due_date || ""} onChange={v => {
                    upd("appraisal_due_date", v);
                    if (v && !loan.appraisal_received_date) {
                      const followUp = nextBusinessDay(v);
                      onAddTask({ title: `Follow up: Appraisal due — ${loan.borrower_last}`, assigned_to: "patricia", due_date: followUp, loan_id: loan.id, loan_name: `${loan.borrower_last}, ${loan.borrower_first}`, notes: `Auto: Appraisal was due ${v}. Follow up if not received.`, is_recurring: true, snooze_options: true });
                    }
                  }} />
                  <DateField label="Received:" value={loan.appraisal_received_date || ""} onChange={v => {
                    upd("appraisal_received_date", v);
                    if (v) {
                      const val = window.prompt("Appraisal received! What is the appraised value?", loan.appraised_value || "");
                      if (val !== null) upd("appraised_value", val);
                    }
                  }} accent="#065f46" />
                  {loan.appraised_value && (
                    <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 4 }}>
                      <span style={{ fontSize: 12, fontWeight: 700, color: "#065f46" }}>Appraised Value: ${loan.appraised_value}</span>
                      <button onClick={() => { const val = window.prompt("Update appraised value:", loan.appraised_value || ""); if (val !== null) upd("appraised_value", val); }} style={{ background: "none", border: "none", color: "#6b7280", cursor: "pointer", fontSize: 11 }}>edit</button>
                    </div>
                  )}
                </div>
              )}
            </div>
            {/* WVOE */}
            <div style={{ background: "#f8fafc", borderRadius: 8, padding: "12px 14px", border: "1px solid #e5e7eb" }}>
              <div style={{ fontWeight: 700, fontSize: 13, color: "#0f2644", marginBottom: 8 }}>WVOE (Written Verification of Employment)</div>
              <div style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
                <DateField label="Requested:" value={loan.wvoe_requested_date || ""} onChange={v => {
                  upd("wvoe_requested_date", v);
                  if (v && !loan.wvoe_received_date) {
                    onAddTask({ title: `Follow up: WVOE — ${loan.borrower_last}`, assigned_to: "patricia", due_date: safeTaskDate(addDays(v, 2)), loan_id: loan.id, loan_name: `${loan.borrower_last}, ${loan.borrower_first}`, notes: "Auto: Follow up on WVOE if not received.", is_recurring: true, snooze_options: true });
                  }
                }} />
                <DateField label="Received:" value={loan.wvoe_received_date || ""} onChange={v => upd("wvoe_received_date", v)} accent="#065f46" />
              </div>
            </div>
            {/* PVOE */}
            <div style={{ background: "#f8fafc", borderRadius: 8, padding: "12px 14px", border: "1px solid #e5e7eb" }}>
              <div style={{ fontWeight: 700, fontSize: 13, color: "#0f2644", marginBottom: 8 }}>PVOE (Phone Verification of Employment)</div>
              <div style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
                <DateField label="Requested:" value={loan.pvoe_requested_date || ""} onChange={v => {
                  upd("pvoe_requested_date", v);
                  if (v && !loan.pvoe_received_date) {
                    onAddTask({ title: `Follow up: PVOE — ${loan.borrower_last}`, assigned_to: "patricia", due_date: safeTaskDate(addDays(v, 2)), loan_id: loan.id, loan_name: `${loan.borrower_last}, ${loan.borrower_first}`, notes: "Auto: Follow up on PVOE if not received.", is_recurring: true, snooze_options: true });
                  }
                }} />
                <DateField label="Received:" value={loan.pvoe_received_date || ""} onChange={v => upd("pvoe_received_date", v)} accent="#065f46" />
              </div>
            </div>
            <div style={{ background: "#f8fafc", borderRadius: 8, padding: "12px 14px", border: "1px solid #e5e7eb" }}>
              <DateField label="Sent to Set Up:" value={loan.sent_to_setup_date || ""} onChange={v => {
                if (v) {
                  // Hard stop: check for trailing items with no notes
                  const missingNotes = [];
                  INITIAL_NEEDS.forEach(s => {
                    s.items.forEach(item => {
                      const statusObj = needsStatus[item];
                      const st = statusObj?.status || statusObj;
                      const note = statusObj?.note || "";
                      if (st === "Trailing" && !note.trim()) missingNotes.push(item);
                    });
                  });
                  miscCustomItems.forEach(ci => { if (ci.status === "Trailing" && !ci.note?.trim()) missingNotes.push(ci.text); });
                  processorItems.forEach(i => { if (i.status === "Trailing" && !i.notes?.trim()) missingNotes.push(i.text); });
                  if (missingNotes.length > 0) {
                    alert(`Cannot set "Sent to Set Up" — the following Trailing items are missing notes:\n\n${missingNotes.filter(Boolean).map(n => `• ${n}`).join("\n")}\n\nPlease add notes explaining the trailing status before setting this date.`);
                    return;
                  }
                  // Auto-advance stage to Set Up if not already further along
                  const stageOrder = LOAN_STAGES.map(s => s.label);
                  const currentIdx = stageOrder.indexOf(loan.loan_stage || "Loan Open");
                  const setupIdx = stageOrder.indexOf("Set Up");
                  if (currentIdx < setupIdx) upd("loan_stage", "Set Up");
                }
                upd("sent_to_setup_date", v);
              }} />
            </div>
          </div>
        </Section>


        {/* Processing Items Needed */}
        <Section title="PROCESSING ITEMS NEEDED" accent="#374151">
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            {/* Patricia Reviewed checkbox */}
          <div style={{ background: "#f0f9ff", borderRadius: 8, padding: "12px 14px", border: "1.5px solid #93c5fd", marginBottom: 8 }}>
            <label style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer" }}>
              <input type="checkbox" checked={loan.patricia_reviewed || false} onChange={e => {
                upd("patricia_reviewed", e.target.checked);
                if (e.target.checked && !loan.proc_needs_requested) {
                  onAddTask({ title: `Patricia: Send processing needs list — ${loan.borrower_last}`, assigned_to: "patricia", due_date: safeTaskDate(addDays(todayStr(), 1)), loan_id: loan.id, loan_name: `${loan.borrower_last}, ${loan.borrower_first}`, notes: "Auto: Patricia has reviewed file. Follow up to send processing needs list.", is_recurring: true, snooze_options: true });
                }
              }} style={{ width: 16, height: 16, accentColor: "#1e40af", cursor: "pointer" }} />
              <span style={{ fontSize: 13, fontWeight: 700, color: "#1e40af" }}>✓ Patricia has reviewed this file</span>
            </label>
            {loan.patricia_reviewed && !loan.proc_needs_requested && (
              <div style={{ fontSize: 11, color: "#1e40af", marginTop: 6, marginLeft: 26 }}>Follow up task created — will repeat every 24 hours until Processing Needs List is sent</div>
            )}
          </div>
          <div style={{ background: "#f8fafc", borderRadius: 8, padding: "12px 14px", border: "1px solid #e5e7eb" }}>
              <div style={{ display: "flex", gap: 20, flexWrap: "wrap", marginBottom: 8 }}>
                <DateField label="Processing Needs List Requested:" value={loan.proc_needs_requested || ""}
                  onChange={v => { upd("proc_needs_requested", v); if (v && !loan.proc_needs_received) { onAddTask({ title: "Follow up: Processing Needs List", assigned_to: "patricia", due_date: safeTaskDate(addDays(v, 2)), loan_id: loan.id, loan_name: `${loan.borrower_last}, ${loan.borrower_first}`, notes: "Auto-generated. Follow up if processing needs list has not been received.", auto: true }); } }} />
                <DateField label="Received:" value={loan.proc_needs_received || ""} onChange={v => upd("proc_needs_received", v)} accent="#065f46" />
              </div>
            </div>
            <FreeformList items={processorItems} onChange={items => upd("processor_items", JSON.stringify(items))} statusOptions={STATUS_OPTS} withClientToggle={true} withCheckbox={true} placeholder="Add item needed..." />
            <div>
              <label style={lbl}>Processing Notes</label>
              <textarea value={loan.processing_notes || ""} onChange={e => upd("processing_notes", e.target.value)} placeholder="Processing notes..." style={{ ...inp, height: 80, resize: "vertical" }} />
            </div>
          </div>
        </Section>

        {/* Underwriting */}
        <Section title="UNDERWRITING" accent="#1e3a5f">
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <DateField label="Submitted to Underwriting:" value={loan.submitted_to_uw_date || ""} onChange={v => {
              upd("submitted_to_uw_date", v);
              if (v) {
                const stageOrder = LOAN_STAGES.map(s => s.label);
                const currentIdx = stageOrder.indexOf(loan.loan_stage || "Loan Open");
                const uwIdx = stageOrder.indexOf("Underwriting");
                if (currentIdx < uwIdx) upd("loan_stage", "Underwriting");
              }
            }} />
            <div style={{ background: "#f8fafc", borderRadius: 8, padding: "12px 14px", border: "1px solid #e5e7eb" }}>
              <div style={{ fontWeight: 700, fontSize: 13, color: "#0f2644", marginBottom: 8 }}>Conditions</div>
              <div style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
                <DateField label="Conditions Sent:" value={loan.conditions_sent_date || ""} onChange={v => {
                  upd("conditions_sent_date", v);
                  if (v && !loan.conditions_received_date) {
                    const due = addDays(v, 2);
                    onAddTask({ title: `Follow up: Conditions received — ${loan.borrower_last}`, assigned_to: "patricia", due_date: due, loan_id: loan.id, loan_name: `${loan.borrower_last}, ${loan.borrower_first}`, notes: "Auto: Follow up if conditions not yet received.", is_recurring: true, snooze_options: true });
                  }
                }} />
                <DateField label="Conditions Received:" value={loan.conditions_received_date || ""} onChange={v => upd("conditions_received_date", v)} accent="#065f46" />
              </div>
            </div>
            <div>
              <div style={{ fontSize: 13, fontWeight: 700, color: "#374151", marginBottom: 8 }}>Underwriting Conditions</div>
              <FreeformList items={conditions} onChange={items => upd("conditions", JSON.stringify(items))} statusOptions={COND_STATUS_OPTS} withNotes={true} withCheckbox={true} withClientToggle={true} defaultChecked={true} placeholder="Type or paste condition..." />
            </div>
            <div>
              <label style={lbl}>Underwriting Notes</label>
              <textarea value={loan.uw_notes || ""} onChange={e => upd("uw_notes", e.target.value)} placeholder="Underwriting notes..." style={{ ...inp, height: 80, resize: "vertical" }} />
            </div>
          </div>
        </Section>

        {/* Closing Disclosure */}
        <Section title="CLOSING DISCLOSURE" accent="#374151">
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <DateField label="CD Requested:" value={loan.cd_requested_date || ""} onChange={v => upd("cd_requested_date", v)} accent="#374151" />
            <div>
              <label style={lbl}>CD Notes</label>
              <textarea value={loan.cd_notes || ""} onChange={e => upd("cd_notes", e.target.value)} placeholder="Notes on closing disclosure..." style={{ ...inp, height: 70, resize: "vertical" }} />
            </div>
          </div>
        </Section>

        {/* Final Inspection */}
        <Section title="ARE THESE ITEMS REQUIRED?" accent="#1e3a5f">
          <p style={{ fontSize: 12, color: "#6b7280", marginBottom: 14, marginTop: 0 }}>
            Toggle Yes for any required items. Ordered and received dates will appear. Patricia receives 48-hour follow up tasks until each received date is entered.
          </p>
          {[
            { key: "final_inspection", label: "Final Inspection", hasDue: true },
            { key: "homeowners_insurance", label: "Homeowners Insurance", hasDue: false },
            { key: "flood_insurance", label: "Flood Insurance", hasDue: false },
            { key: "credit_supplement", label: "Credit Supplement", hasDue: false },
            { key: "ibts", label: "IBTS", hasDue: false },
            { key: "engineer_cert", label: "Engineer Certificate", hasDue: false },
          ].map(({ key, label, hasDue, questionLabel }) => {
            const reqKey = `${key}_required`;
            const ordKey = `${key}_ordered_date`;
            const dueKey = `${key}_due_date`;
            const recKey = `${key}_received_date`;
            const noteKey = `${key}_notes`;
            const isRequired = loan[reqKey] === "Yes";
            return (
              <div key={key} style={{ marginBottom: 12, background: "#f8fafc", borderRadius: 8, padding: "12px 14px", border: "1px solid #e5e7eb" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <span style={{ fontSize: 13, fontWeight: 700, color: "#0f2644" }}>{questionLabel || label}</span>
                  <div style={{ display: "flex", gap: 8 }}>
                    {["Yes", "No"].map(opt => (
                      <button key={opt} onClick={() => upd(reqKey, loan[reqKey] === opt ? "" : opt)} style={{ padding: "4px 16px", borderRadius: 7, border: `1.5px solid ${loan[reqKey] === opt ? (opt === "Yes" ? "#1e3a5f" : "#6b7280") : "#d1d5db"}`, background: loan[reqKey] === opt ? (opt === "Yes" ? "#1e3a5f" : "#6b7280") : "#fff", color: loan[reqKey] === opt ? "#fff" : "#374151", fontWeight: 700, fontSize: 12, cursor: "pointer" }}>{opt}</button>
                    ))}
                  </div>
                </div>
                {isRequired && (
                  <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 10 }}>
                    <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
                      <DateField label="Ordered:" value={loan[ordKey] || ""} onChange={v => {
                        upd(ordKey, v);
                        if (v && !loan[recKey]) {
                          onAddTask({ title: `Follow up: ${label} — ${loan.borrower_last}`, assigned_to: "patricia", due_date: safeTaskDate(addDays(v, 2)), loan_id: loan.id, loan_name: `${loan.borrower_last}, ${loan.borrower_first}`, notes: `Auto: Follow up on ${label} if not received.`, is_recurring: true, snooze_options: true });
                        }
                      }} />
                      {hasDue && (
                        <DateField label="Due:" value={loan[dueKey] || ""} onChange={v => {
                          upd(dueKey, v);
                          if (v && !loan[recKey]) {
                            onAddTask({ title: `Follow up: ${label} due — ${loan.borrower_last}`, assigned_to: "patricia", due_date: nextBusinessDay(v), loan_id: loan.id, loan_name: `${loan.borrower_last}, ${loan.borrower_first}`, notes: `Auto: ${label} was due ${v}. Follow up if not received.`, is_recurring: true, snooze_options: true });
                          }
                        }} />
                      )}
                      <DateField label="Received:" value={loan[recKey] || ""} onChange={v => upd(recKey, v)} accent="#065f46" />
                    </div>
                    <input value={loan[noteKey] || ""} onChange={e => upd(noteKey, e.target.value)} placeholder={`Notes on ${label}...`} style={{ width: "100%", padding: "6px 10px", borderRadius: 6, border: "1px solid #d1d5db", fontSize: 12, outline: "none", boxSizing: "border-box" }} />
                  </div>
                )}
              </div>
            );
          })}

          {/* Custom additional requirement items */}
          {(() => {
            const customReqs = parse(loan.custom_requirements, []);
            return (
              <div>
                {customReqs.map(item => {
                  const isReq = item.required === "Yes";
                  return (
                    <div key={item.id} style={{ marginBottom: 12, background: "#f8fafc", borderRadius: 8, padding: "12px 14px", border: "1px solid #e5e7eb" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: isReq ? 10 : 0 }}>
                        <input value={item.label} onChange={e => {
                          const u = customReqs.map(x => x.id === item.id ? { ...x, label: e.target.value } : x);
                          upd("custom_requirements", JSON.stringify(u));
                        }} placeholder="Item name..." style={{ flex: 1, padding: "5px 10px", borderRadius: 6, border: "1px solid #d1d5db", fontSize: 13, outline: "none" }} />
                        {["Yes", "No"].map(opt => (
                          <button key={opt} onClick={() => {
                            const newVal = item.required === opt ? "" : opt;
                            const u = customReqs.map(x => x.id === item.id ? { ...x, required: newVal } : x);
                            upd("custom_requirements", JSON.stringify(u));
                            if (newVal === "Yes" && item.label) {
                              onAddTask({ title: `Follow up: ${item.label} — ${loan.borrower_last}`, assigned_to: "patricia", due_date: safeTaskDate(addDays(todayStr(), 2)), loan_id: loan.id, loan_name: `${loan.borrower_last}, ${loan.borrower_first}`, notes: `Auto: Follow up on ${item.label} if not received.`, is_recurring: true, snooze_options: true });
                            }
                          }} style={{ padding: "4px 14px", borderRadius: 7, border: `1.5px solid ${item.required === opt ? (opt === "Yes" ? "#1e3a5f" : "#6b7280") : "#d1d5db"}`, background: item.required === opt ? (opt === "Yes" ? "#1e3a5f" : "#6b7280") : "#fff", color: item.required === opt ? "#fff" : "#374151", fontWeight: 700, fontSize: 12, cursor: "pointer" }}>{opt}</button>
                        ))}
                        <button onClick={() => upd("custom_requirements", JSON.stringify(customReqs.filter(x => x.id !== item.id)))} style={{ background: "none", border: "none", color: "#dc2626", cursor: "pointer", fontSize: 18, padding: "0 4px" }}>×</button>
                      </div>
                      {isReq && (
                        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                          <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
                            <DateField label="Ordered:" value={item.ordered_date || ""} onChange={v => { const u = customReqs.map(x => x.id === item.id ? { ...x, ordered_date: v } : x); upd("custom_requirements", JSON.stringify(u)); }} />
                            <DateField label="Received:" value={item.received_date || ""} onChange={v => { const u = customReqs.map(x => x.id === item.id ? { ...x, received_date: v } : x); upd("custom_requirements", JSON.stringify(u)); }} accent="#065f46" />
                          </div>
                          <input value={item.notes || ""} onChange={e => { const u = customReqs.map(x => x.id === item.id ? { ...x, notes: e.target.value } : x); upd("custom_requirements", JSON.stringify(u)); }} placeholder="Notes..." style={{ width: "100%", padding: "6px 10px", borderRadius: 6, border: "1px solid #d1d5db", fontSize: 12, outline: "none", boxSizing: "border-box" }} />
                        </div>
                      )}
                    </div>
                  );
                })}
                <button onClick={() => {
                  const newItem = { id: Date.now() + Math.random(), label: "", required: "", ordered_date: "", received_date: "", notes: "" };
                  upd("custom_requirements", JSON.stringify([...customReqs, newItem]));
                }} style={{ background: "#f0f9ff", color: "#1e40af", border: "1.5px solid #93c5fd", borderRadius: 7, padding: "6px 14px", fontSize: 13, cursor: "pointer", fontWeight: 600, marginTop: 4 }}>+ Add Item</button>
              </div>
            );
          })()}
        </Section>

        {/* Signing & Funding */}
        <Section title="SIGNING AND FUNDING" accent="#0f2644">
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <DateField label="Signing Date:" value={loan.signing_date || ""} onChange={v => upd("signing_date", v)} accent="#0f2644" />
            <DateField label="Funding Date:" value={loan.funding_date || ""} onChange={v => {
              upd("funding_date", v);
              if (v) {
                onAddTask({ title: `Call ${loan.borrower_last} — closing document questions`, assigned_to: "alex", due_date: v, loan_id: loan.id, loan_name: `${loan.borrower_last}, ${loan.borrower_first}`, notes: "Auto: Call client on funding day to check for closing document questions.", shared_with: "madison", auto: true });
                onAddTask({ title: `Call ${loan.borrower_last} — closing document questions`, assigned_to: "madison", due_date: v, loan_id: loan.id, loan_name: `${loan.borrower_last}, ${loan.borrower_first}`, notes: "Auto: Call client on funding day to check for closing document questions.", shared_key: loan.id + "_funding_call_" + v, auto: true });
                onAddTask({ title: `40-day check in: ${loan.borrower_last}`, assigned_to: "alex", due_date: safeTaskDate(addDays(v, 40)), loan_id: loan.id, loan_name: `${loan.borrower_last}, ${loan.borrower_first}`, notes: "Auto: 40-day post-close check in call.", shared_with: "madison", auto: true });
                onAddTask({ title: `40-day check in: ${loan.borrower_last}`, assigned_to: "madison", due_date: safeTaskDate(addDays(v, 40)), loan_id: loan.id, loan_name: `${loan.borrower_last}, ${loan.borrower_first}`, notes: "Auto: 40-day post-close check in call.", auto: true });
              }
            }} accent="#0f2644" />
          </div>
          {loan.funding_date && <div style={{ marginTop: 12, padding: "10px 14px", background: "#d1fae5", borderRadius: 8, fontSize: 13, fontWeight: 700, color: "#065f46" }}>🎉 This loan has funded and will appear in the Closed / Funded tab.</div>}
        </Section>

        {/* Tasks in this file */}
        <Section title="CONVERSATION LOG" accent="#0f2644" defaultOpen={false}>
          <ConversationLog
            entries={parse(loan.conversation_log, [])}
            onChange={entries => upd("conversation_log", JSON.stringify(entries))}
          />
        </Section>

        <Section title="EMAIL LOG" accent="#374151" defaultOpen={false}>
          {(() => {
            const emailLog = parse(loan.email_log, []);
            return emailLog.length === 0 ? (
              <p style={{ fontSize: 13, color: "#9ca3af", margin: 0 }}>No emails logged yet. Emails are logged automatically when you send them from the Emails dropdown.</p>
            ) : (
              <div>
                {[...emailLog].reverse().map((entry, idx) => (
                  <div key={idx} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderBottom: idx < emailLog.length - 1 ? "1px solid #f1f5f9" : "none" }}>
                    <span style={{ fontSize: 13, color: "#374151" }}>📧 {entry.type}</span>
                    <span style={{ fontSize: 12, color: "#6b7280" }}>{entry.date}</span>
                  </div>
                ))}
              </div>
            );
          })()}
        </Section>

        <Section title="FILE TASKS" accent="#374151">
          <div style={{ marginBottom: 12 }}>
            {loanTasks.filter(t => !t.completed).length === 0 ? (
              <p style={{ fontSize: 13, color: "#9ca3af", marginTop: 0 }}>No open tasks for this file.</p>
            ) : (
              loanTasks.filter(t => !t.completed).map(task => <TaskBadge key={task.id} task={task} onComplete={handleCompleteTaskWithSnooze} onPush={onPushTask} onReassign={onPushTask} />)
            )}
            {loanTasks.filter(t => t.completed).length > 0 && (
              <details style={{ marginTop: 8 }}>
                <summary style={{ cursor: "pointer", fontSize: 12, color: "#6b7280" }}>Show completed ({loanTasks.filter(t => t.completed).length})</summary>
                {loanTasks.filter(t => t.completed).map(task => <TaskBadge key={task.id} task={task} onComplete={handleCompleteTaskWithSnooze} onPush={onPushTask} onReassign={onPushTask} />)}
              </details>
            )}
          </div>
          <button onClick={() => setShowAddTask(true)} style={{ background: "#f0f9ff", color: "#1e40af", border: "1.5px solid #93c5fd", borderRadius: 7, padding: "6px 14px", fontSize: 13, cursor: "pointer", fontWeight: 600 }}>+ Add Task to This File</button>
        </Section>

      </div>
      {showAddTask && <AddTaskModal loans={[loan]} onSave={task => { onAddTask({ ...task, loan_name: `${loan.borrower_last}, ${loan.borrower_first}` }); setShowAddTask(false); }} onCancel={() => setShowAddTask(false)} defaultLoanId={loan.id} />}
      {/* Floating bottom action bar */}
      <div style={{ position: "fixed", bottom: 0, left: 0, right: 0, background: "linear-gradient(90deg, #0f2644 0%, #1e3a5f 100%)", padding: "10px 24px", display: "flex", justifyContent: "space-between", alignItems: "center", zIndex: 99, boxShadow: "0 -2px 10px rgba(0,0,0,0.15)" }}>
        <button onClick={handleBack} style={{ background: "rgba(255,255,255,0.15)", border: "none", color: "#fff", borderRadius: 7, padding: "8px 18px", cursor: "pointer", fontSize: 13, fontWeight: 600 }}>
          {saving ? "Saving..." : "← Dashboard"}
        </button>
        <button onClick={handleSave} style={{ background: saved ? "#d1fae5" : "#c9a84c", color: saved ? "#065f46" : "#0f2644", border: "none", borderRadius: 7, padding: "8px 20px", fontWeight: 800, fontSize: 13, cursor: "pointer" }}>
          {saving ? "Saving..." : saved ? "✓ Saved" : "Save File"}
        </button>
      </div>
      {/* Spacer so floating bar doesn't cover content */}
      <div style={{ height: 60 }} />

      {snoozePrompt && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }}>
          <div style={{ background: "#fff", borderRadius: 14, padding: "32px", width: 420, boxShadow: "0 20px 60px rgba(0,0,0,0.2)", textAlign: "center" }}>
            <div style={{ fontSize: 24, marginBottom: 8 }}>📋</div>
            <h3 style={{ margin: "0 0 6px", color: "#0f2644", fontSize: 16, fontWeight: 800 }}>Follow Up Complete</h3>
            <p style={{ fontSize: 13, color: "#6b7280", margin: "0 0 20px" }}>When should the next follow up be?</p>
            <div style={{ display: "flex", gap: 8, justifyContent: "center", flexWrap: "wrap" }}>
              {[[2,"48 Hours","#1e3a5f","#fff"],[5,"5 Days","#374151","#fff"],[7,"7 Days","#4b5563","#fff"],[10,"10 Days","#6b7280","#fff"],[null,"Done — No Follow Up","#f1f5f9","#374151"]].map(([days,label,bg,color]) => (
                <button key={label} onClick={() => handleSnoozeChoice(snoozePrompt.taskId, days)} style={{ padding: "8px 14px", borderRadius: 8, border: "none", background: bg, color, fontWeight: 700, fontSize: 13, cursor: "pointer" }}>{label}</button>
              ))}
            </div>
          </div>
        </div>
      )}
      {manualCompletePrompt && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }}>
          <div style={{ background: "#fff", borderRadius: 14, padding: "32px", width: 420, boxShadow: "0 20px 60px rgba(0,0,0,0.2)", textAlign: "center" }}>
            <div style={{ fontSize: 24, marginBottom: 8 }}>✅</div>
            <h3 style={{ margin: "0 0 6px", color: "#0f2644", fontSize: 16, fontWeight: 800 }}>Task Complete!</h3>
            <p style={{ fontSize: 13, color: "#6b7280", margin: "0 0 20px" }}>Would you like to set a follow up?</p>
            <div style={{ display: "flex", gap: 8, justifyContent: "center", flexWrap: "wrap" }}>
              {[[1,"1 Day","#1e3a5f","#fff"],[2,"2 Days","#374151","#fff"],[3,"3 Days","#4b5563","#fff"],[null,"No Follow Up","#f1f5f9","#374151"]].map(([days,label,bg,color]) => (
                <button key={label} onClick={async () => {
                  setManualCompletePrompt(null);
                  await onCompleteTask(manualCompletePrompt.taskId);
                  if (days) {
                    const task = allTasks.find(t => t.id === manualCompletePrompt.taskId);
                    if (task) await onAddTask({ title: task.title, assigned_to: task.assigned_to, due_date: safeTaskDate(addDays(todayStr(), days)), loan_id: task.loan_id, loan_name: task.loan_name, notes: task.notes });
                  }
                }} style={{ padding: "8px 14px", borderRadius: 8, border: "none", background: bg, color, fontWeight: 700, fontSize: 13, cursor: "pointer" }}>{label}</button>
              ))}
              <button onClick={async () => { setManualCompletePrompt(null); await onCompleteTask(manualCompletePrompt.taskId); }} style={{ padding: "8px 14px", borderRadius: 8, border: "none", background: "#f1f5f9", color: "#374151", fontWeight: 700, fontSize: 13, cursor: "pointer" }}>Complete Only</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── ROOT APP ──────────────────────────────────────────────────────────────
export default function App() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [loans, setLoans] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [leads, setLeads] = useState([]);
  const [relationships, setRelationships] = useState([]);
  const [activeRelationshipId, setActiveRelationshipId] = useState(null);
  const [showNewRelationshipModal, setShowNewRelationshipModal] = useState(false);
  const [activeLoanId, setActiveLoanId] = useState(null);
  const [activeLeadId, setActiveLeadId] = useState(null);
  const [activeTab, setActiveTab] = useState("loans");
  const [showNewModal, setShowNewModal] = useState(false);
  const [showNewLeadModal, setShowNewLeadModal] = useState(false);
  const [error, setError] = useState("");

  const activeLoan = loans.find(l => l.id === activeLoanId) || null;
  const activeLead = leads.find(l => l.id === activeLeadId) || null;
  const activeRelationship = relationships.find(r => r.id === activeRelationshipId) || null;

  // Global helper for TaskActionModal follow up creation
  useEffect(() => {
    window._createFollowupTask = createTask;
    return () => { delete window._createFollowupTask; };
  });

  async function fetchAll() {
    try {
      const [loanData, taskData, leadData, relData] = await Promise.all([
        sbFetch("/loans?select=*&order=borrower_last.asc"),
        sbFetch("/tasks?select=*&order=due_date.asc"),
        sbFetch("/leads?select=*&order=last_name.asc"),
        sbFetch("/relationships?select=*&order=last_name.asc"),
      ]);
      setLoans(loanData || []);
      setTasks(taskData || []);
      setLeads(leadData || []);
      setRelationships(relData || []);
    } catch (e) { setError("Could not load data: " + e.message); }
  }

  // Check for automated tasks that need generating (lock expiration, overdue follow-ups)
  useEffect(() => {
    if (!loggedIn) return;
    fetchAll().then(() => {
      // Lock expiration tasks checked after load in checkAutoTasks
    });
  }, [loggedIn]);

  // After loans load, check lock expiration dates and create tasks if needed
  useEffect(() => {
    if (loans.length === 0) return;
    checkLockExpirationTasks();
    checkBirthdayTasks();
  }, [loans.length, relationships.length]);

  async function checkBirthdayTasks() {
    const today = todayStr();
    for (const rel of relationships) {
      if (!rel.date_of_birth) continue;
      const bday = getBirthdayThisYear(rel.date_of_birth);
      if (!bday) continue;
      const sevenBefore = nextWeekday(addDays(bday, -7));
      const bdayWeekday = nextWeekday(bday);
      for (const dueDate of [sevenBefore, bdayWeekday]) {
        const key = `bday_${rel.id}_${dueDate}`;
        const exists = tasks.some(t => t.auto_key === key);
        if (!exists && dueDate >= today) {
          for (const assignee of ["alex", "madison"]) {
            const assignKey = `${key}_${assignee}`;
            const assignExists = tasks.some(t => t.auto_key === assignKey);
            if (!assignExists) {
              const safeB = safeTaskDate(dueDate);
              await createTaskDirect({ title: `🎂 Birthday: ${rel.first_name} ${rel.last_name}${dueDate === bdayWeekday ? " — Today!" : " — Coming up in 7 days"}`, assigned_to: assignee, due_date: safeB, relationship_id: rel.id, relationship_name: `${rel.last_name}, ${rel.first_name}`, notes: `Auto: Birthday reminder for ${rel.first_name} ${rel.last_name}.`, auto_key: assignKey });
            }
          }
        }
      }
    }
  }

  async function checkLockExpirationTasks() {
    const today = todayStr();
    for (const loan of loans) {
      if (!loan.lock_expiration_date || loan.funding_date) continue;
      const dayBefore = addDays(loan.lock_expiration_date, -1);
      for (const assignee of ["alex", "madison"]) {
        for (const dueDate of [dayBefore, loan.lock_expiration_date]) {
          const key = `lock_exp_${loan.id}_${dueDate}_${assignee}`;
          const exists = tasks.some(t => t.auto_key === key);
          if (!exists && dueDate >= today) {
            await createTask({ title: `🔒 Lock expiration: ${loan.borrower_last} — extend lock`, assigned_to: assignee, due_date: dueDate, loan_id: loan.id, loan_name: `${loan.borrower_last}, ${loan.borrower_first}`, notes: "Auto: Lock expiration reminder. Extend if not yet funded.", auto_key: key });
          }
        }
      }
    }
  }

  async function createLoan(form) {
    try {
      const data = await sbFetch("/loans", { method: "POST", prefer: "return=representation", body: JSON.stringify({ ...form, needs_status: JSON.stringify(buildDefaultNeedsStatus()), processor_items: JSON.stringify([]), conditions: JSON.stringify([]), misc_custom_items: JSON.stringify([]), additional_borrowers: JSON.stringify([]), loan_status: "Active" }) });
      setLoans(prev => [...prev, ...(data || [])]);
      setShowNewModal(false);
      if (data && data[0]) setActiveLoanId(data[0].id);
    } catch (e) { alert("Error creating loan: " + e.message); }
  }

  async function saveLoan(updated) {
    try {
      await sbFetch(`/loans?id=eq.${updated.id}`, { method: "PATCH", prefer: "return=representation", body: JSON.stringify(updated) });
      // Re-fetch this specific loan to get the true saved state from DB
      const fresh = await sbFetch(`/loans?id=eq.${updated.id}&select=*`);
      if (fresh && fresh[0]) {
        setLoans(prev => prev.map(l => l.id === updated.id ? fresh[0] : l));
      } else {
        setLoans(prev => prev.map(l => l.id === updated.id ? updated : l));
      }
    } catch (e) { alert("Error saving: " + e.message); }
  }

  async function deleteLoan(id) {
    try {
      await sbFetch(`/loans?id=eq.${id}`, { method: "DELETE" });
      setLoans(prev => prev.filter(l => l.id !== id));
    } catch (e) { alert("Error deleting: " + e.message); }
  }

  async function createTask(taskData) {
    try {
      const loanName = taskData.loan_name || (taskData.loan_id ? (loans.find(l => l.id === taskData.loan_id) ? `${loans.find(l => l.id === taskData.loan_id).borrower_last}, ${loans.find(l => l.id === taskData.loan_id).borrower_first}` : "") : "");
      const data = await sbFetch("/tasks", { method: "POST", prefer: "return=representation", body: JSON.stringify({ title: taskData.title, assigned_to: taskData.assigned_to, due_date: taskData.due_date || null, loan_id: taskData.loan_id || null, loan_name: loanName || null, lead_id: taskData.lead_id || null, lead_name: taskData.lead_name || null, relationship_id: taskData.relationship_id || null, relationship_name: taskData.relationship_name || null, notes: taskData.notes || "", completed: false, auto_key: taskData.auto_key || null, is_recurring: taskData.is_recurring || false, snooze_options: taskData.snooze_options || false, apply_link_followup: taskData.apply_link_followup || false }) });
      if (data) setTasks(prev => [...prev, ...data]);
    } catch (e) { console.error("Error creating task:", e.message); }
  }

  async function createLead(form) {
    try {
      const cleanForm = { ...form, status: form.status || "New", follow_ups_stopped: false, estimated_amount: form.estimated_amount === "" || form.estimated_amount === undefined ? null : form.estimated_amount, needs_status: JSON.stringify(buildDefaultNeedsStatus()), misc_custom_items: JSON.stringify([]), email_log: JSON.stringify([]) };
      const data = await sbFetch("/leads", { method: "POST", prefer: "return=representation", body: JSON.stringify(cleanForm) });
      if (data && data[0]) {
        setLeads(prev => [...prev, ...data]);
        setShowNewLeadModal(false);
        setActiveLeadId(data[0].id);
        // Auto-task Jordin to input lead info + Alex & Madison to work application
        const dueDate = todayStr();
        const leadName = `${data[0].last_name}, ${data[0].first_name}`;
        await createTaskDirect({ title: `Input lead info: ${leadName}`, assigned_to: "jordin", due_date: dueDate, lead_id: data[0].id, lead_name: leadName, notes: "Auto: New lead created. Input all lead information." });
        await createTaskDirect({ title: `Work up application: ${leadName}`, assigned_to: "alex", due_date: dueDate, lead_id: data[0].id, lead_name: leadName, notes: "Auto: New lead — work up application or update status." });
        await createTaskDirect({ title: `Work up application: ${leadName}`, assigned_to: "madison", due_date: dueDate, lead_id: data[0].id, lead_name: leadName, notes: "Auto: New lead — work up application or update status." });
      }
    } catch (e) { alert("Error creating lead: " + e.message); }
  }

  async function saveLead(updated) {
    try {
      const cleanLead = { ...updated, estimated_amount: updated.estimated_amount === "" || updated.estimated_amount === undefined ? null : updated.estimated_amount };
      await sbFetch(`/leads?id=eq.${updated.id}`, { method: "PATCH", prefer: "return=representation", body: JSON.stringify(cleanLead) });
      setLeads(prev => prev.map(l => l.id === updated.id ? updated : l));
    } catch (e) { alert("Error saving lead: " + e.message); }
  }

  async function createRelationship(form) {
    try {
      const cleanRel = { ...form, status: "New", contacted_dates: "[]", referral_history: "[]", date_of_birth: form.date_of_birth || null, last_contacted: form.last_contacted || null };
      const data = await sbFetch("/relationships", { method: "POST", prefer: "return=representation", body: JSON.stringify(cleanRel) });
      if (data && data[0]) { setRelationships(prev => [...prev, ...data]); setShowNewRelationshipModal(false); setActiveRelationshipId(data[0].id); }
    } catch (e) { alert("Error creating contact: " + e.message); }
  }

  async function saveRelationship(updated) {
    try {
      const cleanRel = { ...updated, date_of_birth: updated.date_of_birth || null, last_contacted: updated.last_contacted || null };
      await sbFetch(`/relationships?id=eq.${updated.id}`, { method: "PATCH", prefer: "return=representation", body: JSON.stringify(cleanRel) });
      setRelationships(prev => prev.map(r => r.id === updated.id ? updated : r));
    } catch (e) { alert("Error saving contact: " + e.message); }
  }

  async function convertLeadToLoan(lead) {
    try {
      const loanData = { borrower_first: lead.first_name, borrower_last: lead.last_name, borrower_email: lead.email, borrower_phone: lead.phone, general_notes: `Converted from lead.\nLoan Type: ${lead.loan_type || ""}\nEstimated Amount: ${lead.estimated_amount ? "$" + lead.estimated_amount : ""}\nLead Source: ${lead.lead_source || ""}\n\n${lead.notes || ""}`, needs_status: lead.needs_status || JSON.stringify(buildDefaultNeedsStatus()), processor_items: JSON.stringify([]), conditions: JSON.stringify([]), misc_custom_items: lead.misc_custom_items || JSON.stringify([]), additional_borrowers: JSON.stringify([]), conversation_log: lead.conversation_log || JSON.stringify([]) };
      const data = await sbFetch("/loans", { method: "POST", prefer: "return=representation", body: JSON.stringify(loanData) });
      if (data && data[0]) {
        setLoans(prev => [...prev, ...data]);
        setActiveTab("loans");
        setActiveLoanId(data[0].id);
      }
    } catch (e) { alert("Error converting lead: " + e.message); }
  }

  async function createTaskDirect(taskData) {
    try {
      const data = await sbFetch("/tasks", { method: "POST", prefer: "return=representation", body: JSON.stringify({ title: taskData.title, assigned_to: taskData.assigned_to, due_date: taskData.due_date || null, loan_id: taskData.loan_id || null, loan_name: taskData.loan_name || null, lead_id: taskData.lead_id || null, lead_name: taskData.lead_name || null, relationship_id: taskData.relationship_id || null, relationship_name: taskData.relationship_name || null, notes: taskData.notes || "", completed: false, auto_key: taskData.auto_key || null, is_recurring: taskData.is_recurring || false, snooze_options: taskData.snooze_options || false, apply_link_followup: taskData.apply_link_followup || false }) });
      if (data) setTasks(prev => [...prev, ...data]);
    } catch (e) { console.error("Error creating task:", e.message); }
  }

  async function completeTask(id, forceComplete = false) {
    try {
      const task = tasks.find(t => t.id === id);
      if (!task) return;
      const newCompleted = forceComplete ? true : !task.completed;
      // Check for shared funding/checkin tasks — complete both
      const sharedTitles = ["Call", "40-day check in", "Follow up with", "Work up application"];
      const isShared = sharedTitles.some(s => task.title.includes(s)) && (task.loan_id || task.lead_id);
      if (isShared) {
        const siblings = tasks.filter(t => t.title === task.title && t.due_date === task.due_date && (task.loan_id ? t.loan_id === task.loan_id : t.lead_id === task.lead_id));
        for (const sib of siblings) {
          await sbFetch(`/tasks?id=eq.${sib.id}`, { method: "PATCH", body: JSON.stringify({ completed: newCompleted }) });
        }
        setTasks(prev => prev.map(t => siblings.some(s => s.id === t.id) ? { ...t, completed: newCompleted } : t));
      } else {
        await sbFetch(`/tasks?id=eq.${id}`, { method: "PATCH", body: JSON.stringify({ completed: newCompleted }) });
        setTasks(prev => prev.map(t => t.id === id ? { ...t, completed: newCompleted } : t));
      }
    } catch (e) { alert("Error updating task: " + e.message); }
  }

  async function reassignTask(id, assignees, mode) {
    try {
      const task = tasks.find(t => t.id === id);
      if (!task) return;
      if (mode === "replace") {
        // Delete existing and create new ones
        await sbFetch(`/tasks?id=eq.${id}`, { method: "DELETE" });
        setTasks(prev => prev.filter(t => t.id !== id));
        for (const assignee of assignees) {
          await createTask({ ...task, id: undefined, assigned_to: assignee });
        }
      } else {
        // Add mode - update existing and create extras
        await sbFetch(`/tasks?id=eq.${id}`, { method: "PATCH", body: JSON.stringify({ assigned_to: assignees[0] }) });
        setTasks(prev => prev.map(t => t.id === id ? { ...t, assigned_to: assignees[0] } : t));
        for (const assignee of assignees.slice(1)) {
          await createTask({ ...task, id: undefined, assigned_to: assignee });
        }
      }
    } catch (e) { alert("Error reassigning task: " + e.message); }
  }

  async function pushTask(id, newDueDate) {
    try {
      const task = tasks.find(t => t.id === id);
      if (!task) return;
      const oldDate = task.due_date || "no date";
      const pushLog = task.push_log ? JSON.parse(task.push_log) : [];
      pushLog.push({ from: oldDate, to: newDueDate, on: todayStr() });
      await sbFetch(`/tasks?id=eq.${id}`, { method: "PATCH", body: JSON.stringify({ due_date: newDueDate, push_log: JSON.stringify(pushLog) }) });
      setTasks(prev => prev.map(t => t.id === id ? { ...t, due_date: newDueDate, push_log: JSON.stringify(pushLog) } : t));
    } catch (e) { alert("Error pushing task: " + e.message); }
  }

  async function deleteTask(id) {
    try {
      await sbFetch(`/tasks?id=eq.${id}`, { method: "DELETE" });
      setTasks(prev => prev.filter(t => t.id !== id));
    } catch (e) { alert("Error deleting task: " + e.message); }
  }

  if (!loggedIn) return <LoginScreen onLogin={() => setLoggedIn(true)} />;

  if (activeLoan) return (
    <LoanFile loan={activeLoan} allTasks={tasks} onBack={() => setActiveLoanId(null)} onSave={saveLoan} onAddTask={createTask} onCompleteTask={completeTask} onDeleteTask={deleteTask} onPushTask={pushTask} />
  );

  if (activeLead) return (
    <LeadFile lead={activeLead} allTasks={tasks} loans={loans} onBack={() => setActiveLeadId(null)} onSave={saveLead} onAddTask={createTask} onCompleteTask={completeTask} onDeleteTask={deleteTask} onConvertToLoan={convertLeadToLoan} onPushTask={pushTask} />
  );

  if (activeRelationship) return (
    <RelationshipFile rel={activeRelationship} allTasks={tasks} onBack={() => setActiveRelationshipId(null)} onSave={saveRelationship} onAddTask={createTask} onCompleteTask={completeTask} onDeleteTask={deleteTask} />
  );

  const openTaskCount = tasks.filter(t => !t.completed).length;
  const activeLeadCount = leads.filter(l => ACTIVE_LEAD_STATUSES.includes(l.status)).length;

  return (
    <div style={{ minHeight: "100vh", background: "#f8fafc" }}>
      {/* Nav */}
      <div style={{ background: "#0f2644", padding: "0 32px", display: "flex", gap: 0 }}>
        {[["loans", "🏠 Loans"], ["leads", `🎯 Leads${activeLeadCount > 0 ? ` (${activeLeadCount})` : ""}`], ["relationships", `🤝 Relationships${relationships.filter(r => r.status !== "Inactive").length > 0 ? ` (${relationships.filter(r => r.status !== "Inactive").length})` : ""}`], ["tasks", `📋 Tasks${openTaskCount > 0 ? ` (${openTaskCount})` : ""}`]].map(([key, label]) => (
          <button key={key} onClick={() => setActiveTab(key)} style={{ padding: "14px 24px", border: "none", borderBottom: activeTab === key ? "3px solid #c9a84c" : "3px solid transparent", background: "none", color: activeTab === key ? "#c9a84c" : "rgba(255,255,255,0.6)", fontWeight: activeTab === key ? 800 : 500, fontSize: 14, cursor: "pointer" }}>{label}</button>
        ))}
      </div>

      {activeTab === "loans" && (
        <>
          <Dashboard loans={loans} tasks={tasks} onOpen={id => setActiveLoanId(id)} onNew={() => setShowNewModal(true)} onDeleteLoan={deleteLoan} onCompleteTask={completeTask} onAddTask={createTask} />
          {showNewModal && <NewLoanModal onSave={createLoan} onCancel={() => setShowNewModal(false)} />}
        </>
      )}
      {activeTab === "leads" && (
        <>
          <LeadsDashboard leads={leads} tasks={tasks} onOpen={id => setActiveLeadId(id)} onNew={() => setShowNewLeadModal(true)} />
          {showNewLeadModal && <NewLeadModal onSave={createLead} onCancel={() => setShowNewLeadModal(false)} />}
        </>
      )}
      {activeTab === "relationships" && (
        <>
          <RelationshipsDashboard relationships={relationships} tasks={tasks} onOpen={id => setActiveRelationshipId(id)} onNew={() => setShowNewRelationshipModal(true)} />
          {showNewRelationshipModal && <NewRelationshipModal onSave={createRelationship} onCancel={() => setShowNewRelationshipModal(false)} />}
        </>
      )}
      {activeTab === "tasks" && (
        <TaskDashboard tasks={tasks} loans={loans} leads={leads} onComplete={completeTask} onAddTask={createTask} onDeleteTask={deleteTask} onPushTask={pushTask} onReassignTask={reassignTask} onNavigate={(task) => {
            if (task.loan_id) { setActiveLoanId(task.loan_id); setActiveTab("loans"); }
            else if (task.lead_id) { setActiveLeadId(task.lead_id); setActiveTab("leads"); }
            else if (task.relationship_id) { setActiveRelationshipId(task.relationship_id); setActiveTab("relationships"); }
          }} />
      )}
      {error && <div style={{ position: "fixed", bottom: 20, left: 20, background: "#fef2f2", border: "1px solid #fca5a5", color: "#991b1b", padding: "10px 16px", borderRadius: 8, fontSize: 13 }}>{error}</div>}
    </div>
  );
}

// ── LEADS CONSTANTS ───────────────────────────────────────────────────────



const LOAN_STAGES = [
  { label: "Loan Open",        bg: "#bfdbfe", text: "#1e3a5f", border: "#93c5fd" },
  { label: "Registered",       bg: "#7dd3fc", text: "#0c4a6e", border: "#38bdf8" },
  { label: "Set Up",           bg: "#a5b4fc", text: "#3730a3", border: "#818cf8" },
  { label: "Processing",       bg: "#c4b5fd", text: "#4c1d95", border: "#a78bfa" },
  { label: "Underwriting",     bg: "#e0aaff", text: "#6b21a8", border: "#c084fc" },
  { label: "Approved",         bg: "#d9f99d", text: "#365314", border: "#a3e635" },
  { label: "Condition Review", bg: "#f9a8d4", text: "#831843", border: "#f472b6" },
  { label: "Clear to Close",   bg: "#fda4af", text: "#881337", border: "#fb7185" },
  { label: "Docs Ordered",     bg: "#fed7aa", text: "#7c2d12", border: "#fb923c" },
  { label: "Docs Out",         bg: "#bbf7d0", text: "#14532d", border: "#4ade80" },
  { label: "Loan On-Hold",     bg: "#e2e8f0", text: "#334155", border: "#94a3b8" },
  { label: "Funded",           bg: "#6ee7b7", text: "#065f46", border: "#34d399" },
];
const LEAD_STATUSES = ["New","Apply Now Link Sent","Pre-Qualified","Building","Credit Help","Rate Drop","Unresponsive","Converted to Loan","Denied","Waiting on Something"];
const LEAD_SOURCES = ["Walk In","Phone","Website","Social Media","Google or Other Search","Family","Friend","Past Client","Past Client Referral","Builder Referral","Realtor Referral"];
const ACTIVE_LEAD_STATUSES = ["New","Apply Now Link Sent","Pre-Qualified","Building","Credit Help","Rate Drop","Unresponsive","Waiting on Something"];
const CLOSED_LEAD_STATUSES = ["Converted to Loan","Denied"];
const LOAN_TYPES = ["Conventional","FHA","VA","USDA","HELOC/HELOAN","Non-QM"];
const FOLLOWUP_TRIGGER_STATUSES_LEAD = ["Pre-Qualified","Building"];

const LEAD_STATUS_COLORS = {
  "New":                { bg: "#dbeafe", text: "#1e40af", border: "#93c5fd" },
  "Apply Now Link Sent":{ bg: "#e0e7ff", text: "#3730a3", border: "#a5b4fc" },
  "Pre-Qualified":      { bg: "#d1fae5", text: "#065f46", border: "#6ee7b7" },
  "Building":           { bg: "#fef3c7", text: "#92400e", border: "#fcd34d" },
  "Credit Help":        { bg: "#fee2e2", text: "#991b1b", border: "#fca5a5" },
  "Rate Drop":          { bg: "#f3e8ff", text: "#5b21b6", border: "#c4b5fd" },
  "Unresponsive":       { bg: "#f1f5f9", text: "#475569", border: "#cbd5e1" },
  "Converted to Loan":  { bg: "#d1fae5", text: "#065f46", border: "#6ee7b7" },
  "Denied":             { bg: "#fee2e2", text: "#991b1b", border: "#fca5a5" },
  "Waiting on Something":{ bg: "#fef9c3", text: "#713f12", border: "#fde047" },
};


const FOLLOWUP_TRIGGER_STATUSES = ["Pre-Qualified","Building"];



// ── LEADS DASHBOARD ───────────────────────────────────────────────────────
function LeadsDashboard({ leads, tasks, onOpen, onNew }) {
  const [statusFilter, setStatusFilter] = useState("all");
  const [search, setSearch] = useState("");
    const [sortBy, setSortBy] = useState("date");  const activeLeads = leads.filter(l => ACTIVE_LEAD_STATUSES.includes(l.status));
  const filteredLeads = activeLeads.filter(l => {
    const name = `${l.last_name} ${l.first_name}`.toLowerCase();
    const matchSearch = name.includes(search.toLowerCase());
    const matchStatus = statusFilter === "all" || l.status === statusFilter;
    return matchSearch && matchStatus;
  }).sort((a, b) => {
    if (sortBy === "name") return (a.last_name || "").toLowerCase() < (b.last_name || "").toLowerCase() ? -1 : 1;
    if (sortBy === "date") return (b.created_at || "") < (a.created_at || "") ? -1 : 1;
    if (sortBy === "status") return (a.status || "").toLowerCase() < (b.status || "").toLowerCase() ? -1 : 1;
    return 0;
  });

  // Stats by status
  const statusCounts = {};
  LEAD_STATUSES.forEach(s => { statusCounts[s] = activeLeads.filter(l => l.status === s).length; });

  return (
    <div style={{ minHeight: "100vh", background: "#f8fafc" }}>
      <div style={{ background: "linear-gradient(90deg, #0f2644 0%, #1e3a5f 100%)", padding: "20px 32px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div>
          <h1 style={{ color: "#fff", margin: 0, fontSize: 22, fontWeight: 800 }}>🎯 Leads Pipeline</h1>
          <p style={{ color: "#c9a84c", margin: 0, fontSize: 13, fontWeight: 600 }}>{activeLeads.length} active leads</p>
        </div>
        <button onClick={onNew} style={{ background: "#c9a84c", color: "#0f2644", border: "none", borderRadius: 8, padding: "10px 22px", fontWeight: 800, fontSize: 14, cursor: "pointer" }}>+ New Lead</button>
      </div>

      {/* Stats bar */}
      <div style={{ background: "#fff", borderBottom: "1.5px solid #e5e7eb", padding: "12px 32px", display: "flex", gap: 8, flexWrap: "wrap", overflowX: "auto" }}>
        {ACTIVE_LEAD_STATUSES.map(s => {
          const c = LEAD_STATUS_COLORS[s] || {};
          const count = statusCounts[s] || 0;
          return (
            <button key={s} onClick={() => setStatusFilter(statusFilter === s ? "all" : s)} style={{
              padding: "4px 12px", borderRadius: 20, fontSize: 12, fontWeight: 700, cursor: "pointer",
              border: `1.5px solid ${statusFilter === s ? c.border : "#e5e7eb"}`,
              background: statusFilter === s ? c.bg : "#f8fafc",
              color: statusFilter === s ? c.text : "#6b7280",
            }}>
              {s} <span style={{ opacity: 0.8 }}>({count})</span>
            </button>
          );
        })}
        {statusFilter !== "all" && (
          <button onClick={() => setStatusFilter("all")} style={{ padding: "4px 12px", borderRadius: 20, fontSize: 12, fontWeight: 700, cursor: "pointer", border: "1.5px solid #d1d5db", background: "#fff", color: "#6b7280" }}>✕ Clear Filter</button>
        )}
      </div>

      <div style={{ padding: "24px 32px" }}>
        {/* Search and sort */}
        <div style={{ display: "flex", gap: 12, marginBottom: 20, flexWrap: "wrap", alignItems: "center" }}>
          <input placeholder="Search by name..." value={search} onChange={e => setSearch(e.target.value)} style={{ padding: "8px 14px", borderRadius: 8, border: "1.5px solid #d1d5db", fontSize: 14, width: 240, outline: "none" }} />
          <select value={sortBy} onChange={e => setSortBy(e.target.value)} style={{ padding: "8px 14px", borderRadius: 8, border: "1.5px solid #d1d5db", fontSize: 13, outline: "none", cursor: "pointer" }}>
            <option value="name">Sort: Last Name A-Z</option>
            <option value="date">Sort: Newest First</option>
            <option value="status">Sort: Status A-Z</option>
          </select>
        </div>

        {filteredLeads.length === 0 ? (
          <div style={{ textAlign: "center", padding: "60px", color: "#9ca3af", fontSize: 15 }}>
            {statusFilter !== "all" ? `No leads with status "${statusFilter}".` : "No active leads. Click \"+ New Lead\" to get started."}
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {filteredLeads.map(lead => {
              const sc = LEAD_STATUS_COLORS[lead.status] || {};
              const leadTasks = tasks.filter(t => !t.completed && t.lead_id === lead.id);
              const overdue = leadTasks.filter(t => t.due_date && daysDiff(t.due_date) < 0).length;
              return (
                <div key={lead.id} onClick={() => onOpen(lead.id)} style={{ background: "#fff", borderRadius: 10, border: "1.5px solid #e5e7eb", padding: "16px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", cursor: "pointer" }}>
                  <div>
                    <div style={{ fontWeight: 800, fontSize: 16, color: "#0f2644" }}>{lead.last_name}, {lead.first_name}</div>
                    <div style={{ fontSize: 13, color: "#6b7280", marginTop: 2 }}>
                      {lead.phone && <span>{lead.phone}</span>}
                      {lead.phone && lead.email && <span> · </span>}
                      {lead.email && <span>{lead.email}</span>}
                      {lead.loan_type && <span style={{ marginLeft: 8, background: "#f1f5f9", borderRadius: 4, padding: "1px 6px", fontSize: 11, fontWeight: 700, color: "#475569" }}>{lead.loan_type}</span>}
                      {lead.lead_source && <span style={{ marginLeft: 6, background: "#f1f5f9", borderRadius: 4, padding: "1px 6px", fontSize: 11, color: "#6b7280" }}>{lead.lead_source}</span>}
                    </div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    {overdue > 0 && <span style={{ background: "#fee2e2", color: "#991b1b", borderRadius: 6, padding: "3px 8px", fontSize: 11, fontWeight: 700 }}>⚠ {overdue} overdue</span>}
                    {leadTasks.length > 0 && overdue === 0 && <span style={{ background: "#fef3c7", color: "#92400e", borderRadius: 6, padding: "3px 8px", fontSize: 11, fontWeight: 700 }}>{leadTasks.length} tasks</span>}
                    <span style={{ background: sc.bg, color: sc.text, border: `1.5px solid ${sc.border}`, borderRadius: 6, padding: "3px 10px", fontSize: 12, fontWeight: 700 }}>{lead.status}</span>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* Denied / closed leads */}
        {leads.filter(l => CLOSED_LEAD_STATUSES.includes(l.status)).length > 0 && (
          <details style={{ marginTop: 24 }}>
            <summary style={{ cursor: "pointer", fontSize: 13, fontWeight: 700, color: "#6b7280", marginBottom: 10 }}>
              Closed Leads (Denied / Converted) — {leads.filter(l => CLOSED_LEAD_STATUSES.includes(l.status)).length}
            </summary>
            {leads.filter(l => CLOSED_LEAD_STATUSES.includes(l.status)).map(lead => {
              const sc = LEAD_STATUS_COLORS[lead.status] || {};
              return (
                <div key={lead.id} onClick={() => onOpen(lead.id)} style={{ background: "#fff", borderRadius: 10, border: "1.5px solid #e5e7eb", padding: "14px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8, cursor: "pointer", opacity: 0.75 }}>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: 15, color: "#374151" }}>{lead.last_name}, {lead.first_name}</div>
                    <div style={{ fontSize: 12, color: "#9ca3af" }}>{lead.email} {lead.loan_type && `· ${lead.loan_type}`}</div>
                  </div>
                  <span style={{ background: sc.bg, color: sc.text, borderRadius: 6, padding: "3px 10px", fontSize: 12, fontWeight: 700 }}>{lead.status}</span>
                </div>
              );
            })}
          </details>
        )}
      </div>
    </div>
  );
}

// ── NEW LEAD MODAL ────────────────────────────────────────────────────────
function NewLeadModal({ onSave, onCancel }) {
  const [form, setForm] = useState({ first_name: "", last_name: "", email: "", phone: "", loan_type: "", estimated_amount: "", lead_source: "", status: "New", notes: "", purchase_or_refi: "Purchase" });
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const inp = { width: "100%", padding: "8px 12px", borderRadius: 7, border: "1.5px solid #d1d5db", fontSize: 14, outline: "none", boxSizing: "border-box" };
  const lbl = { fontSize: 12, fontWeight: 700, color: "#374151", marginBottom: 4, display: "block" };
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }}>
      <div style={{ background: "#fff", borderRadius: 14, padding: "36px 32px", width: 520, boxShadow: "0 20px 60px rgba(0,0,0,0.2)", maxHeight: "90vh", overflowY: "auto" }}>
        <h2 style={{ margin: "0 0 20px", color: "#0f2644", fontSize: 18, fontWeight: 800 }}>New Lead</h2>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 14 }}>
          <div><label style={lbl}>First Name</label><input style={inp} value={form.first_name} onChange={e => set("first_name", e.target.value)} /></div>
          <div><label style={lbl}>Last Name *</label><input style={inp} value={form.last_name} onChange={e => set("last_name", e.target.value)} /></div>
          <div><label style={lbl}>Email</label><input type="email" style={inp} value={form.email} onChange={e => set("email", e.target.value)} /></div>
          <div><label style={lbl}>Phone</label><input type="tel" style={inp} value={form.phone} onChange={e => set("phone", e.target.value)} /></div>
          <div>
            <label style={lbl}>Loan Type</label>
            <select style={inp} value={form.loan_type} onChange={e => set("loan_type", e.target.value)}>
              <option value="">Select...</option>
              {LOAN_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
            </select>
          </div>
          <div>
            <label style={lbl}>Purchase or Refi</label>
            <select style={inp} value={form.purchase_or_refi} onChange={e => set("purchase_or_refi", e.target.value)}>
              <option value="Purchase">Purchase</option>
              <option value="Refinance">Refinance</option>
            </select>
          </div>
          <div><label style={lbl}>Estimated Loan Amount</label><input type="number" style={inp} value={form.estimated_amount} onChange={e => set("estimated_amount", e.target.value)} placeholder="$" /></div>
          <div>
            <label style={lbl}>Lead Source</label>
            <select style={inp} value={form.lead_source} onChange={e => set("lead_source", e.target.value)}>
              <option value="">Select...</option>
              {LEAD_SOURCES.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
        </div>
        <div style={{ marginBottom: 20 }}><label style={lbl}>Notes</label><textarea value={form.notes} onChange={e => set("notes", e.target.value)} placeholder="Initial notes..." style={{ ...inp, height: 70, resize: "vertical" }} /></div>
        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          <button onClick={onCancel} style={{ padding: "9px 20px", borderRadius: 8, border: "1.5px solid #d1d5db", background: "#fff", cursor: "pointer" }}>Cancel</button>
          <button onClick={() => { if (!form.last_name.trim()) return alert("Last name is required."); onSave(form); }} style={{ padding: "9px 20px", borderRadius: 8, border: "none", background: "#1e3a5f", color: "#fff", fontWeight: 700, cursor: "pointer" }}>Create Lead</button>
        </div>
      </div>
    </div>
  );
}

// ── LEAD FILE ─────────────────────────────────────────────────────────────
function LeadFile({ lead: initialLead, allTasks, loans, onBack, onSave, onAddTask, onCompleteTask, onDeleteTask, onConvertToLoan, onPushTask }) {
  const [lead, setLoan] = useState(initialLead);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [showAddTask, setShowAddTask] = useState(false);
  const [followUpPrompt, setFollowUpPrompt] = useState(null);
  const [applyLinkSnoozePrompt, setApplyLinkSnoozePrompt] = useState(null);
  const leadTasks = allTasks.filter(t => t.lead_id === lead.id);
  const prevStatus = initialLead.status;

  useEffect(() => { window.scrollTo(0, 0); }, []);

  function upd(k, v) { setLoan(l => ({ ...l, [k]: v })); }

  const leadNeedsStatus = parse(lead.needs_status, buildDefaultNeedsStatus());
  const leadMiscCustom = parse(lead.misc_custom_items, []);

  function updateLeadNeedsItem(item, val) {
    const ns = { ...leadNeedsStatus, [item]: val };
    upd("needs_status", JSON.stringify(ns));
  }

  function buildLeadGreeting() {
    const names = [];
    if (lead.first_name) names.push(lead.first_name);
    const cobs = parse(lead.coborrowers, []);
    cobs.forEach(cb => { if (cb.first) names.push(cb.first); });
    if (names.length === 0) return "there";
    if (names.length === 1) return names[0];
    if (names.length === 2) return `${names[0]} and ${names[1]}`;
    return `${names.slice(0, -1).join(", ")}, and ${names[names.length - 1]}`;
  }

  function buildApplyLinkMailto() {
    const greeting = buildLeadGreeting();
    const body = `Hello ${greeting},\n\nThank you so much for reaching out to us — we are truly excited about the opportunity to help you! We would love to get the process started for you right away.\n\nPlease click the link below to begin your application at your convenience:\n\nApply Now: https://alexgiampietro.floify.com/\n\nIf you have any questions along the way or need any help completing the application, please do not hesitate to reach out. We are here to make this as easy as possible for you and we look forward to working with you!\n\nThank you,`;
    const leadEmails = [lead.email, ...parse(lead.coborrowers, []).map(b => b.email)].filter(Boolean).join(";");
    return `mailto:${leadEmails}?cc=teamg%40gilavalleymtg.com&subject=${encodeURIComponent(`Welcome to Gila Valley Mortgage — Let's Get Started!`)}&body=${encodeURIComponent(body)}`;
  }

  function buildLeadInitialRequestMailto() {
    const checkedItems = [];
    INITIAL_NEEDS.forEach(s => {
      s.items.filter(item => leadNeedsStatus[item]?.checked).forEach(i => checkedItems.push(`  - ${i}`));
    });
    leadMiscCustom.filter(ci => ci.checked && ci.text).forEach(ci => checkedItems.push(`  - ${ci.text}`));
    const body = `Hello ${buildLeadGreeting()},\n\nWe are so excited to work with you and truly grateful for the opportunity to help you through this process! To get things moving right away, we are going to need a few documents from you to get your file started.\n\nHere is what we need:\n${checkedItems.join("\n")}\n\nPlease get these over to us at your earliest convenience and do not hesitate to reach out if you have any questions or need help with anything at all. We are here every step of the way!\n\nThank you,`;
    const leadInitialEmails = [lead.email, ...parse(lead.coborrowers, []).map(b => b.email)].filter(Boolean).join(";");
    return `mailto:${leadInitialEmails}?cc=teamg%40gilavalleymtg.com&subject=${encodeURIComponent(`Welcome to Gila Valley Mortgage — Documents Needed — ${lead.last_name || ""}`)}&body=${encodeURIComponent(body)}`;
  }

  function logLeadEmail(type) {
    const emailLog = parse(lead.email_log, []);
    upd("email_log", JSON.stringify([...emailLog, { id: Date.now(), type, date: todayStr() }]));
  }

  async function handleSave(overrides = {}) {
    const toSave = { ...lead, ...overrides };
    setSaving(true);
    await onSave(toSave);
    setSaving(false); setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  }

  async function handleBack() {
    setSaving(true);
    await onSave(lead);
    setSaving(false);
    onBack();
  }

  async function handleStatusChange(newStatus) {
    upd("status", newStatus);
    // Auto-create 7 day follow up when entering Pre-Qualified or Building
    if (FOLLOWUP_TRIGGER_STATUSES_LEAD.includes(newStatus) && !FOLLOWUP_TRIGGER_STATUSES_LEAD.includes(prevStatus)) {
      const dueDate = safeTaskDate(addDays(todayStr(), 7));
      for (const assignee of ["alex", "madison"]) {
        await onAddTask({ title: `Follow up with ${lead.last_name} on application`, assigned_to: assignee, due_date: dueDate, lead_id: lead.id, lead_name: `${lead.last_name}, ${lead.first_name}`, notes: `Auto: 7-day follow up after status changed to ${newStatus}.`, is_recurring: true });
      }
    }
    // Auto-create 48 hour follow up when status changes to Apply Now Link Sent
    if (newStatus === "Apply Now Link Sent" && prevStatus !== "Apply Now Link Sent") {
      const dueDate = safeTaskDate(addDays(todayStr(), 2));
      for (const assignee of ["alex", "madison"]) {
        await onAddTask({ title: `Follow up on application: ${lead.last_name}`, assigned_to: assignee, due_date: dueDate, lead_id: lead.id, lead_name: `${lead.last_name}, ${lead.first_name}`, notes: "Auto: Follow up on online application sent. Check if received.", is_recurring: true, snooze_options: true, apply_link_followup: true });
      }
    }
  }

  async function handleCompleteTask(taskId) {
    const task = allTasks.find(t => t.id === taskId);
    if (!task) return;
    if (task.apply_link_followup && !task.completed && lead.status === "Apply Now Link Sent") {
      setApplyLinkSnoozePrompt({ taskId });
      return;
    }
    if (task.is_recurring && !task.completed) {
      setFollowUpPrompt({ taskId });
      return;
    }
    await onCompleteTask(taskId);
  }

  async function handleApplyLinkSnoozeChoice(taskId, days) {
    setApplyLinkSnoozePrompt(null);
    await onCompleteTask(taskId);
    if (days && lead.status === "Apply Now Link Sent") {
      const dueDate = addDays(todayStr(), days);
      for (const assignee of ["alex", "madison"]) {
        await onAddTask({ title: `Follow up on application: ${lead.last_name}`, assigned_to: assignee, due_date: dueDate, lead_id: lead.id, lead_name: `${lead.last_name}, ${lead.first_name}`, notes: "Auto: Recurring follow up on application link.", is_recurring: true, snooze_options: true, apply_link_followup: true });
      }
    }
  }

  async function handleFollowUpChoice(taskId, days) {
    setFollowUpPrompt(null);
    await onCompleteTask(taskId);
    if (days) {
      const dueDate = addDays(todayStr(), days);
      for (const assignee of ["alex", "madison"]) {
        await onAddTask({ title: `Follow up with ${lead.last_name} on application`, assigned_to: assignee, due_date: dueDate, lead_id: lead.id, lead_name: `${lead.last_name}, ${lead.first_name}`, notes: `Auto: Recurring ${days}-day follow up.`, is_recurring: true });
      }
    }
  }

  async function handleStopFollowUps() {
    if (!window.confirm("Stop all recurring follow up tasks for this lead? This cannot be undone.")) return;
    const recurringTasks = leadTasks.filter(t => t.is_recurring && !t.completed);
    for (const t of recurringTasks) { await onDeleteTask(t.id); }
    const stopNote = `${lead.notes ? lead.notes + "\n\n" : ""}[Follow ups stopped on ${todayStr()} — client requested no further contact until they reach out.]`;
    upd("notes", stopNote);
    upd("follow_ups_stopped", true);
    await onSave({ ...lead, notes: stopNote, follow_ups_stopped: true });
  }

  async function handleConvert() {
    if (!window.confirm(`Convert ${lead.first_name} ${lead.last_name} to a loan file? This will create a new loan and mark this lead as Converted.`)) return;
    upd("status", "Converted to Loan");
    await onSave({ ...lead, status: "Converted to Loan" });
    onConvertToLoan(lead);
    onBack();
  }

  const inp = { padding: "7px 12px", borderRadius: 7, border: "1.5px solid #d1d5db", fontSize: 14, outline: "none", width: "100%", boxSizing: "border-box" };
  const lbl = { fontSize: 12, fontWeight: 700, color: "#374151", display: "block", marginBottom: 4 };
  const sc = LEAD_STATUS_COLORS[lead.status] || {};

  return (
    <div style={{ minHeight: "100vh", background: "#f8fafc" }}>
      {/* Top bar */}
      <div style={{ background: "linear-gradient(90deg, #0f2644 0%, #1e3a5f 100%)", padding: "14px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 100 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <button onClick={handleBack} style={{ background: "rgba(255,255,255,0.15)", border: "none", color: "#fff", borderRadius: 7, padding: "6px 14px", cursor: "pointer", fontSize: 13 }}>{saving ? "Saving..." : "← Leads"}</button>
          <div>
            <div style={{ color: "#fff", fontWeight: 800, fontSize: 16 }}>{lead.last_name}, {lead.first_name}</div>
            <div style={{ color: "#c9a84c", fontSize: 12 }}>{lead.loan_type || "Loan type TBD"} · {lead.purchase_or_refi || "Purchase"}</div>
          </div>
        </div>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <span style={{ background: sc.bg, color: sc.text, border: `1.5px solid ${sc.border}`, borderRadius: 6, padding: "4px 12px", fontSize: 12, fontWeight: 700 }}>{lead.status}</span>
          {!lead.follow_ups_stopped && leadTasks.some(t => t.is_recurring && !t.completed) && (
            <button onClick={handleStopFollowUps} style={{ background: "#fee2e2", color: "#991b1b", border: "1.5px solid #fca5a5", borderRadius: 7, padding: "6px 12px", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>🛑 Stop Follow Ups</button>
          )}
          <EmailDropdown emails={[
            { label: "📋 Initial Needs List Request", href: buildLeadInitialRequestMailto(), onLog: () => logLeadEmail("Initial Needs List Request") },
            { label: "🔗 Send Application Link", href: buildApplyLinkMailto(), onLog: () => logLeadEmail("Application Link Sent") },
          ]} />
          <button onClick={handleConvert} style={{ background: "#c9a84c", color: "#0f2644", border: "none", borderRadius: 7, padding: "7px 14px", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>🏠 Convert to Loan</button>
          <button onClick={() => handleSave()} style={{ background: saved ? "#d1fae5" : "#fff", color: saved ? "#065f46" : "#1e3a5f", border: `2px solid ${saved ? "#6ee7b7" : "#1e3a5f"}`, borderRadius: 7, padding: "7px 16px", fontWeight: 700, fontSize: 13, cursor: "pointer" }}>
            {saving ? "Saving..." : saved ? "✓ Saved" : "Save"}
          </button>
        </div>
      </div>

      <div style={{ maxWidth: 920, margin: "0 auto", padding: "24px 20px" }}>

        {/* Status */}
        <Section title="STATUS" accent="#0f2644">
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {LEAD_STATUSES.map(s => {
              const c = LEAD_STATUS_COLORS[s] || {};
              const active = lead.status === s;
              return (
                <button key={s} onClick={() => handleStatusChange(s)} style={{ padding: "6px 14px", borderRadius: 20, fontSize: 13, fontWeight: active ? 800 : 500, cursor: "pointer", border: `1.5px solid ${active ? c.border : "#d1d5db"}`, background: active ? c.bg : "#fff", color: active ? c.text : "#6b7280" }}>{s}</button>
              );
            })}
          </div>
          {lead.follow_ups_stopped && <div style={{ marginTop: 10, padding: "8px 12px", background: "#fef2f2", borderRadius: 7, fontSize: 12, color: "#991b1b", fontWeight: 600 }}>🛑 Recurring follow ups have been stopped for this lead.</div>}
        </Section>

        {/* Contact Info */}
        <Section title="CONTACT INFORMATION" accent="#1e3a5f">
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 14 }}>
            <div><label style={lbl}>First Name</label><input style={inp} value={lead.first_name || ""} onChange={e => upd("first_name", e.target.value)} /></div>
            <div><label style={lbl}>Last Name</label><input style={inp} value={lead.last_name || ""} onChange={e => upd("last_name", e.target.value)} /></div>
            <div><label style={lbl}>Email</label><input type="email" style={inp} value={lead.email || ""} onChange={e => upd("email", e.target.value)} /></div>
            <div><label style={lbl}>Phone</label><input type="tel" style={inp} value={lead.phone || ""} onChange={e => upd("phone", e.target.value)} /></div>
          </div>
          {/* Co-borrowers */}
          {(() => {
            const coborrowers = parse(lead.coborrowers, []);
            return (
              <div>
                {coborrowers.map((cb, idx) => (
                  <div key={cb.id} style={{ marginBottom: 12, padding: "12px 14px", background: "#f8fafc", borderRadius: 8, border: "1px solid #e5e7eb" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                      <div style={{ fontSize: 12, fontWeight: 800, color: "#c9a84c", textTransform: "uppercase", letterSpacing: "0.06em" }}>Co-Borrower {idx + 1}</div>
                      <button onClick={() => upd("coborrowers", JSON.stringify(coborrowers.filter(x => x.id !== cb.id)))} style={{ background: "none", border: "none", color: "#dc2626", cursor: "pointer", fontSize: 18 }}>×</button>
                    </div>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                      <div><label style={lbl}>First Name</label><input style={inp} value={cb.first || ""} onChange={e => { const u = coborrowers.map(x => x.id === cb.id ? { ...x, first: e.target.value } : x); upd("coborrowers", JSON.stringify(u)); }} /></div>
                      <div><label style={lbl}>Last Name</label><input style={inp} value={cb.last || ""} onChange={e => { const u = coborrowers.map(x => x.id === cb.id ? { ...x, last: e.target.value } : x); upd("coborrowers", JSON.stringify(u)); }} /></div>
                      <div><label style={lbl}>Email</label><input type="email" style={inp} value={cb.email || ""} onChange={e => { const u = coborrowers.map(x => x.id === cb.id ? { ...x, email: e.target.value } : x); upd("coborrowers", JSON.stringify(u)); }} /></div>
                      <div><label style={lbl}>Phone</label><input type="tel" style={inp} value={cb.phone || ""} onChange={e => { const u = coborrowers.map(x => x.id === cb.id ? { ...x, phone: e.target.value } : x); upd("coborrowers", JSON.stringify(u)); }} /></div>
                    </div>
                  </div>
                ))}
                {coborrowers.length < 3 && (
                  <button onClick={() => upd("coborrowers", JSON.stringify([...coborrowers, { id: Date.now() + Math.random(), first: "", last: "", email: "", phone: "" }]))} style={{ background: "#f0f9ff", color: "#1e40af", border: "1.5px solid #93c5fd", borderRadius: 7, padding: "6px 14px", fontSize: 13, cursor: "pointer", fontWeight: 600 }}>+ Add Co-Borrower</button>
                )}
              </div>
            );
          })()}
        </Section>

        {/* Loan Details */}
        <Section title="LOAN DETAILS" accent="#374151">
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
            <div>
              <label style={lbl}>Loan Type</label>
              <select style={inp} value={lead.loan_type || ""} onChange={e => upd("loan_type", e.target.value)}>
                <option value="">Select...</option>
                {LOAN_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>
            <div>
              <label style={lbl}>Purchase or Refinance</label>
              <select style={inp} value={lead.purchase_or_refi || "Purchase"} onChange={e => upd("purchase_or_refi", e.target.value)}>
                <option value="Purchase">Purchase</option>
                <option value="Refinance">Refinance</option>
              </select>
            </div>
            <div><label style={lbl}>Estimated Loan Amount</label><input type="number" style={inp} value={lead.estimated_amount || ""} onChange={e => upd("estimated_amount", e.target.value)} placeholder="$" /></div>
            <div>
              <label style={lbl}>Lead Source</label>
              <select style={inp} value={lead.lead_source || ""} onChange={e => upd("lead_source", e.target.value)}>
                <option value="">Select...</option>
                {LEAD_SOURCES.map(s => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
          </div>
        </Section>

        {/* Notes */}
        <Section title="INITIAL NEEDS LIST" accent="#1e3a5f">
          <p style={{ fontSize: 12, color: "#6b7280", marginBottom: 14, marginTop: 0 }}>Check items to include in the Initial Request email. Use status buttons to track progress.</p>
          {INITIAL_NEEDS.map(section => (
            <div key={section.header} style={{ marginBottom: 18 }}>
              <div style={{ fontSize: 11, fontWeight: 800, color: "#c9a84c", letterSpacing: "0.08em", marginBottom: 8, textTransform: "uppercase" }}>{section.header}</div>
              {section.items.map(item => (
                <NeedsItemRow key={item} item={item} statusObj={leadNeedsStatus[item] || { status: "N/A", checked: false, note: "" }} onUpdate={val => updateLeadNeedsItem(item, val)} />
              ))}
            </div>
          ))}
        </Section>

        <Section title="NOTES" accent="#1e3a5f">
          <textarea value={lead.notes || ""} onChange={e => upd("notes", e.target.value)} placeholder="Notes about this lead..." style={{ ...inp, height: 120, resize: "vertical" }} />
        </Section>

        {/* Tasks */}
        <Section title="CONVERSATION LOG" accent="#0f2644" defaultOpen={false}>
          <ConversationLog
            entries={parse(lead.conversation_log, [])}
            onChange={entries => upd("conversation_log", JSON.stringify(entries))}
          />
        </Section>

        <Section title="EMAIL LOG" accent="#374151" defaultOpen={false}>
          {(() => {
            const emailLog = parse(lead.email_log, []);
            return emailLog.length === 0 ? (
              <p style={{ fontSize: 13, color: "#9ca3af", margin: 0 }}>No emails logged yet.</p>
            ) : (
              <div>
                {[...emailLog].reverse().map((entry, idx) => (
                  <div key={idx} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderBottom: "1px solid #f1f5f9" }}>
                    <span style={{ fontSize: 13, color: "#374151" }}>📧 {entry.type}</span>
                    <span style={{ fontSize: 12, color: "#6b7280" }}>{entry.date}</span>
                  </div>
                ))}
              </div>
            );
          })()}
        </Section>

        <Section title="LEAD TASKS" accent="#374151">
          {leadTasks.filter(t => !t.completed).length === 0 ? (
            <p style={{ fontSize: 13, color: "#9ca3af", margin: "0 0 10px" }}>No open tasks for this lead.</p>
          ) : (
            leadTasks.filter(t => !t.completed).map(task => (
              <TaskBadge key={task.id} task={task} onComplete={handleCompleteTask} onPush={onPushTask} />
            ))
          )}
          {leadTasks.filter(t => t.completed).length > 0 && (
            <details style={{ marginTop: 8 }}>
              <summary style={{ cursor: "pointer", fontSize: 12, color: "#6b7280" }}>Show completed ({leadTasks.filter(t => t.completed).length})</summary>
              {leadTasks.filter(t => t.completed).map(task => <TaskBadge key={task.id} task={task} onComplete={handleCompleteTask} onPush={onPushTask} />)}
            </details>
          )}
          <button onClick={() => setShowAddTask(true)} style={{ marginTop: 8, background: "#f0f9ff", color: "#1e40af", border: "1.5px solid #93c5fd", borderRadius: 7, padding: "6px 14px", fontSize: 13, cursor: "pointer", fontWeight: 600 }}>+ Add Task</button>
        </Section>

      </div>

      {/* Follow up interval prompt */}
      {followUpPrompt && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }}>
          <div style={{ background: "#fff", borderRadius: 14, padding: "32px", width: 380, boxShadow: "0 20px 60px rgba(0,0,0,0.2)", textAlign: "center" }}>
            <div style={{ fontSize: 24, marginBottom: 8 }}>✅</div>
            <h3 style={{ margin: "0 0 8px", color: "#0f2644", fontSize: 17, fontWeight: 800 }}>Great work!</h3>
            <p style={{ fontSize: 14, color: "#6b7280", margin: "0 0 20px" }}>When should we follow up with {lead.first_name} next?</p>
            <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
              {[[30, "#1e3a5f", "#fff"], [60, "#374151", "#fff"], [null, "#f1f5f9", "#374151"]].map(([days, bg, color]) => (
                <button key={days} onClick={() => handleFollowUpChoice(followUpPrompt.taskId, days)} style={{ padding: "10px 20px", borderRadius: 8, border: "none", background: bg, color, fontWeight: 700, fontSize: 14, cursor: "pointer" }}>
                  {days ? `${days} Days` : "No Follow Up"}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      {showAddTask && (
        <AddTaskModal loans={[]} leads={[lead]} onSave={task => { onAddTask({ ...task, lead_id: lead.id, lead_name: `${lead.last_name}, ${lead.first_name}` }); setShowAddTask(false); }} onCancel={() => setShowAddTask(false)} defaultLeadId={lead.id} />
      )}
      {applyLinkSnoozePrompt && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }}>
          <div style={{ background: "#fff", borderRadius: 14, padding: "32px", width: 420, boxShadow: "0 20px 60px rgba(0,0,0,0.2)", textAlign: "center" }}>
            <div style={{ fontSize: 24, marginBottom: 8 }}>📱</div>
            <h3 style={{ margin: "0 0 6px", color: "#0f2644", fontSize: 16, fontWeight: 800 }}>Application Follow Up</h3>
            <p style={{ fontSize: 13, color: "#6b7280", margin: "0 0 20px" }}>Has {lead.first_name} submitted their application yet? When should we check back?</p>
            <div style={{ display: "flex", gap: 8, justifyContent: "center", flexWrap: "wrap" }}>
              {[[1,"24 Hours","#1e3a5f","#fff"],[2,"48 Hours","#374151","#fff"],[7,"1 Week","#4b5563","#fff"],[null,"Done — Application Received","#f1f5f9","#374151"]].map(([days,label,bg,color]) => (
                <button key={label} onClick={() => handleApplyLinkSnoozeChoice(applyLinkSnoozePrompt.taskId, days)} style={{ padding: "8px 14px", borderRadius: 8, border: "none", background: bg, color, fontWeight: 700, fontSize: 13, cursor: "pointer" }}>{label}</button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── RELATIONSHIPS CONSTANTS ───────────────────────────────────────────────
const RELATIONSHIP_TYPES = ["Referral Partner", "Acquaintance", "Family", "Friend"];
const RELATIONSHIP_STATUSES = ["New", "Contacted", "Active", "Inactive"];

const REL_TYPE_COLORS = {
  "Referral Partner": { bg: "#dbeafe", text: "#1e40af", border: "#93c5fd" },
  "Acquaintance":     { bg: "#f3e8ff", text: "#5b21b6", border: "#c4b5fd" },
  "Family":           { bg: "#fce7f3", text: "#831843", border: "#f9a8d4" },
  "Friend":           { bg: "#d1fae5", text: "#065f46", border: "#6ee7b7" },
};

const REL_STATUS_COLORS = {
  "New":       { bg: "#f1f5f9", text: "#475569", border: "#cbd5e1" },
  "Contacted": { bg: "#dbeafe", text: "#1e40af", border: "#93c5fd" },
  "Active":    { bg: "#d1fae5", text: "#065f46", border: "#6ee7b7" },
  "Inactive":  { bg: "#fee2e2", text: "#991b1b", border: "#fca5a5" },
};

// Get next weekday (skip to Friday if weekend)
function nextWeekday(dateStr) {
  const d = new Date(dateStr + "T12:00:00");
  const day = d.getDay();
  if (day === 0) d.setDate(d.getDate() - 2); // Sunday -> Friday
  if (day === 6) d.setDate(d.getDate() - 1); // Saturday -> Friday
  return d.toISOString().split("T")[0];
}

function getBirthdayThisYear(dobStr) {
  if (!dobStr) return null;
  const dob = new Date(dobStr + "T12:00:00");
  const now = new Date();
  const thisYear = now.getFullYear();
  const bday = new Date(thisYear, dob.getMonth(), dob.getDate());
  if (bday < now) bday.setFullYear(thisYear + 1);
  return bday.toISOString().split("T")[0];
}

// ── RELATIONSHIPS DASHBOARD ───────────────────────────────────────────────
function RelationshipsDashboard({ relationships, tasks, onOpen, onNew }) {
  const [typeFilter, setTypeFilter] = useState("all");
  const [search, setSearch] = useState("");
  const [sortBy, setSortBy] = useState("name");

  const active = relationships.filter(r => r.status !== "Inactive");
  const filtered = active.filter(r => {
    const name = `${r.last_name} ${r.first_name}`.toLowerCase();
    const matchSearch = name.includes(search.toLowerCase());
    const matchType = typeFilter === "all" || r.contact_type === typeFilter;
    return matchSearch && matchType;
  }).sort((a, b) => {
    if (sortBy === "name") return (a.last_name || "").toLowerCase() < (b.last_name || "").toLowerCase() ? -1 : 1;
    if (sortBy === "type") return (a.contact_type || "").toLowerCase() < (b.contact_type || "").toLowerCase() ? -1 : 1;
    if (sortBy === "date") return (b.created_at || "") < (a.created_at || "") ? -1 : 1;
    return 0;
  });

  const typeCounts = {};
  RELATIONSHIP_TYPES.forEach(t => { typeCounts[t] = active.filter(r => r.contact_type === t).length; });

  return (
    <div style={{ minHeight: "100vh", background: "#f8fafc" }}>
      <div style={{ background: "linear-gradient(90deg, #0f2644 0%, #1e3a5f 100%)", padding: "20px 32px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div>
          <h1 style={{ color: "#fff", margin: 0, fontSize: 22, fontWeight: 800 }}>🤝 Relationships</h1>
          <p style={{ color: "#c9a84c", margin: 0, fontSize: 13, fontWeight: 600 }}>{active.length} active contacts</p>
        </div>
        <button onClick={onNew} style={{ background: "#c9a84c", color: "#0f2644", border: "none", borderRadius: 8, padding: "10px 22px", fontWeight: 800, fontSize: 14, cursor: "pointer" }}>+ New Contact</button>
      </div>

      {/* Type filter bar */}
      <div style={{ background: "#fff", borderBottom: "1.5px solid #e5e7eb", padding: "12px 32px", display: "flex", gap: 8, flexWrap: "wrap" }}>
        <button onClick={() => setTypeFilter("all")} style={{ padding: "4px 14px", borderRadius: 20, fontSize: 12, fontWeight: 700, cursor: "pointer", border: `1.5px solid ${typeFilter === "all" ? "#1e3a5f" : "#e5e7eb"}`, background: typeFilter === "all" ? "#1e3a5f" : "#f8fafc", color: typeFilter === "all" ? "#fff" : "#6b7280" }}>
          All ({active.length})
        </button>
        {RELATIONSHIP_TYPES.map(t => {
          const c = REL_TYPE_COLORS[t] || {};
          const active2 = typeFilter === t;
          return (
            <button key={t} onClick={() => setTypeFilter(typeFilter === t ? "all" : t)} style={{ padding: "4px 12px", borderRadius: 20, fontSize: 12, fontWeight: 700, cursor: "pointer", border: `1.5px solid ${active2 ? c.border : "#e5e7eb"}`, background: active2 ? c.bg : "#f8fafc", color: active2 ? c.text : "#6b7280" }}>
              {t} ({typeCounts[t] || 0})
            </button>
          );
        })}
      </div>

      <div style={{ padding: "24px 32px" }}>
        <div style={{ display: "flex", gap: 12, marginBottom: 20, flexWrap: "wrap", alignItems: "center" }}>
          <input placeholder="Search by name..." value={search} onChange={e => setSearch(e.target.value)} style={{ padding: "8px 14px", borderRadius: 8, border: "1.5px solid #d1d5db", fontSize: 14, width: 240, outline: "none" }} />
          <select value={sortBy} onChange={e => setSortBy(e.target.value)} style={{ padding: "8px 14px", borderRadius: 8, border: "1.5px solid #d1d5db", fontSize: 13, outline: "none", cursor: "pointer" }}>
            <option value="name">Sort: Last Name A-Z</option>
            <option value="type">Sort: Contact Type</option>
            <option value="date">Sort: Newest First</option>
          </select>
        </div>

        {filtered.length === 0 ? (
          <div style={{ textAlign: "center", padding: "60px", color: "#9ca3af", fontSize: 15 }}>No contacts found. Click "+ New Contact" to get started.</div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {filtered.map(r => {
              const tc = REL_TYPE_COLORS[r.contact_type] || {};
              const sc = REL_STATUS_COLORS[r.status] || {};
              const relTasks = tasks.filter(t => !t.completed && t.relationship_id === r.id);
              const overdue = relTasks.filter(t => t.due_date && daysDiff(t.due_date) < 0).length;
              return (
                <div key={r.id} onClick={() => onOpen(r.id)} style={{ background: "#fff", borderRadius: 10, border: "1.5px solid #e5e7eb", padding: "16px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", cursor: "pointer" }}>
                  <div>
                    <div style={{ fontWeight: 800, fontSize: 16, color: "#0f2644" }}>{r.last_name}, {r.first_name}{r.company ? ` — ${r.company}` : ""}</div>
                    <div style={{ fontSize: 13, color: "#6b7280", marginTop: 2 }}>
                      {r.phone && <span>{r.phone}</span>}
                      {r.phone && r.email && <span> · </span>}
                      {r.email && <span>{r.email}</span>}
                      {r.last_contacted && <span style={{ marginLeft: 8, fontSize: 11, color: "#9ca3af" }}>Last contact: {r.last_contacted}</span>}
                    </div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    {overdue > 0 && <span style={{ background: "#fee2e2", color: "#991b1b", borderRadius: 6, padding: "3px 8px", fontSize: 11, fontWeight: 700 }}>⚠ {overdue} overdue</span>}
                    <span style={{ background: tc.bg, color: tc.text, border: `1.5px solid ${tc.border}`, borderRadius: 6, padding: "3px 10px", fontSize: 11, fontWeight: 700 }}>{r.contact_type}</span>
                    <span style={{ background: sc.bg, color: sc.text, border: `1.5px solid ${sc.border}`, borderRadius: 6, padding: "3px 10px", fontSize: 11, fontWeight: 700 }}>{r.status}</span>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* Inactive contacts */}
        {relationships.filter(r => r.status === "Inactive").length > 0 && (
          <details style={{ marginTop: 24 }}>
            <summary style={{ cursor: "pointer", fontSize: 13, fontWeight: 700, color: "#6b7280", marginBottom: 10 }}>
              Inactive Contacts ({relationships.filter(r => r.status === "Inactive").length})
            </summary>
            {relationships.filter(r => r.status === "Inactive").map(r => (
              <div key={r.id} onClick={() => onOpen(r.id)} style={{ background: "#fff", borderRadius: 10, border: "1.5px solid #e5e7eb", padding: "14px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8, cursor: "pointer", opacity: 0.7 }}>
                <div style={{ fontWeight: 700, fontSize: 15, color: "#374151" }}>{r.last_name}, {r.first_name}{r.company ? ` — ${r.company}` : ""}</div>
                <span style={{ background: REL_TYPE_COLORS[r.contact_type]?.bg || "#f1f5f9", color: REL_TYPE_COLORS[r.contact_type]?.text || "#475569", borderRadius: 6, padding: "3px 10px", fontSize: 11, fontWeight: 700 }}>{r.contact_type}</span>
              </div>
            ))}
          </details>
        )}
      </div>
    </div>
  );
}

// ── NEW RELATIONSHIP MODAL ────────────────────────────────────────────────
function NewRelationshipModal({ onSave, onCancel }) {
  const [form, setForm] = useState({ first_name: "", last_name: "", email: "", phone: "", company: "", position: "", contact_type: "Referral Partner", status: "New", where_know_from: "", date_of_birth: "", family_names: "", likes_dislikes: "", common_ground: "", personality_type: "", preferred_contact: "Call", notes: "", referral_history: "[]", contacted_dates: "[]", last_contacted: "" });
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const inp = { width: "100%", padding: "8px 12px", borderRadius: 7, border: "1.5px solid #d1d5db", fontSize: 14, outline: "none", boxSizing: "border-box" };
  const lbl = { fontSize: 12, fontWeight: 700, color: "#374151", marginBottom: 4, display: "block" };
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }}>
      <div style={{ background: "#fff", borderRadius: 14, padding: "36px 32px", width: 520, boxShadow: "0 20px 60px rgba(0,0,0,0.2)", maxHeight: "90vh", overflowY: "auto" }}>
        <h2 style={{ margin: "0 0 20px", color: "#0f2644", fontSize: 18, fontWeight: 800 }}>New Contact</h2>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 14 }}>
          <div><label style={lbl}>First Name</label><input style={inp} value={form.first_name} onChange={e => set("first_name", e.target.value)} /></div>
          <div><label style={lbl}>Last Name *</label><input style={inp} value={form.last_name} onChange={e => set("last_name", e.target.value)} /></div>
          <div><label style={lbl}>Email</label><input type="email" style={inp} value={form.email} onChange={e => set("email", e.target.value)} /></div>
          <div><label style={lbl}>Phone</label><input type="tel" style={inp} value={form.phone} onChange={e => set("phone", e.target.value)} /></div>
          <div><label style={lbl}>Company</label><input style={inp} value={form.company} onChange={e => set("company", e.target.value)} /></div>
          <div><label style={lbl}>Position</label><input style={inp} value={form.position} onChange={e => set("position", e.target.value)} /></div>
          <div>
            <label style={lbl}>Contact Type</label>
            <select style={inp} value={form.contact_type} onChange={e => set("contact_type", e.target.value)}>
              {RELATIONSHIP_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
            </select>
          </div>
          <div>
            <label style={lbl}>Preferred Contact</label>
            <select style={inp} value={form.preferred_contact} onChange={e => set("preferred_contact", e.target.value)}>
              {["Call", "Text", "Email"].map(t => <option key={t} value={t}>{t}</option>)}
            </select>
          </div>
        </div>
        <div style={{ marginBottom: 20 }}><label style={lbl}>Where do you know them from?</label><input style={inp} value={form.where_know_from} onChange={e => set("where_know_from", e.target.value)} /></div>
        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          <button onClick={onCancel} style={{ padding: "9px 20px", borderRadius: 8, border: "1.5px solid #d1d5db", background: "#fff", cursor: "pointer" }}>Cancel</button>
          <button onClick={() => { if (!form.last_name.trim()) return alert("Last name is required."); onSave(form); }} style={{ padding: "9px 20px", borderRadius: 8, border: "none", background: "#1e3a5f", color: "#fff", fontWeight: 700, cursor: "pointer" }}>Create Contact</button>
        </div>
      </div>
    </div>
  );
}

// ── RELATIONSHIP FILE ─────────────────────────────────────────────────────
function RelationshipFile({ rel: initialRel, allTasks, onBack, onSave, onAddTask, onCompleteTask, onDeleteTask }) {
  const [rel, setRel] = useState(initialRel);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [showAddTask, setShowAddTask] = useState(false);
  const [followUpPrompt, setFollowUpPrompt] = useState(null);
  const [showAddReferral, setShowAddReferral] = useState(false);
  const [newReferral, setNewReferral] = useState({ date: todayStr(), client_name: "", converted: false, notes: "" });

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const relTasks = allTasks.filter(t => t.relationship_id === rel.id);
  const contactedDates = parse(rel.contacted_dates, []);
  const referralHistory = parse(rel.referral_history, []);

  function upd(k, v) { setRel(r => ({ ...r, [k]: v })); }

  async function handleSave(overrides = {}) {
    const toSave = { ...rel, ...overrides };
    setSaving(true);
    await onSave(toSave);
    setSaving(false); setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  }

  async function handleBack() {
    setSaving(true);
    await onSave(rel);
    setSaving(false);
    onBack();
  }

  async function handleStatusChange(newStatus) {
    const prevStatus = rel.status;
    upd("status", newStatus);
    if (newStatus === "Contacted" && prevStatus !== "Contacted") {
      const dueDate = addDays(todayStr(), 7);
      for (const assignee of ["alex", "madison"]) {
        await onAddTask({ title: `Follow up with ${rel.last_name}`, assigned_to: assignee, due_date: dueDate, relationship_id: rel.id, relationship_name: `${rel.last_name}, ${rel.first_name}`, notes: `Auto: 7-day follow up after Contacted status set.`, is_recurring: true });
      }
    }
  }

  async function logContactDate() {
    const today = todayStr();
    const newDates = [today, ...contactedDates].slice(0, 20);
    upd("contacted_dates", JSON.stringify(newDates));
    upd("last_contacted", today);
    await onSave({ ...rel, contacted_dates: JSON.stringify(newDates), last_contacted: today });
  }

  async function handleCompleteTask(taskId) {
    const task = allTasks.find(t => t.id === taskId);
    if (!task) return;
    if (task.is_recurring && !task.completed) {
      setFollowUpPrompt({ taskId });
      return;
    }
    await onCompleteTask(taskId);
  }

  async function handleFollowUpChoice(taskId, days) {
    setFollowUpPrompt(null);
    await onCompleteTask(taskId);
    if (days) {
      const dueDate = addDays(todayStr(), days);
      for (const assignee of ["alex", "madison"]) {
        await onAddTask({ title: `Follow up with ${rel.last_name}`, assigned_to: assignee, due_date: dueDate, relationship_id: rel.id, relationship_name: `${rel.last_name}, ${rel.first_name}`, notes: `Auto: Recurring ${days}-day follow up.`, is_recurring: true });
      }
    }
  }

  function addReferral() {
    const updated = [...referralHistory, { id: Date.now(), ...newReferral }];
    upd("referral_history", JSON.stringify(updated));
    setNewReferral({ date: todayStr(), client_name: "", converted: false, notes: "" });
    setShowAddReferral(false);
  }

  function removeReferral(id) {
    upd("referral_history", JSON.stringify(referralHistory.filter(r => r.id !== id)));
  }

  const tc = REL_TYPE_COLORS[rel.contact_type] || {};
  const sc = REL_STATUS_COLORS[rel.status] || {};
  const inp = { padding: "7px 12px", borderRadius: 7, border: "1.5px solid #d1d5db", fontSize: 14, outline: "none", width: "100%", boxSizing: "border-box" };
  const lbl = { fontSize: 12, fontWeight: 700, color: "#374151", display: "block", marginBottom: 4 };

  return (
    <div style={{ minHeight: "100vh", background: "#f8fafc" }}>
      <div style={{ background: "linear-gradient(90deg, #0f2644 0%, #1e3a5f 100%)", padding: "14px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 100 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <button onClick={handleBack} style={{ background: "rgba(255,255,255,0.15)", border: "none", color: "#fff", borderRadius: 7, padding: "6px 14px", cursor: "pointer", fontSize: 13 }}>{saving ? "Saving..." : "← Relationships"}</button>
          <div>
            <div style={{ color: "#fff", fontWeight: 800, fontSize: 16 }}>{rel.last_name}, {rel.first_name}{rel.company ? ` — ${rel.company}` : ""}</div>
            <div style={{ color: "#c9a84c", fontSize: 12 }}>{rel.contact_type}{rel.position ? ` · ${rel.position}` : ""}</div>
          </div>
        </div>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <span style={{ background: tc.bg, color: tc.text, border: `1.5px solid ${tc.border}`, borderRadius: 6, padding: "4px 10px", fontSize: 11, fontWeight: 700 }}>{rel.contact_type}</span>
          <span style={{ background: sc.bg, color: sc.text, border: `1.5px solid ${sc.border}`, borderRadius: 6, padding: "4px 10px", fontSize: 11, fontWeight: 700 }}>{rel.status}</span>
          <button onClick={() => handleSave()} style={{ background: saved ? "#d1fae5" : "#fff", color: saved ? "#065f46" : "#1e3a5f", border: `2px solid ${saved ? "#6ee7b7" : "#1e3a5f"}`, borderRadius: 7, padding: "7px 16px", fontWeight: 700, fontSize: 13, cursor: "pointer" }}>
            {saving ? "Saving..." : saved ? "✓ Saved" : "Save"}
          </button>
        </div>
      </div>

      <div style={{ maxWidth: 920, margin: "0 auto", padding: "24px 20px" }}>

        {/* Summary Card */}
        <div style={{ background: "linear-gradient(135deg, #0f2644, #1e3a5f)", borderRadius: 12, padding: "20px 24px", marginBottom: 20, color: "#fff" }}>
          <div style={{ fontSize: 20, fontWeight: 800, marginBottom: 4 }}>{rel.first_name} {rel.last_name}</div>
          {rel.company && <div style={{ color: "#c9a84c", fontSize: 14, fontWeight: 600, marginBottom: 8 }}>{rel.position ? `${rel.position} at ` : ""}{rel.company}</div>}
          <div style={{ display: "flex", gap: 20, flexWrap: "wrap", fontSize: 13 }}>
            {rel.phone && <span>📞 {rel.phone}</span>}
            {rel.email && <span>✉️ {rel.email}</span>}
            {rel.preferred_contact && <span>💬 Prefers {rel.preferred_contact}</span>}
            {rel.last_contacted && <span>🕐 Last contact: {rel.last_contacted}</span>}
          </div>
          {rel.notes && <div style={{ marginTop: 10, fontSize: 13, color: "rgba(255,255,255,0.8)", fontStyle: "italic" }}>"{rel.notes}"</div>}
        </div>

        {/* Status */}
        <Section title="STATUS" accent="#0f2644">
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 14 }}>
            {RELATIONSHIP_STATUSES.map(s => {
              const c = REL_STATUS_COLORS[s] || {};
              const active = rel.status === s;
              return <button key={s} onClick={() => handleStatusChange(s)} style={{ padding: "6px 18px", borderRadius: 20, fontSize: 13, fontWeight: active ? 800 : 500, cursor: "pointer", border: `1.5px solid ${active ? c.border : "#d1d5db"}`, background: active ? c.bg : "#fff", color: active ? c.text : "#6b7280" }}>{s}</button>;
            })}
          </div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 8 }}>
            {[
              { label: "📞 Call Logged", type: "Call Conversation" },
              { label: "📞 Voicemail", type: "Left Voicemail" },
              { label: "💬 Text Logged", type: "Text Conversation" },
              { label: "💬 Text Sent", type: "Text Sent" },
              { label: "✉️ Email Logged", type: "Email Conversation" },
              { label: "✉️ Email Sent", type: "Email Sent" },
            ].map(opt => (
              <button key={opt.type} onClick={() => {
                const note = opt.type.includes("Conversation") ? window.prompt(`Add notes for ${opt.type}:`, "") : null;
                const today2 = todayStr();
                const newDates = [today2, ...contactedDates].slice(0, 20);
                upd("contacted_dates", JSON.stringify(newDates));
                upd("last_contacted", today2);
                // Add to conversation log if notes provided
                if (note !== null && note.trim()) {
                  const convLog = parse(rel.conversation_log, []);
                  const now = new Date();
                  const ts = `${now.toLocaleDateString()} ${now.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}`;
                  upd("conversation_log", JSON.stringify([{ id: Date.now(), author: "Team", text: `[${opt.type}] ${note}`, timestamp: ts }, ...convLog]));
                } else if (note === null && !opt.type.includes("Conversation")) {
                  // Non-conversation types just log the date
                }
                onSave({ ...rel, contacted_dates: JSON.stringify([today2, ...contactedDates].slice(0, 20)), last_contacted: today2 });
              }} style={{ background: "#f8fafc", color: "#374151", border: "1.5px solid #e5e7eb", borderRadius: 7, padding: "5px 12px", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>{opt.label}</button>
            ))}
          </div>
          {contactedDates.length > 0 && (
            <div style={{ marginTop: 10 }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: "#6b7280", marginBottom: 4 }}>CONTACT HISTORY</div>
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                {contactedDates.map((d, i) => <span key={i} style={{ background: "#f1f5f9", borderRadius: 5, padding: "2px 8px", fontSize: 11, color: "#475569" }}>{d}</span>)}
              </div>
            </div>
          )}
        </Section>

        {/* Contact Info */}
        <Section title="CONTACT INFORMATION" accent="#1e3a5f">
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
            <div><label style={lbl}>First Name</label><input style={inp} value={rel.first_name || ""} onChange={e => upd("first_name", e.target.value)} /></div>
            <div><label style={lbl}>Last Name</label><input style={inp} value={rel.last_name || ""} onChange={e => upd("last_name", e.target.value)} /></div>
            <div><label style={lbl}>Email</label><input type="email" style={inp} value={rel.email || ""} onChange={e => upd("email", e.target.value)} /></div>
            <div><label style={lbl}>Phone</label><input type="tel" style={inp} value={rel.phone || ""} onChange={e => upd("phone", e.target.value)} /></div>
            <div><label style={lbl}>Company</label><input style={inp} value={rel.company || ""} onChange={e => upd("company", e.target.value)} /></div>
            <div><label style={lbl}>Position</label><input style={inp} value={rel.position || ""} onChange={e => upd("position", e.target.value)} /></div>
            <div>
              <label style={lbl}>Contact Type</label>
              <select style={inp} value={rel.contact_type || "Referral Partner"} onChange={e => upd("contact_type", e.target.value)}>
                {RELATIONSHIP_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>
            <div>
              <label style={lbl}>Preferred Contact Method</label>
              <select style={inp} value={rel.preferred_contact || "Call"} onChange={e => upd("preferred_contact", e.target.value)}>
                {["Call", "Text", "Email"].map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>
            <div><label style={lbl}>Date of Birth</label><input type="date" style={inp} value={rel.date_of_birth || ""} onChange={e => upd("date_of_birth", e.target.value)} /></div>
            <div><label style={lbl}>Where Do You Know Them From?</label><input style={inp} value={rel.where_know_from || ""} onChange={e => upd("where_know_from", e.target.value)} /></div>
          </div>
        </Section>

        {/* Relationship Intel */}
        <Section title="RELATIONSHIP INTEL" accent="#374151">
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <div><label style={lbl}>Family Names</label><input style={inp} value={rel.family_names || ""} onChange={e => upd("family_names", e.target.value)} placeholder="Spouse, kids, pets..." /></div>
            <div><label style={lbl}>Likes and Dislikes</label><textarea value={rel.likes_dislikes || ""} onChange={e => upd("likes_dislikes", e.target.value)} placeholder="Things they love or hate..." style={{ ...inp, height: 70, resize: "vertical" }} /></div>
            <div><label style={lbl}>Common Ground</label><textarea value={rel.common_ground || ""} onChange={e => upd("common_ground", e.target.value)} placeholder="Shared interests, experiences, topics to connect on..." style={{ ...inp, height: 70, resize: "vertical" }} /></div>
            <div><label style={lbl}>Personality Type</label><input style={inp} value={rel.personality_type || ""} onChange={e => upd("personality_type", e.target.value)} placeholder="How do they communicate, make decisions, respond to follow up..." /></div>
            <div><label style={lbl}>Notes</label><textarea value={rel.notes || ""} onChange={e => upd("notes", e.target.value)} placeholder="Anything else worth remembering..." style={{ ...inp, height: 80, resize: "vertical" }} /></div>
          </div>
        </Section>

        {/* Referral History */}
        <Section title="REFERRAL HISTORY" accent="#1e3a5f">
          {referralHistory.length === 0 ? (
            <p style={{ fontSize: 13, color: "#9ca3af", margin: "0 0 10px" }}>No referrals logged yet.</p>
          ) : (
            <div style={{ marginBottom: 12 }}>
              {referralHistory.map(ref => (
                <div key={ref.id} style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 12px", background: "#f8fafc", borderRadius: 8, border: "1px solid #e5e7eb", marginBottom: 6 }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 13, fontWeight: 700, color: "#0f2644" }}>{ref.client_name}</div>
                    <div style={{ fontSize: 11, color: "#6b7280" }}>{ref.date}{ref.notes ? ` · ${ref.notes}` : ""}</div>
                  </div>
                  <span style={{ background: ref.converted ? "#d1fae5" : "#fef3c7", color: ref.converted ? "#065f46" : "#92400e", borderRadius: 5, padding: "2px 8px", fontSize: 11, fontWeight: 700 }}>{ref.converted ? "Converted" : "Pending"}</span>
                  <button onClick={() => removeReferral(ref.id)} style={{ background: "none", border: "none", color: "#dc2626", cursor: "pointer", fontSize: 18 }}>×</button>
                </div>
              ))}
            </div>
          )}
          {showAddReferral ? (
            <div style={{ background: "#f8fafc", borderRadius: 8, padding: "12px", border: "1.5px solid #93c5fd" }}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 10 }}>
                <div><label style={lbl}>Client Name</label><input style={inp} value={newReferral.client_name} onChange={e => setNewReferral(r => ({ ...r, client_name: e.target.value }))} /></div>
                <div><label style={lbl}>Date</label><input type="date" style={inp} value={newReferral.date} onChange={e => setNewReferral(r => ({ ...r, date: e.target.value }))} /></div>
                <div><label style={lbl}>Notes</label><input style={inp} value={newReferral.notes} onChange={e => setNewReferral(r => ({ ...r, notes: e.target.value }))} placeholder="Optional..." /></div>
                <div style={{ display: "flex", alignItems: "flex-end", gap: 8 }}>
                  <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
                    <input type="checkbox" checked={newReferral.converted} onChange={e => setNewReferral(r => ({ ...r, converted: e.target.checked }))} style={{ width: 16, height: 16, accentColor: "#1e3a5f" }} />
                    Converted to Loan
                  </label>
                </div>
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                <button onClick={addReferral} style={{ background: "#1e3a5f", color: "#fff", border: "none", borderRadius: 7, padding: "6px 16px", fontSize: 13, cursor: "pointer", fontWeight: 700 }}>Add</button>
                <button onClick={() => setShowAddReferral(false)} style={{ background: "#fff", border: "1.5px solid #d1d5db", borderRadius: 7, padding: "6px 14px", fontSize: 13, cursor: "pointer" }}>Cancel</button>
              </div>
            </div>
          ) : (
            <button onClick={() => setShowAddReferral(true)} style={{ background: "#f0f9ff", color: "#1e40af", border: "1.5px solid #93c5fd", borderRadius: 7, padding: "6px 14px", fontSize: 13, cursor: "pointer", fontWeight: 600 }}>+ Log Referral</button>
          )}
        </Section>

        {/* Tasks */}
        <Section title="CONVERSATION LOG" accent="#0f2644" defaultOpen={false}>
          <ConversationLog
            entries={parse(rel.conversation_log, [])}
            onChange={entries => upd("conversation_log", JSON.stringify(entries))}
          />
        </Section>

        <Section title="TASKS" accent="#374151">
          {relTasks.filter(t => !t.completed).length === 0 ? (
            <p style={{ fontSize: 13, color: "#9ca3af", margin: "0 0 10px" }}>No open tasks.</p>
          ) : (
            relTasks.filter(t => !t.completed).map(task => <TaskBadge key={task.id} task={task} onComplete={handleCompleteTask} />)
          )}
          {relTasks.filter(t => t.completed).length > 0 && (
            <details style={{ marginTop: 8 }}>
              <summary style={{ cursor: "pointer", fontSize: 12, color: "#6b7280" }}>Show completed ({relTasks.filter(t => t.completed).length})</summary>
              {relTasks.filter(t => t.completed).map(task => <TaskBadge key={task.id} task={task} onComplete={handleCompleteTask} />)}
            </details>
          )}
          <button onClick={() => setShowAddTask(true)} style={{ marginTop: 8, background: "#f0f9ff", color: "#1e40af", border: "1.5px solid #93c5fd", borderRadius: 7, padding: "6px 14px", fontSize: 13, cursor: "pointer", fontWeight: 600 }}>+ Add Task</button>
        </Section>

      </div>

      {/* Follow up interval prompt */}
      {followUpPrompt && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }}>
          <div style={{ background: "#fff", borderRadius: 14, padding: "32px", width: 400, boxShadow: "0 20px 60px rgba(0,0,0,0.2)", textAlign: "center" }}>
            <div style={{ fontSize: 24, marginBottom: 8 }}>✅</div>
            <h3 style={{ margin: "0 0 8px", color: "#0f2644", fontSize: 17, fontWeight: 800 }}>Great work!</h3>
            <p style={{ fontSize: 14, color: "#6b7280", margin: "0 0 20px" }}>When should we follow up with {rel.first_name} next?</p>
            <div style={{ display: "flex", gap: 8, justifyContent: "center", flexWrap: "wrap" }}>
              {[[30, "#1e3a5f", "#fff"], [60, "#374151", "#fff"], [90, "#4b5563", "#fff"], [null, "#f1f5f9", "#374151"]].map(([days, bg, color]) => (
                <button key={days} onClick={() => handleFollowUpChoice(followUpPrompt.taskId, days)} style={{ padding: "10px 18px", borderRadius: 8, border: "none", background: bg, color, fontWeight: 700, fontSize: 14, cursor: "pointer" }}>
                  {days ? `${days} Days` : "No Follow Up"}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      {showAddTask && (
        <AddTaskModal loans={[]} leads={[]} onSave={task => { onAddTask({ ...task, relationship_id: rel.id, relationship_name: `${rel.last_name}, ${rel.first_name}` }); setShowAddTask(false); }} onCancel={() => setShowAddTask(false)} />
      )}
    </div>
  );
}


